const messagesRU = {
    code: "ru",
    messages: {
        zoho: {
            SETTING_GROUP: "Настройки",
            usermapping: "Сопоставление пользователей",
        },
        chatWindow: {
            thereIsNoChatContent: "Нет содержимого чата.",
            thereIsNoChatContentDsc: "Здесь вы можете просматривать содержимое чата и отправлять сообщения.",
            interactions: "Взаимодействия:",
            departments: "Отделы",
            channels: "Каналы",
            date: "Дата",
            lastChatStatus: "Последний статус чата",
            all: "Все",
            queued: "В очереди",
            open: "Открыто",
            closed: "Закрыто",
            private: "Частное",
            chatbot: "Чат-бот",
            lostMissed: "Потерянные / Пропущенные",
            interaction: "Взаимодействие",
            myActiveInbox: "Мой активный почтовый ящик",
            activeQueueInbox: "Активный + Очередь почтовый ящик",
            chatbotActiveInbox: "Активный почтовый ящик чат-бота",
            myDepartmentsActiveInbox: "Активный почтовый ящик моих отделов",
            notInteractedYesterday: "Вчера не было взаимодействий",
            queueInbox: "Очередь почтового ящика",
            whatsappActiveInbox: "Активный почтовый ящик WhatsApp",
            socialMediaActiveInbox: "Активный почтовый ящик соцсетей",
            missedThisMonth: "Пропущенные чаты в этом месяце",
            chooseAFileOrDragItHere: "Выберите файл или перетащите его сюда!",
            watching: "Наблюдаю",
            selectFilter: "Выбрать фильтр",
            clearAll: "Очистить все",
            me: "Я",
            today: "Сегодня",
            yesterday: "Вчера",
            thisWeek: "Эта неделя",
            lastWeek: "Прошлая неделя",
            last7Days: "Последние 7 дней",
            last30Days: "Последние 30 дней",
            thisMonth: "Этот месяц",
            lastMonth: "Прошлый месяц",
            last24h: "Последние 24 часа",
            custom: "Настроить",
            startMessage: "Начать сообщение",
            goToAgentReport: "Перейти к отчету агента",
            agentDetail: "Детали агента",
            agentList: "Список агентов",
            selectedFilter: "Выбранный фильтр",
            groupBy: "Группировать",
            none: "Нет группы",
            agent: "Представитель",
            department: "Отдел",
            sortBy: "Сортировать",
            lastPostAbove: "Последнее сообщение сверху",
            newChatsAbove: "Новые чаты сверху",
            oldChatsAbove: "Старые чаты сверху",
            live: "Жить",
            systemStatus: "Состояние системы",
            refresh: "Обновить",
            close: "Закрыть",
            totalCustomers: "Общее количество клиентов",
            totalAnswered: "Всего отвечено",
            waitingAnswer: "Ожидание ответа",
            totalAgentInChat: "Всего агентов в чате",
            onlineAgentCount: "Количество онлайн агентов",
            totalCustomer: "Всего клиентов",
            answered: "Отвечено",
            unanswered: "Без ответа",
            noContactWasFoundMatchingTheCurrentFilters: "Не найдено контактов, соответствующих текущим фильтрам.",
            you: "Ты",
            others: "Другие",
            queue: "Очередь",
            chatbotContact: "Чатбот",
            closedContact: "Закрыто",
            myInteractions: "Мои взаимодействия",
            special: "Особенный",
            allInteractions: "Все контакты",
            waiting: "Ожидающие",
            tag: "Тег",
            website: "Веб-сайт",
            channel: "Канал",
            platform: "Платформа",
            answerStatus: "Статус ответа",
            departmentToWhichItIsAffiliated: "Прикрепленный отдел",
        },
        form: {
            title: {
                titleSettings: "Настройки заголовка",
                fullNameSettings: "Настройки полного имени",
                emailSettings: "Настройки электронной почты",
                addressSettings: "Настройки адреса",
                phoneSettings: "Настройки телефона",
                datePickerSettings: "Настройки выбора даты",
                shortTextSettings: "Настройки короткого текста",
                longTextSettings: "Настройки длинного текста",
                dropDownListSettings: "Настройки выпадающего списка",
                singleChoiceSettings: "Настройки одиночного выбора",
                multipleSelectionSettings: "Настройки множественного выбора",
                numberSettings: "Настройки чисел",
                hourSettings: "Настройки часов",
                spinnerSettings: "Настройки спиннера",
                sendSettings: "Настройки отправки",
                starRatingSettings: "Настройки звездного рейтинга",
                ratingScaleSettings: "Настройки шкалы оценок",
                separationElementSettings: "Настройки элемента разделения",
                fileUploadSettings: "Настройки загрузки файлов",
                imageSettings: "Настройки изображения"
            },
            lineColor: "Цвет линии",
            separatorColorInfo: "Выберите или введите цвет разделителя (например, #RRGGBB)",
            separatorHeight: "Высота разделителя",
            separatorHeightInfo: "Введите высоту разделителя",
            bottomSpace: "Нижний отступ",
            bottomSpaceInfo: "Добавьте пространство под разделителем",
            topSpace: "Верхний отступ",
            topSpaceInfo: "Добавьте пространство над разделителем",
            sideSpace: "Боковой отступ",
            sideSpaceInfo: "Добавьте пространство слева и справа от разделителя",
            onlyImageUpload: "Можно загрузить только изображение!",
            imageSizeLimit: "Размер вашего изображения должен быть не более 5 МБ!",
            image: "Изображение",
            size: "Размер",
            width: "Ширина",
            height: "Высота",
            imageAlignment: "Выравнивание изображения",
            wide: "Широкий",
            small: "Маленький",
            textAlignment: "Выравнивание текста",
            chooseHorizontalAlignment: "Выберите, как выровнять этот заголовок по горизонтали.",
            headerSize: "Размер заголовка",
            addSmallTextBelowHeader: "Добавьте меньший текст под заголовком",
            subHeaderText: "Текст подзаголовка",
            subLabel1: "Подметка(1)",
            subLabel2: "Подметка(2)",
            validPhoneNumber: "Пожалуйста, введите действительный номер телефона",
            masked: "Замаскированный",
            copyField: "Скопировать поле",
            copyFieldDescription: "Создайте копию этого поля, сохраняя все его сохраненные настройки",
            enterQuestion: "Введите вопрос",
            notRequired: "Не требуется",
            addDescriptionBelowField: "Добавьте короткое описание под полем",
            setDefault: "Установить как по умолчанию",
            pleaseSelect: "Пожалуйста, выберите",
            placeholder: "Место для текста",
            required: "Обязательно",
            fieldEmptyError: "Не разрешать отправку формы, если это поле пусто",
            subLabels: "Подподписи",
            addressLine1: "Адрес, строка 1",
            addressLine2: "Адрес, строка 2",
            postalCode: "Почтовый индекс",
            stateProvince: "Регион / Штат",
            chooseLabelAlignment: "Выберите, как выровнять текст метки по горизонтали",
            right: "ПРАВО",
            left: "ЛЕВО",
            top: "ВЕРХ",
            labelAlignment: "Выравнивание метки",
            fieldLabel: "Метка поля",
            read: "Прочитано",
            itemsPerPage: "элементов/страница",
            downloadAllDataAsPDF: "Скачать все данные в формате PDF",
            downloadAllDataAsExcel: "Скачать все данные в формате Excel",
            downloadSelectedDataAsPDF: "Скачать выбранные данные в формате PDF",
            downloadSelectedDataAsExcel: "Скачать выбранные данные в формате Excel",
            selectItemToViewDetails: "Выберите элемент, чтобы увидеть детали.",
            deleteFormConfirm:
                "При удалении этой формы все связанные с ней данные будут удалены безвозвратно. Вы уверены, что хотите продолжить?",
            redicetFormAnswer: "ПЕРЕДАТЬ ОТВЕТЫ ФОРМЫ",
            redicetFormAnswerDesc:
                "При перенаправлении ответов формы в тикет-систему обязательно запрашивайте у пользователя в форме номер телефона или адрес электронной почты. Эта информация важна для более быстрой и эффективной связи с пользователем.",
            redicetFormAnswerDesc2: "Ответы формы направляются в систему в виде тикетов",
            rediectAnswersToTicket: "Перенаправлять входящие ответы в тикет",
            errorTicketMode: "Ошибка обновления режима тикетов:",
            formView: "Посмотреть форму",
            formEdit: "Форма обновления",
            totalResponse: "Общий ответ",
            totalUnreadResponse: "Всего непрочитанных ответов",
            totalReadResponse: "Общий отклик на чтение",
            totalArchivedResponse: "Всего архивных ответов",
            singleChoice: "Единичный выбор",
            _delete: "Удалить",
            inbox: "Входящие",
            edit: "Редактировать",
            forms: "Формы",
            formsDesc: "Здесь вы можете управлять своими формами.",
            createaForm: "создать форму",
            allForms: "все формы",
            formPublish: {
                shareFast: "ДЕЛИТЕСЬ БЫСТРО",
                shareFastDesc: "Прямая ссылка на форму и социальный обмен",
                add: "ДОБАВИТЬ",
                addDesc: "Различные варианты встраивания веб-страниц",
                assignForm: "ВЫРОВНЯТЬ ФОРМУ",
                assignFormDesc: "Назначайте свои формы другим",
                emails: "ЭЛЕКТРОННАЯ ПОЧТА",
                emailsDesc: "Напоминания и мгновенный обмен информацией",
                prefill: "PREFILL",
                prefillDesc: "Предварительное заполнение форм",
                pdf: "PDF",
                pdfDesc: "Скачать заполняемый PDF",
                platforms: "ПЛАТФОРМЫ",
                platformsDesc: "Варианты публикации сторонних разработчиков",
                linkToYour: "АДРЕС ССЫЛКИ НА ВАШУ ФОРМУ",
                linkToYourDesc: "Ваша форма была надежно опубликована и готова к использованию по этому адресу.",
                shareWithLink: "ПОДЕЛИТЬСЯ ССЫЛКОЙ",
                publicForm: "Публичная форма",
                copyLink: "КОПИРОВАТЬ ССЫЛКУ",
                openInNewTab: "ОТКРЫТЬ В НОВОЙ ВКЛАДКЕ",
                linkCopied: "Ссылка скопирована",
                codeCopied: "Скопированный код",
                iframe: "IFRAME",
                iframeDesc: "Добавьте форму на страницу с помощью iFrame",
                openWindow: "ОТКРЫТОЕ ОКНО",
                openWindowDesc: "Ссылка на всплывающую форму",
                formAddDesc: "Скопируйте и вставьте этот сниппет в код и разместите форму на своем сайте.",
            },
            formSettings: {
                enterNameForm: "Введите имя для этой формы",
                selectStatusForm: "Выберите статус вашей формы",
                disabled: "Инвалиды",
                disableSpecifiedTime: "Отключение в указанное время",
                disableFormResponse: "Отключение при достижении лимита ответов формы",
                pageShownAfterForm: "Страница, отображаемая после отправки формы",
                formNotFound: "Форма не найдена.",
                errorLoadingform: "При загрузке формы произошла ошибка.",
                formUpdated: "Заголовок формы был успешно обновлен.",
                formErrorUpdated: "Произошла ошибка при обновлении заголовка формы",
                formSettings: "НАСТРОЙКИ ФОРМЫ",
                changeFormStateAndProperties: "Настройки формы",
                title: "Название",
                newFormSettings: "Настройки новой формы",
                formStatus: "Статус формы",
                activateOrDeactivate: "Активируйте, деактивируйте или условно активируйте вашу форму",
                effective: "ЭФФЕКТИВНО",
                yourFromIsVisible: "Теперь ваша форма видна и может принимать ответы.",
                emails: "ЭЛЕКТРОННАЯ ПОЧТА",
                emailsDesc: "Отправка писем автоответчика и писем с уведомлениями",
                conditions: "УСЛОВИЯ",
                conditionsDesc: "Секция условной логики, которая запускает действия на основе вводимых данных формы",
                thankYouPage: "СТРАНИЦА БЛАГОДАРНОСТЕЙ",
                thankYouPageDesc: "Страница, отображаемая после отправки формы",
                integretions: "ИНТЕГРАЦИИ",
                integretionsDesc: "Подключите вашу форму к другим приложениям",
            },
            clickToDeleteYourLogo: "Нажмите, чтобы удалить свой логотип",
            create: "Создать",
            settings: "Настройки",
            load: "Загрузить",
            insertFormField: "Вставка поля формы",
            addYourLogo: "Добавьте свой логотип",
            surveyElements: {
                surveyElements: "Элементы исследования",
                dataTable: "Таблица данных",
                starRating: "Звездный рейтинг",
                evaluationScale: "Шкала оценки",
            },
            pageElements: {
                pageElements: "Элементы страницы",
                separationElement: "Элемент разделения",
                partitionCollapse: "Распад раздела",
                pageBreak: "Конец страницы",
            },
            basicElements: {
                basicElements: "Основные элементы",
                shortText: "Короткий текст",
                longText: "Длинный текст",
                paragraph: "Параграф",
                dropDownList: "Выпадающий список",
                singleChoice: "Единственный выбор",
                multipleSelection: "Множественный выбор",
                number: "Номер",
                image: "Изображение",
                fileUpload: "Загрузка файлов",
                hour: "Час",
                spinner: "Спиннер",
                send: "Отправить",
            },
            formElements: {
                formElements: "Элементы формы",
                title: "Название",
                fullName: "Полное имя",
                email: "Электронная почта",
                address: "Адрес",
                phone: "Телефон",
                datePicker: "Подборщик даты",
                appointment: "Назначение",
                signature: "Подпись",
                productList: "список продуктов",
            },
            startWithaBlankForm: "Начните с пустого бланка",
            startFromScratch: "Начните с нуля",
            createOrTransferaForm: "Создайте или перенесите форму, чтобы начать сбор данных",
            createForm: "Создать форму",
        },
        automation: {
            calendarEventCreated: "Событие создано в календаре",
            calendarEventUpdated: "Событие обновлено в календаре",
            calendarEventDeleted: "Событие удалено из календаря",
            reservationCreated: "Резервирование создано",
            reservationDateChanged: "Дата резервирования изменена",
            reservationDeleted: "Резервирование удалено",
            chatLost: "Когда чат потерян",
            webchatCompleted: "Когда веб-чат завершен",
            instagramCompleted: "Когда чат из Instagram завершен",
            messengerCompleted: "Когда чат из Messenger завершен",
            whatsappCompleted: "Когда чат из WhatsApp завершен",
            telegramCompleted: "Когда чат из Telegram завершен",
            chatAssignedToAgent: "Когда чат назначен агенту",
            profileButtonClicked: "Когда кнопка автоматизации нажата в профиле",
            operatedTask: "Выполняемая задача",
            tableSelection: "Выбор таблицы",
            selectTable: "Выбор таблицы",
            whichTableAutomationAddRecords:
                "В какой таблице вы хотите запустить автоматизацию при добавлении записи? Пожалуйста, выберите.",
            whichTableAutomationUpdateRecords:
                "Вы хотите запустить автоматизацию при обновлении записи в какой таблице? Пожалуйста, выберите.",
            whichTableAutomationDeletedRecords:
                "Из какой таблицы вы хотите запустить автоматизацию при удалении записи? Пожалуйста, выберите.",
            whichTableAutomationClickRecords:
                "В какой таблице вы хотите запустить автоматизацию при нажатии кнопки автоматизации на записи? Пожалуйста, выберите.",
            planStatus: "Статус плана",
            scheduled: "Запланировано",
            completed: "Завершено",
            cancelled: "Отменено",
            startTest: "Начать тест",
            unpublish: "Отменить публикацию",
            whenMessagePicked: "Когда сообщение выбирается через интерфейс чата",
            whenTaskCompleted: "Когда задача завершена",
            whenTaskDeleted: "Когда задача удаляется",
            whenTaskAssigneeChanged: "При изменении назначенного задания",
            whenTaskPriorityChanged: "При изменении приоритета задачи",
            whenTaskDueDateChanged: "Когда изменяется дата выполнения задачи",
            whenTaskStatusChanged: "При изменении статуса задачи",
            whenTaskArchived: "Когда задача архивируется",
            whenTagAdded: "Когда к задаче добавляется тег",
            whenTagRemovedTask: "Когда тег удаляется из задачи",
            whenTagChecklist: "Когда контрольный список задачи завершен",
            whenReminderActivated: "Когда активируется напоминание",
            whenTicketCreated: "Когда создается билет",
            whenTicketStageChanged: "При изменении стадии билета",
            whenTicketAssigneeChanged: "При изменении получателя билета",
            whenTicketClosed: "Когда билет закрывается",
            whenTicketUpdated: "Когда билет обновляется",
            archivingDate: "Дата архивации",
            autoPlanAndTaskHistory: "План автоматизации и история задач",
            automation: "Автоматизация",
            botScenario: "Сценарий бота",
            nameSurname: "ИмяФамилия",
            phone164: "*Введите номер в формате E164. Например: 905396667744",
            whichWpChannels: "Какие каналы Whatsapp добавить?",
            findContact: "Найти контакт",
            findContacts: "Найти контакты",
            offsetDesc:
                "Пропустить первые N контактов. Значение по умолчанию - '0'. Используйте это значение для прокрутки контактов.",
            limitDesc:
                "Максимальное количество контактов для возврата после смещения. Значение по умолчанию - '10'. Используйте это значение для постраничного просмотра",
            contact: "Контакт",
            selectAction: "Выберите действие",
            addMethod: "Добавить метод",
            selectField: "Выберите поле",
            schedulerRunningPlanEx: "Пример плана выполнения планировщика",
            schedulerPlanner: "Планировщик расписания",
            taskCreated: "Задача создана?",
            taskStatus: "Статусы задач",
            terminateReason: "Причина завершения",
            taskDuration: "Длительность задачи",
            taskWakeUpCount: "Количество пробуждений задачи",
            completedAt: "Завершено",
            cancelledAt: "Отменено",
            nextRunAt: "Следующий запуск",
            configSchedulerAuto: "Настроить таймер для автоматизации",
            saveChanges: "Сохранить изменения",
            catchAllWebhooks: "Перехватывать все веб-хуки с этого URL",
            webhookDataExPreview:
                "Предварительный просмотр образца данных Webhook (будет показан после отправки запроса)",
            webhookUrlCopied: "URL Webhook скопирован в буфер обмена",
            selectAnBlock: "Выбрать блок",
            dataFormats: "Форматы данных",
            whenRecordCreated: "Когда создается запись",
            whenRecordUpdated: "Когда запись обновляется",
            whenRecordDelete: "Когда запись удаляется",
            whenRecordAutomation: "Когда нажимается кнопка автоматизации записи",
            whenWebhookTriggered: "Когда срабатывает веб-хук",
            whenChatCreated: "Когда создается чат",
            whenChatClosed: "Когда чат закрывается",
            whenChatRated: "Когда чат оценивается",
            whenNewContactCreated: "Когда создается новый контакт",
            whenContactUpdate: "Когда контакт обновляется",
            whenContactPropUpdate: "При обновлении свойств контакта",
            whenNewTagAdded: "При добавлении нового тега",
            whenTagRemoved: "Когда тег удаляется",
            whenNewEmailReceived: "Когда получено новое электронное письмо",
            whenNewTaskCreated: "Когда создается новая задача",
            whenNewMetaleadCreated: "Когда создается новый мета-лид",
            whenNewAgentCreated: "Когда создается новый агент",
            whenNewInvoiceCreated: "Когда создается новый счет-фактура",
            whenNewWpReceived: "Когда получено новое сообщение Whatsapp",
            whenNewReservationCreated: "Когда создается новое бронирование",
            whenNewChatbotReceived: "Когда получено новое сообщение чатбота",
            chatWebhookAutomation: "Поймать веб-крючок и запустить автоматизацию",
            automationName: "Имя автоматизации",
            supsisObject: "Объект Supsis",
            selectModule: "Модель выбора",
            bodyType: "Тип тела",
            selectBodyType: "Выбрать тип тела",
            selectMethod: "Выбрать метод",
            trigger: "Триггер",
            published: "Опубликовано",
            createdAt: "Создано",
            action: "Действие",
            type: "Тип",
            view: "Посмотреть",
            createTimerAutomation: "Создание таймера автоматизации",
            createEventBasedAutomation: "Создание автоматизации на основе событий",
            createWebhookAutomation: "Создание автоматизации Webhook",
            automationsDeletedSuccessfully: "Автоматизации удалены успешно",
            automationsCouldNotBeDeleted: "Автоматизации не могут быть удалены",
            timerAutomationCreatedSuccessfully: "Автоматизация таймера создана успешно",
            eventAutomationCreatedSuccessfully: "Автоматизация событий создана успешно",
            webhookAutomationCreatedSuccessfully: "Автоматизация вебхука создана успешно",
            automationsCouldNotBeFetched: "Автоматизации не удалось получить",
            automationPublishedStateUpdatedSuccessfully: "Автоматизация успешно обновила опубликованное состояние",
            automationPublishedStateCouldNotBeUpdated: "Не удалось обновить состояние публикации автоматизации",
            createAnEventAutomation: "Создать автоматизацию события",
            automations: "Автоматизации",
            allAutomations: "Все автоматизации",
            scheduledAutomations: "Автоматизации по расписанию",
            eventBasedAutomations: "Автоматизации, основанные на событиях",
            buttonAutomations: "Автоматизации по кнопкам",
            webhookAutomations: "Автоматизации по вебхукам",
            blocks: {
                START_POINT: "ТОЧКА СТАРТА",
                AI_ASSISTANT: "AI ПОМОЩНИК",
                BOT_RESPONSE: "ОТВЕТ БОТА",
                AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "КЛАССИФИКАЦИЯ AI",
                AI_MENU_FLOW: "AI МЕНЮ",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
                PLATFORM_FLOW: "ПЛАТФОРМА",
                DEFAULT_FALLBACK: "ВОЗВРАТ ПО УМОЛЧАНИЮ",
                DEFAULT_TIMEOUT: "ТАЙМАУТ ПО УМОЛЧАНИЮ",
                AI_FUNCTIONS: "AI ФУНКЦИИ",
                FILTER: "ФИЛЬТР",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "ВВОД ВЛОЖЕНИЙ",
                USER_INPUT: "ПОЛЬЗОВАТЕЛЬСКИЙ ВВОД",
                GO_TO_STEP: "ПЕРЕЙТИ К ШАГУ",
                WEBHOOK: "ВЕБХУК",
                SET_ATTRIBUTE: "УСТАНОВИТЬ АТРИБУТ",
                QUESTION: "ВОПРОС",
                CLOSE_CHAT: "ЗАКРЫТЬ ЧАТ",
                CREATE_TICKET: "СОЗДАТЬ БИЛЕТ",
                TRANSFER_CHAT: "ПЕРЕДАТЬ ЧАТ",
                TRANSFER_TO_CHATBOT: "ПЕРЕСЛАТЬ ЧАТБОТУ",
                TAG_CHAT: "ДОБАВИТЬ ТЕГ",
                REMOVE_TAG: "УДАЛИТЬ ТЕГ",
                SET_DEPARTMENT: "УСТАНОВИТЬ ОТДЕЛ",
                SEND_TRANSCRIPT: "ОТПРАВИТЬ СТЕНОГРАММУ",
                SEND_SMS: "ОТПРАВИТЬ СМС",
                SEND_MAIL: "SEND MAIL",
                CREATE_EVENT: "СОЗДАТЬ СОБЫТИЕ",
                CREATE_RESERVATION: "СОЗДАТЬ РЕЗЕРВАЦИЮ",
                RESERVATION_OPEN_URL: "ОТКРЫТЫЙ URL РЕЗЕРВАЦИИ",
                RESERVATION_SELECT_DAY: "ВЫБЕРИТЕ ДЕНЬ БРОНИРОВАНИЯ",
                RESERVATION_EVENT_LIST: "ПОСЕТИТЕЛЬ СПИСКА РЕЗЕРВИРОВАНИЯ",
                RESERVATION_SELECT_TIME: "ВЫБЕРИТЕ ВРЕМЯ БРОНИРОВАНИЯ",
                CREATE_TASK: "СОЗДАТЬ ЗАДАЧУ",
                UPDATE_TASK: "ОБНОВИТЬ ЗАДАНИЕ",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY SHOW PRODUCTS",
                SHOPIFY_PRODUCT_AVAILABILITY: "НАЛИЧИЕ ТОВАРА В МАГАЗИНЕ",
                SHOPIFY_ORDER_STATUS: "СТАТУС ЗАКАЗА SHOPIFY",
                AKINON_SHOW_PRODUCTS: "ПОКАЗАТЬ ТОВАРЫ AKINON",
                AKINON_FIND_PRODUCT: "AKINON НАЙТИ ПРОДУКТ",
                AKINON_ORDER_STATUS: "СТАТУС ЗАКАЗА AKINON",
                AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
                AKINON_SELECT_SIZE: "AKINON ВЫБРАТЬ РАЗМЕР",
                AKINON_FIND_NEAREST_STOCK: "ПОКАЗАТЬ ЗАПАСЫ В МАГАЗИНЕ",
                AKINON_FIND_NEAREST_STORES: "ПОКАЗАТЬ БЛИЖАЙШИЕ МАГАЗИНЫ",
                AKINON_SHOW_DISCOUNT_CODES: "ПОКАЗАТЬ КОДЫ СКИДОК",
                SUPPRESSION_ADD: "БЛОКИРОВАТЬ КОНТАКТ",
                SUPPRESSION_REMOVE: "РАЗБЛОКИРОВАТЬ КОНТАКТ",
                ADD_TO_SEGMENT: "ДОБАВИТЬ СЕГМЕНТ",
                REMOVE_FROM_SEGMENT: "УДАЛИТЬ ИЗ СЕГМЕНТА",

                IDEASOFT_SELECT_ORDER: "ВЫБРАТЬ ЗАКАЗ",
                IDEASOFT_ORDER_STATUS: "ПОЛУЧИТЬ СТАТУС ЗАКАЗА",
                IDEASOFT_GET_MEMBER_INFO: "ЗАПОЛНИТЬ ИНФОРМАЦИЮ О ПОЛЬЗОВАТЕЛЕ",
                TICKET_UPDATE: "ОБНОВИТЬ БИЛЕТ",

                GET_LOCATION: "ПОЛУЧИТЬ МЕСТОПОЛОЖЕНИЕ",
                FALLBACK: "Альтернативный вариант",
                TIMEOUT: "ТАЙМАУТ",
                SUCCESS: "УСПЕШНО",
                FAILURE: "НЕУДАЧА",

                PROBEL_SELECT_BRANCH: "Выбрать филиал",
                PROBEL_SELECT_CLINIC: "Выберите поликлинику",
                PROBEL_SELECT_DAY: "Выберите день приема",
                PROBEL_SELECT_HOUR: "Выберите время приема",
                PROBEL_MAKE_APPOINTMENT: "Записаться на прием",
                PROBEL_CANCEL_APPOINTMENT: "Отмена назначения",
                PROBEL_GET_PATIENT_TOKEN: "Получить токен пациента",
                PROBEL_FILL_INFO: "Получить информацию MERNIS",
                PROBEL_SELECT_APPOINTMENT: "Выбрать назначение",

                SEND_WP_BUSINESS_MESSAGE: "ОТПРАВИТЬ СООБЩЕНИЕ WHATSAPP",
                INSTAGRAM_COMMENT_REPLY: "ОТВЕТИТЬ НА КОММЕНТАРИЙ",
                INSTAGRAM_COMMENT_DELETE: "УДАЛИТЬ КОММЕНТАРИЙ",
                INSTAGRAM_COMMENT_SHOW: "ПОКАЗАТЬ КОММЕНТАРИЙ",
                INSTAGRAM_COMMENT_HIDE: "СКРЫТЬ КОММЕНТАРИЙ",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "ОТВЕТИТЬ КАК ПРИВАТНЫЙ",
                LOOP: "зацикливать",
                LOOP_NEXT: "зацикливать следующий элемент",
                LOOP_BREAK: "прервать цикл",
                LOOP_CONTINUE: "Продолжить следующий цикл",
                LOOP_FINISH: "Завершить цикл",
                SLEEP: "Спать",
                NOOP: "Пропустить",
                CATCH_WEBHOOK: "Отловить webhook",
                TERMINATE_AUTOMATION: "Завершить автоматизацию",
                OPEN_AI: "OPEN_AI",
                CREATE_CONTACT: "Создать контакт",
                UPDATE_CONTACT: "Обновить контакт",
                FIND_CONTACTS: "Найти контакты",
                FIND_CONTACT: "Найти контакт",
                FIND_CHATS: "Найти чаты",
                FIND_CHAT: "Найти чат",
                WAIT_FOR: "Подождать",
                STRING_FORMAT: "Форматировать строку",
                NUMBER_FORMAT: "Форматировать число",
                DATE_FORMAT: "Форматировать дату",
                RECORDS_FROM_CSV: "Записи из CSV",
                MESSAGE_RECEIVED: "Сообщение получено",
                ASK_AI: "Спросите Аи",

                TABLE_CREATE_RECORD: "Создать запись",
                TABLE_DELETE_RECORD: "Удалить запись",
                TABLE_UPDATE_RECORD: "Обновление регистрации",
                TABLE_FIND_RECORD: "Найти запись",
                TABLE_FIND_RECORDS: "Запись списка",

                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Find Records (By Phone)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Добавить файл к записи Zoho",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Загрузить изображение в пользовательское поле Zoho",
                ZOHO_CREATE_RECORD: "Создать запись Zoho",

                GET_SUPSIS_RECORD_BY_ID: "Найти запись Supsis (по идентификатору)",
            },
        },
        modules: {
            moduleDeletedSuccessfully: "Модуль успешно удален",
            deleteModuleTitle: "Удалить модуль",
            deleteModuleContent: "Вы уверены, что хотите удалить этот модуль?",
            modules: "Модули",
            modulesSettings: "Настройки Модулей",
            displayName: "Отображаемое Имя",
            description: "Описание",
            table: "Таблица",
            menuApiSettings: "Настройки Меню и API",
            icon: "Иконка",
            save: "Сохранить",
            exampleIcon: "Пример: extension, home",
            newModule: "Новый Модуль",
            moduleName: "Имя Модуля",
            apiName: "Имя API",
            type: "Тип",
            apiAccess: "Доступ к API",
            actions: "Действия",
            module: "Модуль",
            relation: "Отношение",
            moduleRelationName: "Модуль/Отношение",
            moduleRelationTable: "Таблица Модуль/Отношение",
            showInMainMenu: "Показать в Главном Меню",
            apiEnabled: "API Включен",
            settings: "Настройки",
            createModule: "Создать Модуль",
            relationType: "Тип отношения",
            standartModule: "Стандартный модуль",
            customTable: "Таблица",
            localField: "Локальное поле",
            showingRemoteFieldInList: "Показать удаленное поле в списке",
            relationSettings: "Настройки отношения",
            remoteField: "Удаленное поле",
            localFieldType: "Тип локального поля",
            standart: "Стандартный",
            custom: "Пользовательский",
            contact: "Контакт",
            viewRecord: "Просмотр записи",
            recordDetail: "Детали записи",
            recordNotFound: "Запись или информация таблицы не найдена",
            relatedLists: "Связанные списки",
            recordViewer: "Просмотр записей",
        },
        tables: {
            priority_lowest: "Низший",
            priority_low: "Низкий",
            priority_medium: "Средний",
            priority_high: "Высокий",
            priority_highest: "Высший",
            createFailed: "Не удалось создать модуль",
            createSuccess: "Модуль успешно создан",
            today: "Сегодня",
            month: "Месяц",
            week: "Неделя",
            day: "День",
            table: "Таблица",
            kanban: "Канбан",
            calendar: "Календарь",
            calendarSettings: "Настройки Календаря",
            colorBy: "Цвет По",
            startDateField: "Поле Даты Начала",
            endDateField: "Поле Даты Окончания (Необязательно)",
            eventCardFields: "Поля Карточки События",
            selectColorField: "Выбрать Поле Цвета",
            selectStartDateField: "Выбрать Поле Даты Начала",
            selectEndDateField: "Выбрать Поле Даты Окончания",
            cancel: "Отмена",
            save: "Сохранить",
            kanbanNotAvailable: "Просмотр Канбан Недоступен",
            needDropdownField:
                "Для использования просмотра Канбан необходимо хотя бы одно статическое поле выпадающего списка в вашей таблице. Вы можете добавить новое поле или отредактировать существующее в настройках таблицы.",
            notAvailable: "Просмотр Календаря Недоступен",
            needDateField:
                "Для использования просмотра календаря необходимо хотя бы одно поле даты в вашей таблице. Вы можете добавить новое поле или отредактировать существующее в настройках таблицы.",
            switchToTable: "Переключиться на Просмотр Таблицы",
            operator: "Оператор",
            conditionalColor: "Условное цвет",
            groupField: "Групповое поле",
            selectDirection: "Выберите направление",
            showEmptyGroups: "Показать пустые группы",
            clearGrouping: "Очистить группировку",
            applyGrouping: "Применить группировку",
            sortDirection: "Направление сортировки",
            downloadSelectedRecords: "Загрузить выбранные записи",
            viewName: "Имя вида",
            enterViewName: "Введите имя вида",
            enterDesc: "Введите описание",
            viewNameRequired: "Требуется ввести имя вида",
            runWebhookAutomation: "Запустить автоматизацию Webhook",
            downloadAllRecords: "Загрузить все записи",
            deleteRecords: "Удалить записи",
            editRecords: "Обновить записи",
            duplicateRecords: "Дублировать записи",
            selected: "Выбранные",
            sureDeleteRecords: "Вы уверены, что хотите удалить записи?",
            selectedRecordSucs: "Выбранные записи были успешно удалены.",
            errorDeletingRecords: "При удалении записей произошла ошибка.",
            sureCopyRecords: "Вы уверены, что хотите скопировать записи?",
            copyRecords: "Копировать записи",
            recordsCopiedSucs: "Выбранные записи были успешно скопированы",
            recordsCopiedError: "При копировании выбранных записей произошла ошибка.",
            viewSucsCreated: "Представление было создано успешно.",
            editMultipleRecords: "Редактировать несколько записей",
            importRecords: "Импортировать записи",
            importHasStarted:
                "Импорт начался. Это может занять несколько минут в зависимости от размера ваших данных. Пожалуйста, подождите...",
            anErrorImport: "Во время импорта произошла ошибка.",
            recordCreated: "Создать запись",
            recordUpdated: "Обновить запись",
            recordDeleted: "Удалить запись",
            noAutomationDefined: "Автоматизация еще не определена",
            nameTheAutomationAdd:
                "Назовите автоматизацию, которая будет выполняться при добавлении записи в эту таблицу:",
            nameTheAutomationUpdate:
                "Назовите автоматизацию, которая будет запускаться при обновлении записи в этой таблице:",
            nameTheAutomationDelete:
                "Назовите автоматизацию, которая будет запущена при удалении записи из этой таблицы:",
            editField: "Поле редактирования",
            sort: "Сортировка",
            ascending: "По возрастанию",
            descending: "По убыванию",
            createField: "Создать поле",
            insertBefore: "Вставить до",
            insertAfter: "Вставить после",
            goToRelatedAuto: "Перейти к связанной автоматизации",
            permission: "Разрешение",
            lockField: "Заблокировать поле",
            hideField: "Скрыть поле",
            deleteField: "Удалить поле",
            watchVideo: "Смотреть видео",
            uploadError: "Ошибка при загрузке",
            updateError: "Ошибка обновления",
            invalidValue: "Недопустимое значение. Пожалуйста, используйте правильный формат.",
            errorUpdatingRecord: "При обновлении записи произошла ошибка.",
            errorCreatingView: "При создании представления произошла ошибка.",
            datetimeOptions: "Параметры времени даты",
            numberOptions: "Параметры числа",
            currencyOptions: "Параметры валюты",
            dropdownOptions: "Параметры выпадающего списка",
            automationButtonOptions: "Параметры кнопки автоматизации",
            defaultLabel: "Метка по умолчанию",
            disableWhenClicked: "Отключать при нажатии",
            fieldSucsCreate: "Поле создано успешно",
            fieldCreatingFailed: "При создании поля произошла ошибка",
            fieldSucsUpdate: "Поле успешно обновлено",
            fieldUpdatingFailed: "При обновлении поля произошла ошибка",
            showAll: "Показать все",
            hideAll: "Скрыть все",
            searchFields: "Поля для поиска",
            firstRowHeader: "Первая строка содержит заголовок",
            seperatorCharacter: "Символ разделителя",
            comma: "Запятая",
            semicolan: "Точка с запятой",
            tableFieldOrFileColumns: "Сопоставление полей таблицы / столбцов файла",
            exampleResultPreview: "Предварительный просмотр примера результата",
            newView: "Новый вид",
            createViewaFiltering:
                "Создайте представления, чтобы продолжить фильтрацию, сортировку и скрытие полей без изменения главной таблицы",
            pleaseUpdateSelected: "Пожалуйста, выберите поле, которое вы хотите обновить для выбранных записей",
            pleaseSelectedNewValue: "Пожалуйста, введите новое значение для выбранного поля.",
            selectedMenuItem: "Выбранный пункт меню:",
            deleteTable: "Удалить таблицу",
            sureDeleteTable: "Вы уверены, что хотите удалить эту таблицу?",
            deleteTableSucs: "Таблица была удалена успешно.",
            deleteTableError: "Ошибка при удалении таблицы:",
            editTable: "Редактировать таблицу",
            createNewField: "Создать новое поле",
            tables: "Таблицы",
            tableName: "Название таблицы",
            description: "Описание",
            createTable: "Создать таблицу",
            createNewTable: "Создать новую таблицу",
            allTables: "Все таблицы",
            myTables: "Мои таблицы",
            myFavorites: "Мои избранные",
            errorCreatingTable: "Ошибка при создании таблицы:",
            customerTable: "Таблица клиентов",
            customerTableDesc: "Таблица клиентов по умолчанию",
            leadTracking: "Отслеживание лидов",
            leadTrackingDesc: "Таблица отслеживания лидов",
            todoList: "Список дел",
            todoListDesc: "Список для отслеживания задач",
            approvalReq: "Запрос на утверждение",
            approvalReqDesc: "Управление запросами на утверждение",
            eventSchedule: "Календарь событий",
            eventScheduleDesc: "Расписание предстоящих событий",
            inventoryList: "Список инвентаря",
            inventoryListDesc: "Следит за запасами продуктов",
            bookingForm: "Форма бронирования",
            bookingFormDesc: "Отслеживание бронирований",
            bugTracker: "Трекер ошибок",
            bugTrackerDesc: "Отслеживание ошибок в программном обеспечении",
            employeeDirectory: "Справочник сотрудников",
            employeeDirectoryDesc: "Содержит информацию о сотрудниках",
            errorPullTable: "Ошибка при извлечении данных из таблицы",
            newRecordSucs: "Новая запись создана успешно",
            failedNewRecord: "Не удалось создать новую запись:",
            newRecordCreateError: "При создании новой записи произошла ошибка.",
            recordCount: "Количество записей",
            increaseLimit: "Лимит увеличения",
            newRecord: "Новая запись",
            imports: "Импорт",
            exports: "Экспорт",
            download: "Загрузка",
            automateYourData: "Автоматизировать ваши данные",
            recordUpdatedSucs: "Запись успешно обновлена",
            failedToUpdateRecord: "Не удалось обновить запись",
            recordUpdatingError: "Ошибка при обновлении записи",
            mainTable: "Главная таблица",
            filter: "Фильтр",
            hideFields: "Скрыть поля",
            saveAsView: "Сохранить как вид",
            search: "Поиск",
            create: "Создать",
            left: "Левый",
            center: "Средний",
            right: "Правый",
            selectTimezone: "Выберите часовой пояс",
            createFieldSucs: "Поле создано успешно.",
            failedCreateField: "Не удалось создать поле:",
            createFieldError: "При создании поля произошла ошибка.",
            addCondition: "Добавить условие",
            applyFilter: "Применить фильтр",
            fieldType: "Тип поля",
            alignment: "Выравнивание",
            blankTable: "Пустая таблица",
            templates: "Шаблоны",
            timezone: "Часовой пояс",
            timeFormat: "Формат времени",
            includeTime: "Включая время",
            decimalFormat: "Десятичный формат",
            currencySymbol: "Символ валюты",
            mode: "Режим",
            statics: "Статический",
            dynamic: "Динамический",
            multipleSelection: "Множественный выбор",
            addOption: "Добавить опцию",
            text: "Текст",
            longText: "Длинный текст",
            number: "Число",
            currency: "Валюта",
            datetime: "Дата и время",
            dropdown: "Выпадающий список",
            checkbox: "Флажок",
            email: "Электронная почта",
            phone: "Телефон",
            file: "Файл",
            image: "Изображение",
            video: "Видео",
            audio: "Аудио",
            color: "Цвет",
            automationButton: "Кнопка автоматизации",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Неделя",
            readyContents: "Готовое содержимое",
            webhookIntegration: "Интеграция вебхуков",
            businessChannel: "Канал бизнеса WhatsApp",
            confirmationFeature: "Функция подтверждения",
            specialReporting: "Специальная отчетность",
            aiAssistant: "ИИ помощник",
            flexibleBilling: "Гибкая биллинг",
            automaticReservation: "Автоматическое бронирование",
            taskManagement: "Управление задачами",
            calendarIntegration: "Интеграция календаря",
            activeChatbot: "Активный чатбот",
            smsIntegration: "Интеграция SMS",
            mailIntegration: "Интеграция почты",
            startChatWithVisitor: "Начать чат с посетителем",
            whatsappManaging: "Управление Whatsapp",
            automaticChatbotButton: "Автоматическая кнопка/чат-бот",
            personalizedBroadcasts: "Персонализированные рассылки",
            chatWithNonContacts: "Чат с неконтактными лицами",
            broadcastMessaging: "Рассылка сообщений",
            perBroadcast: "За трансляцию",
            extraPricePerMessage: "Дополнительная плата за сообщение",
            smartTrigger: "Умный триггер",
            telegramIntegration: "Интеграция с Telegram",
            instagramIntegration: "Интеграция с Instagram",
            ticketFeature: "Функция билетов",
            storage: "Хранение",
            onePanelManagement: "Управление в одной панели",
            isolatedDatabaseConnection: "Изолированное подключение к базе данных",
            removeLogo: "Удалить логотип Supsis",
            chatBaloonCustomization: "Настройка пузырьков чата",
            chatAndNotifications: "Чат и уведомления",
            unlimited: "Неограниченный",
            specialCustomerSupport: "Специальная клиентская поддержка",
            softwareSupport: "Поддержка программного обеспечения",
            standardSupport: "Стандартная поддержка",
            teamChatIntegration: "Интеграция чата команды",
            fileAndVoiceShare: "Обмен файлами и голосом",
            instantVisitor: "Мгновенное отслеживание посетителей",
            detailedReporting: "Подробная отчетность",
            normalreporting: "Обычная отчетность",
            noExtraCosts: "Без дополнительных расходов",
            accessibleToAllAgents: "Доступно для всех агентов",
            dataSecurity: "Безопасность данных",
            autoTranslate: "Автоматический перевод",
            chatbotVersionHistory: "История версий чатбота",
            chatbotStory: "История чатбота",
            freeAgent: "Бесплатный агент",
            stableAgentCount: "Количество стабильных агентов",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Доступные планы",
            generalPlan: "Общий план",
            specialPlan: "Специальный план",
            currentPlan: "Текущий план",
            selected: "Выбрано",
            popular: "Популярный",
            trialPkg: "Пробный пакет",
            support: "Поддержка 24/7",
            flexiblePricing: "Гибкая ценовая политика",
            rightToCancel: "Право отмены в любое время",
            unlimitedCBScenario: "Неограниченные сценарии чатбота",
            freeFirstScenario: "Бесплатный первый сценарий",
            unlimitedLearn: "Неограниченное обучение чатбота",
            allPlatformIntegration: "Интеграция со всеми платформами",
            detailedReports: "Подробные отчеты",
            aiSupport: "Поддержка искусственного интеллекта",
            creativeAI: "Быстрый и реалистичный чат-ассистент на основе ИИ",
            unlimitedSession: "Неограниченные сеансы одновременно",
            assistantFromWebsite: "Создание помощника с веб-сайта",
            assistantFromDoc: "Создание чат-бота из документа",
            mobileApp: "Мобильное приложение",
        },
        messenger: {
            channel: "Канал Messenger",
            manageChannel: "Управление каналом",
            channelDetail: "Детали канала",
            integrationTitle: "Интеграция Messenger",
            deleteDesc: "Вы уверены, что хотите удалить канал Messenger?",
            channels: "Каналы Messenger",
            connectMessenger: "Подключиться к Messenger",
            detail: "деталь",
            visibility: "видимость",
            settings_group: "Настройки",
            commentsettings: "Управление комментариями",
            commentSettingsTitle: "Управление комментариями в мессенджере",
            commentSettingsDesc: "Управляйте своими комментариями в Messenger",
        },
        instagram: {
            channel: "Канал Instagram",
            detail: "деталь",
            visibility: "видимость",
            settings_group: "Настройки",
            commentsettings: "Управление комментариями",
            commentSettingsTitle: "Управление комментариями в Instagram",
            commentSettingsDesc: "Управляйте своими комментариями в Instagram",
            commentSettingsTicket: "Обеспечивает сохранение входящих комментариев в системе как заявок.",
            commentSettingsChatbot: "Выберите, к какому сценарию чат-бота следует направить входящие комментарии.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Показать все каналы Instagram",
        },
        calendar: {
            calendarsDesc: "Избегайте конфликтов расписания",
            generalAvailability: "Общая доступность",
            generalAvailabilityDesc: "Укажите время, когда вы регулярно доступны для встреч.",
            appointDuration: "Продолжительность встречи",
            appointDurationDesc: "Сколько времени должна длиться каждая встреча?",
            customDuration: "Пользовательская продолжительность",
            descriptionDesc:
                "Добавьте заметку, описывающую вашу услугу. Добавленная вами заметка будет отображаться на странице бронирования и в электронных письмах с подтверждением.",
            resForm: "Форма бронирования",
            resFormDesc: "Настройте форму, которую люди будут использовать для бронирования встречи.",
            addField: "Добавить поле",
            addAnItem: "Добавить элемент",
            saveItem: "Сохранить элемент",
            planningTimeframe: "Временные рамки планирования",
            planningTimeframeDesc: "Ограничить временные рамки, в которые может быть назначена встреча",
            availableAtMoment: "Доступно сейчас",
            startAndEndDate: "Дата начала и окончания",
            maxNumberAppoint: "Максимальное количество дней, через которое можно назначить встречу",
            howLongMinAppoint: "За какое время до встречи можно записаться",
            planningIntervalStartEnd: "Даты начала и окончания интервала планирования",
            startTime: "Время начала",
            done: "Выполнено",
            receivedAppointInterval: "Интервал между полученными назначениями",
            receivedAppointIntervalDesc: "Управление полученными встречами для отображения в вашем календаре.",
            interimTime: "Промежуточное время",
            interimTimeDesc: "Добавить время между интервалами встреч",
            dayMaxRes: "Максимальное количество бронирований в день",
            dayMaxResDesc:
                "Ограничение количества забронированных встреч, которые могут быть приняты в течение одного дня",
            customise: "Установить пользовательские настройки",
            noAvatar: "Аватара нет",
            organizationName: "Название организации",
            enterFullAdress: "Введите полный адрес",
            noCoverPhoto: "Нет фотографии на обложке",
            enterAboutInfo: "Введите информацию о себе",
            service: "Услуга",
            deleteService: "Удалить услугу",
            enterGoogleMapsUrl: "Введите URL-адрес Google Maps",
            enterLatitude: "Введите широту",
            enterLongitude: "Введите долготу",
            enterNumber: "Введите номер телефона",
            uploadAvatar: "Загрузить аватар",
            teamMemberDeleteError: "Ошибка при удалении члена команды:",
            setupBookingWebsite: "Настройка сайта бронирования",
            bookingLandingPageBuilder: "Конструктор посадочных страниц бронирования",
            coverPhoto: "Фотография обложки",
            enterOrganisationName: "Введите название организации",
            about: "О компании",
            services: "Услуги",
            deleteServices: "Удалить услугу",
            selectReservationPlan: "Выбрать план бронирования",
            addNewService: "Добавить новую услугу",
            addNewMember: "Добавить нового участника",
            fullAddress: "Полный адрес",
            latitude: "Широта",
            longitude: "Долгота",
            contactDetails: "Контактная информация",
            emailAddress: "Адрес электронной почты",
            enterEmail: "Введите адрес электронной почты",
            websiteURL: "URL веб-сайта",
            enterWebsiteURL: "Введите URL веб-сайта",
            reservationPolicy: "Политика резервирования",
            enterResPolicy: "Введите политику бронирования",
            workingHours: "Рабочие часы",
            selectEndHour: "Выберите время окончания",
            addNewHour: "Добавить новый час",
            updateMemberInfo: "Обновить информацию о члене",
            errorRecevingData: "Ошибка при получении данных:",
            anonymService: "Анонимный сервис",
            unknownPlan: "Неизвестный план",
            errorCreatingMockPage: "Ошибка при создании макетной страницы:",
            failedToCreateBookingPage: "Не удалось создать страницу бронирования",
            fileSizeToolLarge: "Слишком большой размер файла",
            errorLoadingTheLogo: "Ошибка при загрузке логотипа:",
            failedToLoadLogo: "Не удалось загрузить логотип",
            errorUpdating: "Ошибка обновления:",
            failedToUpdate: "Не удалось обновить",
            newMember: "Новый участник",
            errorLoadingAvatar: "Ошибка при загрузке аватара:",
            avatarFailedToLoad: "Не удалось загрузить аватар",
            teamMemberSuccessfullyDeleted: "Член команды успешно удален",
            teamMemberNotDelete: "Не удалось удалить члена команды",
            yesDelete: "Да, удалить",
            sureResDelete: "Вы уверены, что хотите удалить это бронирование?",
            resDetails: "Детали бронирования",
            infoPersonMakingRes: "Информация о человеке, сделавшем бронирование",
            appointmentProgram: "Расписание назначений",
            goToAppointSettings: "Перейти к настройкам программы назначений",
            resPlanCreateSuccess: "План резервирования создан успешно",
            pleaseEnterTitle: "Пожалуйста, введите название",
            sureContinueSaving: "Вы уверены, что хотите продолжить без сохранения?",
            appointProgram: "ПРОГРАММА БРОНИРОВАНИЯ",
            everyMonth: "Каждый месяц",
            firstEveryMonth: "Первый день каждого месяца",
            dayOf: "День",
            notRepeat: "Не повторяется",
            daily: "Ежедневно",
            weekly: "Раз в неделю",
            monthly: "Раз в месяц",
            annually: "Раз в год",
            custom: "Особый",
            eventSaved: "Сохранение события",
            createAppoint: "Создать назначение",
            calendarSetting: "Настройки календаря",
            notAuthezord: "Вы не авторизованы для выполнения этой операции",
            reservationWebPage: "Веб-страница бронирования",
            reservationPrograms: "Программы бронирования",
            addReservationProgram: "Добавить программу бронирования",
            resPlanError: "Ошибка при получении планов бронирования:",
            resDeleteSure: "Вы уверены, что хотите удалить эту программу бронирования?",
            resDeleteSuccess: "Программа бронирования была успешно удалена.",
            resDeleteError: "Ошибка при удалении программы бронирования:",
            unkownUser: "Неизвестный пользователь",
            eventNotFound: "Событие не найдено",
            reservations: "Бронирование",
            events: "События",
            upcoming: "ближайшие",
            past: "Прошлое",
            setting: "Настройки",
            delete: "Удалить",
            cancel: "Отмена",
            save: "Сохранить",
            close: "Закрыть",
            deleteRepeatEvent: "Удалить повторяющееся событие",
            thisEvent: "Это событие",
            thisAndOtherEvent: "Это и следующие события",
            allEvent: "Все события",
            ok: "ОК",
            googleCalendarLink: "Добавить в Google Календарь",
            yahooCalendarLink: "Добавить в Yahoo Календарь",
            subject: "Тема",
            visitor: "Посетитель",
            allDay: "Весь день",
            title: "Название",
            deleteEvent: "Удалить событие",
            deleteEvents: "Удалить события",
            deleteEventsSure: "Вы уверены, что хотите удалить события из этого календаря?",
            deleteEventConfirm: "Вы уверены, что хотите удалить это событие?",
            notEmptyTitle: "Название не может быть пустым!",
            tasks: "Задачи",
            googleConnect: "Интеграция с Google",
            googleDisconnect: "Отключить интеграцию с Google",
            sure: "Вы уверены?",
            disconnectGoogleSure: "Вы уверены, что хотите отключить Google?",
            yes: "Да",
            no: "Нет",
            customRepeat: "Настроить повторение",
            recurrenceFrequency: "Частота повторения",
            repeatDays: "Повторять по дням",
            never: "Никогда",
            thisDate: "В эту дату",
            recurrenceCount: "Количество повторений",
            end: "Конец",
            event: "Событие",
            calendars: "Календари",
            newCalendar: "Создать новый календарь",
            changeColor: "Изменить цвет",
            addCalendar: "Добавить календарь",
            nameCalendar: "Название календаря",
            description: "Описание",
            change: "Изменить",
            deleteCalendar: "Удалить календарь",
            deleteCalendarSure: "Вы уверены, что хотите удалить этот календарь?",
            notEmptyCalendarName: "Название календаря не может быть пустым",
            myEvents: "Мои события",
            everyoneEvents: "Все события",
            haveEvent: "события у представителя",
            goCalendar: "Перейти в календарь",
            goReservation: "Создать бронирование",
            agents: "Представители",
            today: "Сегодня",
            month: "Месяц",
            week: "Неделя",
            day: "День",
            list: "Список",
        },
        ticimax: {
            segment: "Сегмент",
            settings_group: "Настройки",
            waitDayFromLastSend: "Количество дней ожидания с момента последнего отправленного сообщения",
            automationRuleName: "Название правила автоматизации",
            time: "Время",
            year: "Год",
            month: "Месяц",
            dayOfMonth: "День месяца",
            day: "День",
            bySecond: "По секунде",
            byMinute: "По минуте",
            byHour: "По часу",
            byWeekNo: "По номеру недели",
            byYearDay: "По номеру дня в году",
            byMonthDay: "По номеру дня в месяце",
            byMonth: "По месяцу",
            december: "Декабрь",
            november: "Ноябрь",
            october: "Октябрь",
            september: "Сентябрь",
            august: "Август",
            july: "Июль",
            june: "Июнь",
            may: "Май",
            april: "Апрель",
            march: "Март",
            february: "Февраль",
            january: "Январь",
            byWeekDay: "По дню недели",
            interval: "Интервал",
            seconds: "Секунды",
            minutes: "Минуты",
            hourly: "По часам",
            daily: "По дням",
            weekly: "По неделям",
            monthly: "По месяцам",
            yearly: "По годам",
            frequency: "Частота",
            attributes: {
                vip: "VIP",
                segment: "Сегмент",
                province: "Провинция",
                country: "Страна",
                phone: "Телефон",
                email: "Эл. почта",
                fullname: "Полное имя",
                couponPercent: "% купона",
                lastOrderDate: "Последний заказ",
                firstOrderDate: "Первый заказ",
                county: "Каунти",
                lastSource: "Последний источник",
                firstSource: "Первый источник",
                lastPaymentType: "Последний способ оплаты",
                firstPaymentType: "Первый способ оплаты",
                maxOrderAmount: "Максимальная сумма заказа",
                minOrderAmount: "Минимальная сумма заказа",
                totalOrderAmount: "Общая сумма заказов",
                totalOrderCount: "Общее количество заказов",
                usedCouponAmount: "Сумма использованного купона",
                usedCouponCount: "Количество использованных купонов",
                tookDayFromLastOrder: "Дни с момента последнего заказа",
                isCouponUser: "Пользователь купона",
            },
            createAutomation: "Создать автоматизацию",
            previous: "Предыдущий",
            createAutomationDesc: "Создайте и управляйте автоматизацией сообщений",
            newTicimaxChannel: "Новый канал Ticimax",
            connextToTicimaxXml: "Подключиться к службе Ticimax XML",
            connectTicimax: "Подключиться к Ticimax",
            examplePreview: "Примерный просмотр",
            completeAutomationRule: "Завершите правило автоматизации",
            configureMessage: "Настройка сообщения",
            automationTimer: "Таймер автоматизации",
            findTargetMembers: "Найти целевых участников",
            createAutomationRule: "Создать правило автоматизации",
            action: "Действие",
            status: "Статус",
            triggeredUserCount: "Количество пользователей, сработавших",
            nextScheduled: "Следующее запланированное",
            timerRule: "Правило таймера",
            automationRules: "Правила автоматизации",
            apply: "Применить",
            searchAMember: "Поиск участника",
            segmentedMembersDesc: "Перечислите и автоматизируйте сегментированных участников",
            manageVisibilityDesc: "Управляйте видимостью канала",
            xmlOrderListURL: "URL списка заказов XML",
            manageIntegrationDesc: "Управляйте вашей интеграцией Ticimax",
            detail: "Подробности",
            ticimaxChannelsTitle: "Каналы Ticimax",
            ticimaxDetail: "Детали Ticimax",
            settingsGroup: "Настройки",
            visibility: "Видимость",
            members: "Участники",
            automation: "Автоматизация",
            integrationChannel: "Интеграционный канал",
            channelUpdated: "Канал успешно обновлен",
            channelUpdateFailed: "Ошибка обновления канала",
        },
        notification: {
            contactOwner: "Изменить владельца чата, назначить владельца и удалить владельца",
            mobileApp: "Мобильное приложение",
            webPanel: "Веб-панель",
            notifications: "Уведомления",
            whatsappActions: "Действия WhatsApp",
            chatbotActions: "Действия чатбота",
            companyActions: "Действия компании",
            crmActions: "Действия SUPSIS CRM",
            basicActions: "Основные действия",
            notificationSettingsDesc: "Выберите, какие уведомления вы хотите получать и где.",
            noNotificationDesc2:
                "Здесь вы увидите все уведомления, связанные с вакансиями, кандидатами и пулами талантов, которые вы отслеживаете. Вы можете настроить уведомления, изменив настройки.",
            noNotificationTitle2: "Пока нет уведомлений.",
            noNotificationTitle1: "Уведомлений нет. Наслаждайтесь тишиной.",
            adjustSettings: "Настроить параметры",
            showAll: "Показать все",
            showOnlyUnread: "Показать только непрочитанные",
            mailWasSent: "Письмо было отправлено.",
            mailAdressRemoved: "Email адрес был удален.",
            chatbotPublished: "Версия <b>{version}</b> чат-бота была опубликована пользователем <b>{user}</b>.",
            chatbotDeleted: "Чат-бот <b>{chatbot}</b> был удален пользователем <b>{user}</b>.",
            settingsUpdatedWoDetail: "Настройки были обновлены пользователем <b>{user}</b>.",
            noActivityDesc: "В настоящее время в системе нет активности. Несколько событий должны произойти",
            noActivityTitle: "Пока нет действий",
            actionType: "Тип действия",
            dateBetween: "Даты между",
            selectActor: "Выберите пользователя",
            activities: "Мероприятия",
            chatbotCreated: "Чат-бот с именем <b>{chatbot}</b> был создан пользователем <b>{user}</b>.",
            taskStageChanged:
                "Стадия задачи <b>{task}</b> была изменена с <b>{oldStage}</b> на <b>{newStage}</b> пользователем <b>{user}</b>.",
            taskCreated: "Задача <b>{task}</b> была создана пользователем <b>{user}</b>.",
            contactPropRemoved: "Свойство посетителя <b>{prop}</b> было удалено пользователем <b>{user}</b>.",
            contactPropAdded: "Свойство посетителя <b>{prop}</b> было добавлено пользователем <b>{user}</b>.",
            userRemoved: "Пользователь <b>{oldUser}</b> был удален пользователем <b>{user}</b>.",
            loginFormUpdated: "Форма входа посетителя была обновлена <b>{user}</b>.",
            loginFormDeactivated: "Форма входа пользователя была отключена <b>{user}</b>.",
            loginFormActivated: "Форма входа пользователя была активирована <b>{user}</b>.",
            invoiceRefunded: "Процесс возврата был осуществлен <b>{user}</b>.",
            paymentMethodAdded: "Новый способ оплаты был добавлен пользователем <b>{user}</b>.",
            invoicePaymentFailed: "Оплата счета не была принята пользователем <b>{user}</b>.",
            invoicePaymentReceived: "Оплата счета была принята пользователем <b>{user}</b>.",
            planStarted: "<b>{user}</b> Пользователь начал подписку <b>{title}</b> <b>({altTitle})</b>.",
            PlanCanceled: "<b>{user}</b> Пользователь отменил подписку <b>{title}</b> <b>({altTitle})</b>.",
            invoiceCreated: "Счет был создан пользователем <b>{user}</b>.",
            billingAddressUpdated: "Информация об адресе была обновлена пользователем <b>{user}</b>.",
            taskWorkflowDeleted: "Рабочий процесс <b>{workflow}</b> был удален пользователем <b>{user}</b>.",
            whatsappBroadcastFailed: "Отправка широковещательного сообщения с заголовком <b>{title}</b> не удалась.",
            whatsappBroadcastCancelled:
                "Отправка широковещательного сообщения с заголовком <b>{title}</b> была отменена.",
            whatsappBroadcastCompleted:
                "Широковещательное сообщение с заголовком <b>{title}</b> успешно отправлено <b>{numbers}</b> получателям.",
            whatsappBroadcastCreated:
                "Широковещательное сообщение с заголовком <b>{title}</b> было отправлено <b>{user}</b> <b>{numbers}</b> получателям.",
            ticketAssigned: "<b>{user1}</b> пользователям <b>{user2}</b> назначен билет.",
            userLoggedIn: "<b>{user}</b> вошел в систему SUPSIS.",
            chatJoined: "<b>{agent}</b>, <b>{visitor}</b> с чатом.",
            chatForwarded: "Чат с <b>{visitor}</b> был перенаправлен на <b>{agent}</b> от <b>{user}</b>.",
            chatAssigned: "Чат с <b>{visitor}</b> был назначен <b>{agent}</b> системой.",
            customerGroupUpdated: "Группа <b>{group}</b> была обновлена <b>{user}</b>.",
            customerGroupRemoved: "Группа <b>{group}</b> была удалена <b>{user}</b>.",
            customerGroupAdded: "Группа <b>{group}</b> была создана <b>{user}</b>.",
            contentRemoved: "Готовое содержимое <b>{content}</b> было удалено <b>{user}</b>.",
            contentAdded: "Готовое содержимое <b>{content}</b> было добавлено <b>{user}</b>.",
            channelVisibilityChanged:
                "Видимость интеграционного канала <b>{channel}</b> была изменена пользователем <b>{user}</b>.",
            taskDeleted: "Задача <b>{task}</b> была удалена пользователем <b>{user}</b>.",
            userRemovedToDepartment:
                "Пользователь <b>{user2}</b> удален из отдела <b>{department}</b> пользователем <b>{user1}</b>.",
            userAddedToDepartment:
                "Пользователь <b>{user2}</b> добавлен в отдел <b>{department}</b> пользователем <b>{user1}</b>.",
            mailAddressAdded: "<b>{email}</b> адрес электронной почты добавлен <b>{user}</b>",
            settingUpdate: "Обновлено <b>{user}</b>:",
            taskWFlowCreated: "Рабочий процесс <b>{Wflow}</b> создан пользователем <b>{user}</b>.",
            bannedWordRemoved: "Запрещенное слово <b>{bWord}</b> удалено пользователем <b>{user}</b>.",
            bannedWordCreated: "Запрещенное слово <b>{bWord}</b> создано пользователем <b>{user}</b>.",
            welcomeMessageRemoved: "Приветственное сообщение <b>{welcome}</b> удалено пользователем <b>{user}</b>.",
            welcomeMessageAdded: "Приветственное сообщение <b>{welcome}</b> создано <b>{user}</b>.",
            tagRemoved: "Тег <b>{tag}</b> удален <b>{user}</b>.",
            tagAdded: "Тег <b>{tag}</b> добавлен <b>{user}</b>.",
            roleRemoved: "Роль <b>{role}</b> удалена <b>{user}</b>.",
            roleAdded: "Роль <b>{role}</b> добавлена <b>{user}</b>.",
            departmentRemoved: "Отдел <b>{department}</b> удален <b>{user}</b>.",
            departmentAdded: "Отдел <b>{department}</b> добавлен <b>{user}</b>.",
            triggerUpdated: "Триггер обновлен <b>{user}</b>.",
            triggerRemoved: "Триггер удален <b>{user}</b>.",
            triggerAdded: "Новый триггер создан <b>{user}</b>.",
            webhookRemoved: "Webhook <b>{user1}</b>, удаленный <b>{user2}</b>",
            webhookAdded: "Webhook добавлен <b>{user1}</b>, добавлен <b>{user2}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> начал чат <b>{platform}</b> с <b>{visitor}</b>.",
            chatOpenedByVisitor: "Чат <b>{platform}</b> был начат <b>{visitor}</b>.",
            channelRemoved: "Канал <b>{channel}</b> был удален <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> создал представителя по имени <b>{newAgent}</b>.",
            visitorUnblocked: "Посетитель <b>{visitor}</b> разблокирован пользователем <b>{agent}</b>.",
            visitorBlocked: "Посетитель <b>{visitor}</b> заблокирован <b>{agent}</b>.",
            userStatusChanged: "Пользователь <b>{name}</b> изменил статус с <b>{oldStatus}</b> на <b>{newStatus}</b>.",
            channelCreated: "Канал <b>{channel}</b> создан пользователем <b>{name}</b>.",
            reservationCreatedPlan:
                "<b>{name}</b> пользователь запланировал встречу под названием <b>{title}</b> на <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> пользователь обновил встречу под названием <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> пользователь удалил встречу под названием <b>{title}</b>.",
            reservationCreated:
                "Бронь создана для пользователя <b>{name}</b> и посетителя <b>{visitor}</b> на <b>{date}</b>.",
            reservationDeleted:
                "Запланированная встреча между пользователем <b>{name}</b> и посетителем <b>{visitor}</b> на <b>{date}</b> отменена.",
            chatAssignedMe: "Когда чат назначен мне",
            ticketAssignedMe: "Когда мне назначен билет",
            taskAssignedMe: "Когда мне назначается задача",
            myChatClosed: "Когда закрывается чат, который я владею",
            tagActionsToVisitor: "Теги добавлены или удалены у контакта",
            ticketCreated:
                "Билет создан посетителем или чат-ботом. Также, когда отправлено автономное сообщение из виджета чата",
            notesActions: "Заметка была добавлена или удалена у клиента.",
            visitorProfileUpdated: "Профиль посетителя обновлен",
            chatStartedByAnyPlatform: "Чат запущен на любой платформе контактом или агентом",
            userActions: "Пользователь создан, обновлен или удален",
            departmentActions: "Отдел создан, обновлен или удален",
            settingsActions: "Настройки созданы, обновлены или удалены",
            integrationsActions: "Канал интеграции создан, обновлен или удален",
            loginFormActions: "Форма входа обновлена, активирована или деактивирована",
            bannedWordActions: "Запрещенное слово создано, обновлено или удалено",
            emailActions: "Учетная запись электронной почты создана или удалена",
            preparedContentActions: "Подготовленный контент создан или удален",
            roleActions: "Роль создана, обновлена или удалена",
            tagActions: "Метка создана, обновлена или удалена",
            welcomeMessageActions: "Приветственное сообщение создано, обновлено или удалено",
            chatOwnerUpdated: "<b>{agent}</b> переназначил <b>{visitor}</b> от <b>{oldOwner}</b> к <b>{newOwner}</b>.",
            customerOwnershipRemoved:
                "<b>{actor}</b> удалил право собственности на <b>{visitor}</b> у <b>{oldOwner}</b>, оставив его без владельца.",
            customerOwnershipAssigned:
                "<b>{actor}</b> назначил право собственности на <b>{visitor}</b> от без владельца к <b>{newOwner}</b>.",
            customerOwnershipReassigned:
                "<b>{actor}</b> переназначил право собственности на <b>{visitor}</b> от <b>{oldOwner}</b> к <b>{newOwner}</b>.",
            webhookActions: "Webhook создан, обновлен или удален",
            billingEvents: "События биллинга",
            workflowCreated: "Когда создаётся рабочий процесс",
            workflowDeleted: "Когда рабочий процесс удаляется",
            createdTask: "Когда создается задача.",
            taskStatusChanged: "Когда изменяется статус задачи",
            deletedTask: "Когда задача удаляется",
            taskWorkflowCrud: "Рабочий процесс задачи создан, обновлен или удален",
            taskCrud: "Задача создана, обновлена или удалена",
            systemStatus: "Изменения статуса системы онлайн или офлайн",
            chatbotStoryCrud: "История чатбота создана, обновлена или удалена",
            chatbotForwardAgent: "Чатбот перенаправляет чат агенту",
            userSegmentCrud: "Сегмент пользователя создан, обновлен или удален",
            chatbotCreditLow: "Когда кредит чатбота низок",
            wpCreditLow: "Когда кредит Whatsapp низкий",
            wpCustomerGroupCrud: "Когда создается, обновляется или удаляется группа клиентов WhatsApp",
            wpBroadcastMessageStatus:
                "Когда отправляется, завершается или отменяется широковещательное сообщение WhatsApp",
            wpTemplateMesssageCrud: "Когда создается, обновляется или удаляется шаблонное сообщение WhatsApp",
            reservationMessageCrud: "Резервирование создано, обновлено, отменено",
        },
        search: {
            prefix: {
                jump: "Git",
                new: "Новый",
                visitor: "Человек",
                dm: "DM",
                chatbot: "чат-бот",
                automation: "автоматизация",
                table: "стол",
                module: "модуль",
                message: "сообщение",
            },
            calendar: "Календарь",
            soundSettings: "Аудиоуведомления",
            allNotificationSettings: "Настройки уведомлений",
            allAuditLogs: "Журналы аудита",
            allNotifications: "Все уведомления",
            allActivities: "Все действия",
            workFlow: "Рабочий процесс",
            editTask: "Редактировать задачу",
            tasks: "Задачи",
            todo: "Дела, которые нужно сделать",
            tapTo: 'Нажмите ⇥ для операций "{префикс}"',
            newUsers: "Новый ⇥ пользователь",
            newTags: "Новый ⇥ тег",
            newRole: "Новая ⇥ роль",
            newTrigger: "Новый ⇥ триггер",
            newDepartment: "Новый ⇥ департамент",
            newTicket: "Новая ⇥ метка",
            jumpSettings: "Перейти ⇥ настройки",
            jumpIntegrations: "Перейти ⇥ интеграции",
            jumpTeam: "Перейти ⇥ команда",
            jumpUsers: "Перейти ⇥ пользователи",
            jumpReport: "Перейти ⇥ отчет",
            timingSettings: "Настройки времени",
            exampleVisitorMail: "Посетитель@mail.com",
            languageAndRegion: "Язык и регион",
            theme: "Тема",
            appearance: "Внешний вид",
            color: "Цвет",
            background: "Фон",
            smart: "Умный",
            teamChat: "Командный чат",
            chatbot: "Чатбот",
            chatbotTraining: "Обучение чатбота",
            chatbotUserSegments: "Сегменты пользователей чатбота",
            chatbotIntegration: "Интеграция чатбота",
            chatbotEntities: "Сущности чатбота",
            chatbotIntegrationWebHook: "Интеграция вебхука чатбота",
            chatbotArchive: "Архив чатбота",
            chatbotTemplatesAI: "Шаблоны ИИ чатбота",
            chatbotTemplates: "Шаблоны чатботов",
            chatbotReportsOverall: "Общие отчеты чатбота",
            chatbotReportsAllChats: "Отчеты чатбота по всем чатам",
            chatbotReportsRatingDistribution: "Распределение рейтинга отчетов чатбота",
            chatbotReportsPaidChats: "Отчеты чатбота о платных чатах",
            chatbotReportsBusiestPeriod: "Период наибольшей загруженности чатбота",
            chatbotTemplatesAllMessages: "Шаблоны чатбота для всех сообщений",
            chatbotTemplatesAverage: "Среднее значение шаблонов чатбота",
            chatbotTemplatesPopularity: "Популярность шаблонов чатботов",
            chatbotTemplatesAllUser: "Шаблоны чатботов для всех пользователей",
            ticket: "Запросы в службу поддержки",
            archives: "Архив",
            tags: "Теги",
            offlineSupportRequests: "Запросы поддержки в офлайн-режиме",
            roles: "Роли",
            users: "Пользователи",
            departments: "Департаменты",
            content: "Мгновенное содержание",
            welcomeMessages: "Системные сообщения",
            catalog: "Каталог",
            bannedWords: "Запрещенные слова",
            bannedVisitors: "Запрещенные посетители",
            application: "Приложение",
            emails: "Почта",
            visitors: "Посетители",
            integrationsWebhook: "Интеграция Webhook",
            billing: "Счет-фактура",
            reportNew: "Новый отчет",
            integrations: "Интеграции",
            chatbotStory: "Истории чатботов",
            searchPlaceHolder: "Найти, перейти или добавить...",
            searchAreaTitle: "Поиск Supsis",
            searchAreaDesc1: "Вы можете искать что угодно. Только",
            searchAreaDesc2: "или",
            searchAreaDesc3: "введите или ищите что угодно",
            navigateBtn: "Перемещаться",
            selectBtn: "Выбрать",
            cancelBtn: "Отменить",
            integration: {
                shouldByInstaPack:
                    "Вы должны купить Instagram-пакет для создания Instagram-канала. Вы можете сразу приобрести пакеты по доступным ценам.",
                createInstaLimitMax: "Вы достигли лимита создания канала Instagram. Максимум",
                createInstaContinue:
                    "Вы можете создать канал Instagram. Чтобы продолжить, обновите свой пакет или удалите некоторые из ваших Instagram-каналов.",
                privatePolicy: "Частная политика",
                termsAndCondition: "Условия и положения",
                readAndAgree: "Я прочитал и согласен",
                shouldByMessengerPack:
                    "Для создания канала в Messenger необходимо приобрести пакет Messenger. Вы можете получить пакеты по доступным ценам прямо сейчас.",
                createMessengerLimitMax: "Вы достигли предела создания канала Messenger. Максимум",
                createMessengerContinue:
                    "Вы можете создать канал Messenger. Чтобы продолжить, обновите свой пакет или удалите некоторые из ваших каналов Messenger.",
                selectMessengerAccount: "Выберите аккаунт Messenger",
                forwardLiveAgents: "👉 Forward Live Agents",
                allDepartments: "Все отделы",
                deleteAll: "Удалить все",
                wpBusinessAPI: "Интеграции - Whatsapp Business API каналы",
                wpV1: "Интеграции - Мульти Whatsapp каналы",
                instagram: "Интеграции - Instagram",
                instagramContactList: "Интеграции - Список контактов Instagram",
                mail: "Интеграции - Почта",
                whatsapp: "Интеграции - Whatsapp",
                whatsappContactList: "Интеграции - Список контактов Whatsapp",
                wpBCRequests: "Интеграции - Запросы массовых сообщений Whatsapp",
                wpBCCustomerGroups: "Интеграции - Группы клиентов Whatsapp в массовом формате",
                wpBCTemplates: "Интеграции - Шаблоны массовых сообщений Whatsapp",
                chatbot: "Интеграции - ChatBot",
            },
            settings: {
                settings: "Настройки",
                features: "Настройки - Особенности",
                languageAndRegion: "Настройки - Язык и регион",
                bubbleSettings: "Настройки - Настройки пузырьков",
                bubbleActions: "Настройки - Действия пузырька",
                themeSettings: "Настройки - Настройки темы",
                visitorLoginForm: "Настройки - Форма входа посетителя",
                talkSettings: "Настройки - Настройки чата",
                visitorAttribute: "Настройки - Атрибуты посетителя",
                autoAssign: "Настройки - Автоназначение",
                chatTimingSettings: "Настройки - Настройки времени чата",
                availability: "Настройки - Доступность",
                websiteIntegration: "Настройки - Интеграция сайта",
                developer: "Настройки - Разработчик",
            },
        },
        mail: {
            broadcastCreatedSuccess: "Трансляция успешно создана",
            confirmArchive: "Вы уверены, что хотите архивировать эту трансляцию?",
            archive: "Архивировать",
            cancel: "Отмена",
            archiveSuccess: "Трансляция успешно архивирована",
            archiveError: "Ошибка при архивировании трансляции",
            empty: "Пусто",
            summerDiscounts: "Летние скидки",
            opportunities: "Возможности",
            newMailTemplateCreated: "Создать новый шаблон электронной почты",
            dateRange: "Диапазон дат",
            templateName: "Имя шаблона",
            category: "Категория",
            templateUpdateSucs: "Шаблон был успешно обновлен.",
            templateUpdateError: "При обновлении шаблона произошла ошибка.",
            marketing: "Маркетинг",
            operational: "Оперативный",
            custom: "Special",
            pleaseEnterTemplateName: "Пожалуйста, введите название шаблона",
            pleaseEnterTemplateSubject: "Пожалуйста, введите тему шаблона",
            pleaseSelectTemplateCategories: "Пожалуйста, выберите категорию шаблона",
            representMails: "Представительские письма",
            otherRepresentMails:
                "Вы можете отслеживать входящие и исходящие сообщения электронной почты на адреса электронной почты других представителей и с них",
            signatureAutoAdd: "Статус автоматического добавления подписи успешно изменен",
            autoAdd: "Автоматическое добавление",
            forwardEmailAddSucs: "Адрес переадресованной электронной почты успешно добавлен",
            errorAddingForwardEmail: "При добавлении переадресованного адреса электронной почты произошла ошибка.",
            mailAddForward: "Ручное добавление (пересылка завершена)",
            mailAddForwarding: "Ручное добавление (пересылка завершена)",
            broadcast: "Публикации",
            templates: "Шаблоны",
            newMailArrived: "Пришло новое письмо",
            mailSentSucs: "Почта отправлена успешно",
            representativeMails: "Представительская почта",
            composeNewEmail: "Составить новое письмо",
            couldNotUserMail: "Не удалось отправить почту из-за отсутствия пользовательской почты",
            mailAddressReq: "Требуется почтовый адрес.",
            emailAddressInvalid: "Почтовый адрес недействителен",
            departmentIsNotValid: "Отдел недействителен",
            mailSendNotValid: "Почтовый адрес недействителен",
            routingSteps: "Шаги маршрутизации",
            owner: "Владелец",
            whereHeDirected: "Where He Directed",
            forwardingEmailAddress: "Адрес электронной почты для пересылки",
            deleteMailDesc: "Это действие нельзя отменить.",
            deleteMailTitle: "Вы уверены, что хотите удалить этот адрес электронной почты?",
            gmailForwardMail: "Пересылка почты Gmail",
            senderMailAddressDesc: "Пожалуйста, введите адрес электронной почты отправителя",
            verified: "Подтверждено",
            notForwarded: "Не переадресовано",
            notVerified: "Не подтверждено",
            default: "По умолчанию",
            isVerified: "Проверенный",
            forwarding: "Переадресация",
            mailAdress: "Адрес электронной почты",
            addSenderAddress: "Добавить адрес отправителя",
            outlookForward: "Microsoft (Outlook/Exchange) Переадресация",
            gmailForward: "Google (Gmail) Переадресация",
            senderMail: "Адрес отправителя",
            mailDetail: "Детали письма",
            mailNotFound: "Почта не найдена",
            mailSelecting: "Выбор почты",
            newMail: "Новое письмо",
            myMails: "Мои письма",
            inbox: "Входящие",
            sent: "Отправленные",
            departmentMails: "Электронные письма отдела",
            newTemplate: "Новый шаблон",
            unread: "Непрочитанный",
            unreply: "Unanswered",
            reply: "Ответить",
            attachments: "Вложения в письме",
            To: "Кому",
            From: "От кого",
            placeHolders: "Заменители",
            attacheFiles: "Прикрепить файлы",
            replyAll: "Ответить всем",
            forward: "Переслать",
            deleteThread: "Удалить беседу",
            markAsRead: "Отметить как прочитанное",
            markAsAllRead: "Пометить все как прочитанные",
            emailEditor: "Редактор электронной почты",
            integrateYourMail: "Интегрируйте свою почту",
            connect: "Подключить",
            departmentMail: "Почта отдела",
            createMailAddress: "Создать почтовый адрес",
            createNewMail: "Создать новое письмо",
        },
        visitor: {
            downloadAll: "Скачать все",
            saveAsCustomerGroup: "Сохранить как группу клиентов",
            saveSearchFavorite: "Сохранить поиск как избранный",
            mail: "Почта",
            visitorDetail: "Детали посетителя",
            selectedUser: "Выбрано {selectedUser} из {totalUsers} пользователей",
            uncheck: "Снять все отметки",
            checkAll: "Отметить все",
            matchedUsers: "Совпадение с {checkedCount} пользователями",
            more: "Больше",
            exportUsers: "Экспортировать выбранных пользователей",
            exportAllUsers: "Экспортировать всех пользователей",
            addSegment: "Добавить сегмент",
            deleteCheckedUser: "Удалить выбранных пользователей",
            deleteAllUser: "Удалить всех пользователей",
            matchedFilter: "Совпадение всех фильтров",
            visitor: "Посетитель",
            deleteUser: "Удалить пользователя",
            userData: "Данные пользователя",
            lastSession: "Последняя сессия",
            notUserData: "Данные пользователя не найдены",
            segments: "Сегменты",
            tags: "Теги",
            addTag: "Добавить тег",
            userChats: "Чаты с пользователем",
            seeAll: "Показать все",
            confirm: "Подтвердить",
            manageSegments: "Управление сегментами",
            search: "Поиск",
            manageTags: "Управление тегами",
            allAttributes: "Показать все атрибуты",
            noData: "Нет данных",
            noEmail: "Нет электронной почты",
            noIpAddress: "IP адрес не найден.",
            noWpNumber: "Номер не найден.",
            filterName: "имя фильтра..",
            matchedContacts: "{chechkedCount} контакты совпадают",
        },
        chatbotv2: {
            typeStoryTitle: "Напишите название рассказа",
            setUpYourChatbot: "Настройте свой чатбот",
            setUpYourChatbotDesc:
                "Обучите своего чатбота с помощью данных, используйте наши готовые шаблоны или начните с нуля",
            blankBot: "Пустой бот",
            blankBotDesc: "Создайте пустой чатбот, который вы сможете обучить и настроить позже",
            websiteDesc:
                "Сканируйте содержимое вашего сайта, чтобы получить ответы на популярные вопросы пользователей.",
            yourNeedEnterYourOpenAi:
                "Вам нужно ввести свой ключ API OpenAI, чтобы создать автоматизированный чатбот, просканировав ваш сайт.",
            createOpenAiKey: "Создать ключ Api",
            aiKnowledge: "Знания об искусственном интеллекте",
            modalUsage: "Модальное использование",
            usedContentSources: "Используемые источники контента",
            websites: "Веб-сайты",
            articles: "Статьи",
            faq: "FAQ",
            files: "Файлы",
            functions: "Функции",
            settings: "Настройки",
            disableAi: "Отключить искусственный интеллект",
            enableAi: "Включить искусственный интеллект",
            lastEdited: "Последнее редактирование",
            state: "Состояние",
            frequentlyAskedQuestions: "Часто задаваемые вопросы (FAQ)",
            faqIsCreated: "FAQ создан",
            selectKnowEnabled: "Включение выбранных баз знаний...",
            selectKnowDisabled: "Выбранные базы знаний отключены...",
            selectKnowNotEnabled: "Выбранные базы знаний не включены...",
            selectKnowNotDisabled: "Выбранные базы знаний не отключены",
            answered: "Answered",
            answer: "Ответ",
            addFile: "Добавить файл",
            fileDeleted: "Файлы удалены",
            fileDeletedFailed: "Возникла проблема с удалением файлов",
            noFileAdded: "Файл не добавлен",
            aiFunctions: "Функции искусственного интеллекта",
            addFunction: "Добавить функцию",
            parameterCount: "Количество параметров",
            auto: "Авто",
            usedByAI: "Используется ИИ",
            addWebhook: "Добавить веб-крючок",
            usedByAi: "Используется искусственным интеллектом",
            notUsed: "Не используется",
            saveAndClose: "Сохранить и закрыть",
            contentPreview: "Предварительный просмотр содержимого",
            addContent: "Добавить содержимое",
            populerUserQuestion:
                "Сканирование содержимого вашего сайта для получения ответов на популярные вопросы пользователей",
            enterUrlAddress: "Введите URL-адрес",
            sharingYourUrl:
                "Предоставляя свой URL-адрес, вы подтверждаете, что обладаете необходимыми правами, чтобы делиться его содержимым.",
            pageSelected: "Выбранные страницы",
            trainChatbot: "Обучить чатбота",
            thereAreOnePages: "Внутри находится 1 страница",
            categoryDesc: "Категория. Выберите, какую из них использовать для обучения вашей модели ИИ.",
            scarpOrAddContent:
                "Сокращайте или добавляйте контент, который AI Assist может использовать для ответа на запросы ваших клиентов.",
            noContentAdded: "Содержание не добавлено",
            howItWorks: "Как это работает",
            editEntries: "Редактировать записи",
            newEntries: "Новые поступления",
            chatbotManagement: "Управление чатбото",
            chatbotScenarioList: "Список чатботов Шенерио",
            exportDiagramToClipboard: "Экспорт диаграммы в буфер обмена",
            selectedStory: "{count} сценарий выбран",
            Instagram_Actions: "Instagram Actions",
            suppressionRemoved: "Ограничение удалено",
            suppressionAdded: "Ограничение добавлено",
            didntSuppression: "Вы не сделали никаких ограничений.",
            whatsappIntegrationTitle: "WhatsApp V1 и WhatsApp V2 Интеграция",
            whatsappApiIntegrationTitle: "Интеграция WhatsApp Business API",
            ReadyTemplateBadge: "Готовый шаблон",
            readyTemplates: "Готовые шаблоны",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Логотип чатбота",
            chatbotName: "Имя чатбота",
            allSecnario: "Список сценариев чат-бота",
            ChatbotScenarioList: "Список сценариев чат-бота",
            Scenario: "Сценарий",
            filters: {
                equal: "равно",
                not_equal: "не равно",
                contain: "содержать",
                not_contain: "не содержать",
                starts_with: "начинается с",
                ends_with: "начинается с",
                empty: "пустой",
                non_empty: "не пустой",
                longer_than: "длиннее чем",
                shorter_than: "короче чем",
                less_than: "меньше, чем",
                less_or_equal: "меньше или равно",
                greater_than: "лучше чем",
                greater_or_equal: "больше или равно",
            },
            planRequired: "{integratable} Требуется план",
            noDefaultStoryTitle: "История по умолчанию",
            noDefaultStory: "Нет истории по умолчанию.\nХотите сделать эту историю по умолчанию?",
            noMessage: "Нет сообщений",
            loading: "Загрузка",
            loadMore: "Загрузи больше",
            hostname: "имя хоста",
            goToStory: "перейти к истории",
            noResultFound: "результатов не найдено",
            checkYourFilterCombination: "Проверьте комбинацию фильтров",
            clearYourSearch: "очистите свой поиск",
            andTryAgain: "и попробуй еще раз",
            withBot: "& бот",
            userWithBot: "Пользователь & бот",
            chatDetail: "Детали чата",
            allUserDetail: "Посмотреть все данные о пользователе",
            sessionData: "Данные сеанса",
            supsisChatWidget: "Виджет Supsis Chat",
            integratedWith: "Интегрировано с : ",
            botStory: "История бота",
            integration: "Интеграции",
            Users: "пользователи",
            user_id: "ID пользователя",
            allTemplates: "Все шаблоны",
            allAITemplates: "Все шаблоны ИИ",
            templatesFromTheIndustry: "Шаблоны из отрасли",
            basicTemplate: "Базовый шаблон",
            proTemplate: "Расширенный шаблон",
            categories: "Категории",
            worksWith: "Работает с",
            importBot: "Импорт бота",
            keyFeatures: "Ключевая особенность",
            importing: "импорт",
            comingSoon: "Вскоре",
            cardInfos: "информация о карте",
            pickStory: "Выбери историю",
            conversationId: "Идентификатор беседы",
            integrateStoryWithSupsisWidget: "Интегрируйте виджет Supsis с историей чат-бота",
            integrateStoryWithWhatsapp: "Интегрируйте WhatsApp с историей чат-бота",
            integrateStoryWithInstagram: "Интегрируйте Instagram с историей чат-бота",
            selectIntegratingStory: "Выберите историю, которая будет интегрирована",
            install: "Установить",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "Эл. адрес",
                phone: "Phone",
                language: "Язык",
                timezone: "Часовой пояс",
                gender: "Пол",
                country: "Страна",
                department: "Отдел",
                referrer: "Реферер",
                url: "URL-адрес",
                ip: "IP",
                last_seen: "Last Видимый",
                name: "Имя",
                user_id: "ID пользователя",
                message: "Message",
                akinon_brand: "Бренд",
                akinon_order_id: "Номер заказа",
                akinon_product_id: "Код товара",
                akinon_user_id: "ID пользователя",
                akinon_user_name: "Имя пользователя",
                akinon_user_email: "Электронная почта пользователя",
                akinon_invoice_url: "URL счета",
                akinon_order_status: "Статус заказа",
                akinon_order_price: "Стоимость заказа",
                akinon_shipper_name: "Имя грузоотправителя",
                akinon_product_size: "Размер товара",
                akinon_sku: "Артикул",
                akinon_product_url: "URL продукта",
                akinon_product_title: "Название продукта",
                akinon_product_image: "Изображение продукта",
                akinon_product_stock: "Товарный запас",
                akinon_order_date: "Дата заказа",
                akinon_track_number: "Номер дорожки",
                akinon_track_url: "URL отслеживания",
                akinon_latitude: "Широта",
                akinon_longitude: "Долгота",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                visitor_trigger_type: "Тип триггера посетителя",
                visitor_trigger_name: "Имя триггера посетителя",
                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "Автономный режим",
                available_agents: "Доступные представитель",
                probel_sube_kodu: "Код филиала",
                probel_brans_adi: "Название отделения",
                probel_brans_kodu: "Код отделения",
                probel_doktor_adi: "Имя врача",
                probel_doktor_kodu: "Код врача",
                probel_poliklinik_adi: "Название поликлиники",
                probel_poliklinik_kodu: "Код поликлиники",
                probel_randevu_tarihi: "Дата записи",
                probel_date: "Дата записи",
                probel_randevu_saati: "Время записи",
                probel_randevu_id: "ID записи",
                probel_hasta_token: "Токен пациента",
                probel_kimlik_tipi: "Тип удостоверения личности",
                probel_kimlik_no: "Номер удостоверения личности",
                probel_hasta_adi: "Имя пациента",
                probel_hasta_soyadi: "Фамилия пациента",
                probel_hasta_cinsiyet: "Пол",
                probel_hasta_dogum_tarihi: "Дата рождения",
                probel_hasta_telefon: "Телефон",
                platform: "Платформа",
                hour: "Час",
                segments: "Segments",
                tags: "Теги",
                ticket: "билет",
                metaReferrals: "Мета-рефералы",
            },
            storyList: "Список историй",
            douYouWannaDeleteItem: "Вы хотите удалить этот элемент?",
            douYouWannaDeleteWithChildren: "Вы хотите удалить этот элемент вместе с его дочерними элементами?",
            stories: "Рассказы",
            templates: "Шаблоны",
            aitemplates: "Шаблоны ИИ",
            integrations: "Интеграции",
            all: "Все",
            installed: "Установлены",
            installationOK: "установлены",
            uninstall: "Удалить",
            remainingMessageDesc: "Осталось бесплатных сообщений : ",
            openAISiteRoutingDescStart: "Вы можете щелкнуть ссылку ",
            openAISiteRoutingDescEnd: " чтобы получить ключ API.",
            integrationOK: "Интегрированный",
            chatWidget: "Supsis Виджет чата",
            artificialIntelligence: "Искусственный интеллект",
            integratePlatform: "Чат-бот может быть интегрирован с {integretable}.",
            integrateOpenAIWithChatbot: "Интеграция чата GPT-4 с чат-ботом",
            integrateChatBotWithChatGPT3: "Интеграция ChatBot с Chat GPT-4",
            integrateStoryWithTelegram: "История интеграции с Telegram",
            webhooks: "вебхуки",
            archive: "Архив",
            reports: "Отчеты",
            uncheckAll: "Снять все",
            userSegments: "Сегменты пользователей",
            addSegment: "Добавить сегмент",
            addToSegment: "Add To Segment",
            removeFromSegment: "Remove From Segment",
            plansVTippyContent:
                "Оплата за этот пакет будет производиться в начале каждого месяца, и в случае отмены ваше использование будет оплачено до начала месяца, и ваш пакет истечет.<br><br>Цена пакета не включает НДС.<br><br>Изменения в пакете отражаются в счете на следующий день.",
            segmentName: "Название сегмента",
            sameSegment: "Существует сегмент с таким же названием!",
            usersInSegment: "Пользователы в сегменте",
            noUsersAdded: "Пользователи не добавлены",
            updateSegment: "Обновить сегмент",
            newSegment: "Новый сегмент",
            selectAll: "Выбрать все",
            queriesSelected: "выбранные запросы",
            noBlocksFound: "Блоки не найдены!",
            userQuery: "Пользовательский запрос",
            date: "Свидание",
            unmatched: "Бесподобный",
            goToChat: "Перейти в чат",
            selectStory: "Выберите историю",
            selectBlock: "Выберите блок",
            training: "Подготовка",
            trainingAlert:
                "Для внедрения изменений, которые вы внесли на странице обучения бота, вам необходимо опубликовать новую версию сценария, который вы изменили",
            unmatchedPhrases: "Непревзойденные фразы",
            ignored: "Игнорируется",
            story: "История",
            timePeriod: "Временной период",
            wholeTimeSpan: "Весь промежуток времени",
            selectAStory: "Выберите историю",
            searchUserQuery: "Поисковый запрос пользователя",
            time: {
                today: "Сегодня",
                yesterday: "Вчерашний день",
                last7: "Последние 7 дней",
                last30: "Последние 30 дней",
                "this-month": "Этот месяц",
                "last-month": "Прошлый месяц",
                "last-3-month": "Последние 3 месяца",
                "this-year": "В этом году",
                "last-year": "Прошедший год",
                custom: "Выберите другую дату",
            },
            emailProvider: "Провайдер электронной почты",
            triggerFromAnywhere: "Запуск из любого места",
            editBlock: "Редактировать",
            moveBlock: "Шаг",
            copyBlock: "Копировать",
            chatbot: "чат-бот",
            addFilter: "Добавить фильтр",
            addFilterGroup: "Добавить группу фильтров",
            clearFilter: "прозрачный фильтр",
            in: "в",
            and: "а также",
            or: "вейя",
            allStories: "Все истории",
            addBot: "Добавить бота",
            testBot: "Протестируйте бота",
            publish: "Публиковать",
            editName: "Редактировать название",
            search: "Найдите в своей истории…",
            typeMoreThan3Char: "Введите не менее 3 символов",
            expand: "Расширять",
            expandAll: "Расширять все",
            noMatchingItem: "Нет подходящего товара",
            hint: "Намекать",
            select: "Выбрать",
            navigate: "Навигация",
            dismiss: "Увольнять",
            choseAttribute: "Выберите тип атрибута",
            selectReply: "Выберите тип ответа",
            preview: "Предварительный просмотр",
            draft: "Черновик",
            lastUpdate: "Последнее обновление",
            published: "Опубликовано",
            newStory: "Новая история",
            updateStory: "Обновить историю",
            storyDescription: "Описание истории",
            storyTitle: "Название рассказа",
            deleteSingleBlock: "Удалить отдельный блок",
            deleteWithChildren: "Удалить с детьми",
            startTestFromHere: "Start Test From Here",
            copyBlockId: "Copy Block Id",
            gotoLiveLink: "Go to Live Link",
            copyBlockIdSuccessfull: "Block Id copied to clipboard",
            collapse: "Свернуть",
            collapseAll: "Свернуть все",
            snDelay: "{delay} сек задержка",
            blockUpdated: "Блок обновлен",
            addPayload: "Добавить полезную нагрузку",
            previewModeCaution:
                "Сейчас вы просматриваете одну из версий вашей истории. Вы не можете сохранить изменения в режиме предварительного просмотра!",
            enterText: "Введите текст...",
            trackpad: "Трекпад",
            navigation: "Навигация",
            navigationDesc: "Пожалуйста, выберите режим навигации. Вам решать, будет ли это трекпад или мышь.",
            botSetting: "Настройка бота",
            botSettingDesc:
                "Пожалуйста, определите уровень доверия. Это процент от 0 до 100. Уровень определяет правильность интерпретаций чат-ботов, связанных с вводом данных пользователем.",
            languageSettingsDesc:
                "Пожалуйста, убедитесь, что язык бота, на который он отвечает, является вашим предпочтительным языком.",
            mouse: "мышь",
            Interactions: "Взаимодействия",
            Actions: "Действия",
            Supsis_Actions: "Supsis Действия",
            Shopify_Actions: "Shopify Действия",
            Akinon_Actions: "Akinon Действия",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "ТОЧКА ОТСЧЕТА",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "ОТВЕТ БОТА",
            AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "ВОЗВРАТ ПО УМОЛЧАНИЮ",
            FILTER: "ФИЛЬТР",
            addNewFilter: "Добавить новый фильтр",
            FLOW: "ПОТОК",
            ATTACHMENT_INPUT: "ПРИЛОЖЕНИЕ ВВОД",
            USER_INPUT: "ВВОД ПОЛЬЗОВАТЕЛЯ",
            GO_TO_STEP: "ПЕРЕЙТИ К ШАГУ",
            WEBHOOK: "ВЕБХУК",
            SET_ATTRIBUTE: "УСТАНОВИТЬ АТРИБУТ",
            QUESTION: "ВОПРОС",
            CLOSE_CHAT: "ЗАКРЫТЬ ЧАТ",
            CREATE_TICKET: "СОЗДАТЬ ЗАЯВКУ",
            TRANSFER_CHAT: "ТРАНСФЕРНЫЙ ЧАТ",
            TICKET_UPDATE: "ОБНОВЛЕННЫЙ TICKET",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "УСТАНОВИТЬ ОТДЕЛ",
            SEND_TRANSCRIPT: "ОТПРАВИТЬ ЗАПИСЬ",
            SEND_SMS: "SEND SMS",
            SEND_MAIL: "SEND MAIL",
            CREATE_EVENT: "CREATE EVENT",
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            RESERVATION_SELECT_TIME: "Select reservation time",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "ПОКУПАТЬ ПОКАЗАТЬ ПРОДУКЦИЮ",
            SHOPIFY_PRODUCT_AVAILABILITY: "ПОКУПАЙТЕ НАЛИЧИЕ ПРОДУКТА",
            SHOPIFY_ORDER_STATUS: "ПОКУПАТЬ СТАТУС ЗАКАЗА",
            AKINON_SHOW_PRODUCTS: "АКИНОН ПОКАЗАТЬ ПРОДУКТЫ",
            AKINON_FIND_PRODUCT: "AKINON FIND PRODUCT",
            AKINON_ORDER_STATUS: "АКИНОН СТАТУС ЗАКАЗА",
            AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
            AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
            AKINON_FIND_NEAREST_STOCK: "SHOW STORE STOCK",
            AKINON_FIND_NEAREST_STORES: "SHOW NEAREST STORES",
            AKINON_SHOW_DISCOUNT_CODES: "SHOW DISCOUNT CODES",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            INSTAGRAM_COMMENT_REPLY: "ОТВЕТИТЬ НА КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_DELETE: "УДАЛИТЬ КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_SHOW: "ПОКАЗАТЬ КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_HIDE: "СКРЫТЬ КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "ОТВЕТИТЬ В ЛИЧНЫХ СООБЩЕНИЯХ",
            followingAttributesFilled: "Будут заполнены следующие атрибуты.",
            GET_LOCATION: "GET LOCATION",
            FALLBACK: "ОТСТУПАТЬ",
            SUCCESS: "УСПЕХ",
            FAILURE: "ОТКАЗ",

            message: "сообщение",
            condition: "условие",
            score: "счет",
            equal: "равный",
            not_equal: "не равный",
            contain: "содержать",
            not_contain: "не содержать",
            starts_with: "начинается с",
            ends_with: "заканчивается",
            empty: "пустой",
            longer_than: "длиннее чем",
            shorter_than: "короче чем",
            less_than: "меньше, чем",
            less_than_equal: "меньше, чем равно",
            greater_than: "лучше чем",
            greater_than_equal: "больше, чем равно",
            value: "ценность",
            failures: "неудачи",
            email: "Эл. адрес",
            name: "имя",
            username: "имя пользователя",
            source: "источник",
            language: "язык",
            timezone: "часовой пояс",
            region: "область, край",
            country: "страна",
            referrer: "реферер",
            url: "URL",
            ip: "IP",
            city: "город",
            lastSeen: "последний раз видели",
            userId: "ID пользователя",
            selectStep: "выберите шаг",
            keywords: "ключевые слова",
            userSays: "пользователи говорят",
            addKeyword: "Добавить слово",
            addUserMessage: "аддусермессаже",
            set: "установлен",
            to: "к",
            gender: "Пол",

            go_to_failure: "Идти к провалу",
            go_to_success: "Идти к успеху",
            untilFilled: "До заполнения",
            time1: "однажды",
            time2: "время 2",
            time3: "время 3",
            time4: "время 4",
            time5: "время 5",
            any: "Любые",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "буквенно-цифровой",
            integer: "Целое число",
            no: "Нет",
            number: "Число",
            phone: "Телефон",
            yes: "Да",
            yesNo: "Да нет",
            anyDescription: "Соответствует всему, что не пусто.",
            alphanumericDescription: "Соответствует буквам и цифрам.",
            integerDescription: "Соответствует целому числу.",
            noDescription: "Нет синонимов.",
            numberDescription: "Соответствует порядковому и количественному числительному.",
            phoneDescription: "Соответствует номеру телефона.",
            yesDescription: "Соответствует да синонимам.",
            yesNoDescription: "Соответствует синонимам 'да' и 'нет'.",
            emailDescription: "Соответствует электронной почте.",
            urlDescription: "Соответствует URL.",
            temperature: "Температура",
            askWhenInvalid: "спросить, когда недействительно",

            applyFilter: "Применение фильтра",
            RANDOM_TEXT: "Случайный текст",
            QUICK_REPLY: "Быстрый ответ",
            FILE: "File",
            notificationMessageStartSuccess: "Блокировать ",
            notificationMessageEndSuccess: " Добавлен",
            notificationMessageStartError: "Произошла ошибка, заблокируйте ",
            notificationMessageEndError: " не удалось добавить",
            blockChangedWannaUpdate: "Я хочу изменить обновление",
            responses: "Ответы",
            TEXT: "текст",
            IMAGE: "Изображение",
            GALLERY: "Галерея",
            BUTTON: "Кнопка",
            flow: "Поток",
            active: "активный",
            passive: "пассивный",

            chooseAttributeType: "Выберите тип функции",
            imageAttachment: "Вложение изображения",
            audioAttachment: "Аудио вложение",
            videoAttachment: "Видео вложение",
            documentAttachment: "Приложение к документу",
            anyAttachment: "Любое вложение",
            typeAttributeValue: "Тип Атрибут Значение",
            typeSearchValue: "Введите значение поиска",
            male: "мужчина",
            addAttribute: "Добавить атрибут",
            addAttributeDescription:
                "Имя атрибута может содержать только буквенно-цифровые символы, такие как буквы A-Z, цифры 0-9, тире или подчеркивание.",
            USER_DATA: "информация о пользователе",
            CUSTOM_ATTRIBUTES: "ПОЛЬЗОВАТЕЛЬСКИЕ АТРИБУТЫ",
            enterBotResponseHere: "Введите ответ бота здесь...",

            addCard: "Добавить карту",
            addButton: "Добавить кнопку",
            typeCardTitle: "Заголовок типа этажа",
            typeCardDescription: "Тип карты Содержание",
            dragAndDropBrowse: "Загрузить изображение",
            dragAndDropBrowseFile: "Upload File",
            button: "Кнопка",
            enterYourMessage: "Введите сообщение",
            imageView: "Просмотр изображения",
            imageUploading: "Загрузка изображения...",
            fileUploading: "File uploading...",
            clickToChooseNewImage: "Нажмите, чтобы выбрать новое изображение",
            clickToChooseNewFile: "Click To Choose New File",
            removeTheExistingOne: "Удалить существующий",

            validateResponseWithEntity: "Подтвердить ответ",
            actionOnFailureInput: "Действия при неудачном входе в систему",
            askNextQuestion: "Задайте следующий вопрос",
            goToSuccessBlock: "Перейти в свой блог успеха",
            goToFailureBlock: "Перейти к неудавшемуся блоку",
            saveResposeToAttribute: "Сохранить ответ",
            selectReplyType: "Выберите тип ответа",
            questionVariants: "Типы вопросов",
            systemEntities: "система Сущности",
            delay: "задерживать",
            retrySectionTextPart: "Спросите ",
            retrySectionText: " , не является ли ответ пользователя недействительным",
            addNextQuestion: "добавить следующий вопрос",
            typeBlockTitle: "введите заголовок блока",
            versionHistory: "история версий",
            restore: "история",
            versionName: "Название версии",
            restoreModalText:
                "Это действие восстановит выбранную версию. Вы уверены, что хотите восстановить эту версию?",
            restoreVersion: "Восстановить версию",
            newVersion: "Новая версия",
            synonymMustBeUnique: "Синоним должен быть уникальным",
            save: "Сохранять",
            entries: "Записи",
            youHaveNoEntries: "У вас нет записей",
            inputsCantBeEmpty: "Входы не могут быть пустыми",
            entryNamesMustBeUnique: "Имена записей должны быть уникальными",
            entityNameCantBeEmpty: "Сущность не может быть пустой",
            entityNameMustBeUnique: "Имя объекта должно быть уникальным",
            synonyms: "синонимы",
            entities: "Сущности",
            title: "заглавие",
            entryName: "имя_записи",
            entityhasbeenUpdatedSuccessfully: "Сущность успешно обновлена",

            allChats: "все чаты",
            paidChats: "платные чаты",
            busiestPeriod: "Самый загруженный период",
            ratingDistribution: "Распределение рейтинга",
            allMessages: "Все сообщения",
            avarageMessages: "Среднее количество сообщений",
            popularity: "популярность",
            allUsers: "Все пользователи",
            interactionName: "Название взаимодействия",
            numberOfMessage: "Номер сообщения",
            ofAllUsersMessage: "% всех сообщений пользователей",

            totalData: "Всего данных",
            avgData: "Средние данные",
            exportToCsv: "Экспорт в CSV",
            exportToExcel: "Экспорт в Excel",
            inMaintenance: "в обслуживании",
            ADD_TO_SEGMENT: "добавить в сегмент",
            REMOVE_FROM_SEGMENT: "удалить из сегмента",
            users: "пользователи",
            webhookName: "Имя вебхука",
            webHookUrl: "URL вебхука",
            webHookToken: "Token",
            delete: "Удалить",
            basicAuth: "Basic Auth",
            requiredFieldsCannotBeLeftBlank: "Обязательные поля нельзя оставлять пустыми",
            yourVerificationToken: "Token",
            yourWebHookName: "Ваше имя вебхука",
            yourWebHookUrl: "URL вашего вебхука",
            enterKey: "Key",
            password: "Пароль",
            headerValue: "Value",
            saveSuccessfully: "ваша транзакция успешно сохранена",
            urlTypeError: "Пожалуйста, заполните поле правильно (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Требуется ключ OpenAI Chat GPT-4 API.",
                apiKeyDesc:
                    "Для интеграции Chatbot + Chat GPT-4 требуется ключ Api. Пожалуйста, получите ключ API или используйте приведенный ниже ключ API для пробной версии. Вы можете использовать только 20 сообщений для пробной версии.",
                getApiKey: "Получить ключ Openai API",
                typeApiKey: "Введите ключ API",
                ownApiKey: "Собственный ключ API OpenAI",
                trialApiKey: "Пробный ключ API (ограничено 20 сообщениями)",
                useOurTrial: "Воспользуйтесь нашей бесплатной пробной версией",
                twentyMessages: "Вы можете попробовать, используя 20 сообщений бесплатно.",
                enableChatGpt3: "Включить чат GPT-4",
            },
        },
        coupon: {
            code: "Код",
            discount: "Скидка",
            endDate: "Дата окончания",
            name: "Имя",
            email: "Электронное письмо",
            phone: "Телефон",
            add: "Добавить купон",
            coupons: "купоны",
            couponDeleted: "Купон удален",
            limit: "Ограничение",
            visitorBan: "Посетитель заблокирован.",
            visitorUnBlock: "Блокировка снята.",
        },
        instagramTitle: "Нажмите кнопку ниже, чтобы включить функции Instagram..",
        instegramFunctionActive: "Включить функцию Instagram",
        ChatBOT: "Чат-бот",
        WhatsappContacts: "WhatsApp Контакты",
        InstagramContacts: "Instagram Контакты",
        MessengerContacts: "Messenger Contacts",
        editWebhook: "Изменить вебхук",
        newWebhook: "Новый вебхук",
        webhookTitle: "Название вебхука",
        webhookUrl: "URL-адрес веб-перехватчика",
        webhookToken: "Токен вебхука",
        webhookUsername: "Имя пользователя вебхука",
        webhookPassword: "Пароль вебхука",
        allIntegrations: "Все интеграции",
        integrateYourCBwithChatWidget: "Интегрируйте своего чат-бота с виджетом чата.",
        integrateYourCBwithChatGpt3: "Чат-бот можно интегрировать с GPT-4. Требуется ключ API GPT-4.",
        integrateYourCBwithWebHook: "С легкостью передавайте информацию чата между ChatBot и вашими веб-службами.",
        integrateYourCBwithIntegratable: "С легкостью передавайте информацию чата между ChatBot и {integratable}.",
        addWebhook: "Добавить вебхук",
        volumeUp: "Увеличить громкость",
        minimize: "Свести к минимуму",
        maximize: "Максимизировать",
        auditLogs: {
            auditLogsTitle: "Журнал аудита",
            auditLogsSub:
                "Журналы аудита позволяют отслеживать события, произошедшие в вашей компании за последние 30 дней.",
        },
        task: {
            workflowActions: "Действия рабочего процесса",
            workflowTitle: "Заголовок рабочего процесса",
            deleteTask: "Удалить задачу",
            selectOption: "Выберите вариант",
            notAuthorisedCreateTask: "Вы не уполномочены создавать задачу",
            notAuthorisedCreateTaskDesc: "Вы не уполномочены выполнять эту задачу",
            goToMessage: "Перейти к сообщению",
            goToChat: "Перейти к чату",
            showVisitor: "Показать посетителя",
            closeTheTask: "Закрыть задачу",
            sureAddCompletedList: "Вы уверены, что хотите добавить задачу в список выполненных?",
            success: "Успех",
            successDesc: "Новое поле успешно добавлено.",
            moveAndDeleteTask: "Перемещение и удаление задач",
            justDelete: "Просто удалить",
            selectColumnMoveTask: "Выберите столбец, в который вы хотите переместить задачи",
            todos: "Дела, которые нужно сделать",
            inProgress: "В работе",
            approval: "Одобрено",
            addAComment: "Добавить комментарий...",
            deleteComment: "Вы уверены, что хотите удалить комментарий?",
            edited: "Отредактировано",
            comments: "Комментарии",
            addComment: "Добавить комментарий",
            workflow: "Рабочий процесс",
            workflowDetail: "Детали рабочего процесса",
            workflowPerm: "Разрешения рабочего процесса",
            perm: "Разрешения",
            detail: "Детали",
            userPerm: "Пользовательские разрешения",
            deleteCard: "Удалить карточку",
            createCard: "Создать карточку",
            editCard: "Редактировать карточку",
            dragCard: "Перетащить карточку",
            allWorkflow: "Все рабочие процессы",
            createworkflow: "Создать рабочий процесс",
            deleteWorkflow: "Вы уверены, что хотите удалить этот рабочий процесс?",
            permEditTask: "У вас нет разрешения на редактирование этой задачи",
            permEditTaskDes: "Обратитесь к администратору для получения разрешений на редактирование.",
            createTaskError: "У вас нет разрешения на создание задач",
            createTaskErrorDesc: "Обратитесь к администратору для получения разрешений на создание задач.",
            moveTaskError: "У вас нет разрешения на изменение статуса задачи",
            moveTaskErrorDesc: "Обратитесь к администратору для получения разрешений на изменение статуса задачи.",
            deleteTaskError: "У вас нет разрешения на удаление задач",
            deleteTaskErrorDesc: "Обратитесь к администратору для получения разрешений на удаление задач.",
            permissionError: "У вас нет прав на создание задач",
            permissionErrorDesc:
                "Пожалуйста, свяжитесь с вашим администратором для получения разрешения на создание задач",
            whatsappContactProfileTitle: "Профиль {name} / {number}",
            createTaskVisitor: "Создать задачу (посетитель)",
            editWorkflow: "Редактировать рабочий процесс",
            visitor: "Профиль посетителя",
            createTaskMessage: "Создать задачу (Сообщение)",
            createStage: "Создать этап",
            stagesAndStatuses: "Этапы и статусы",
            workflowCreateDesc: "Описание рабочего процесса",
            subTasks: "Подзадачи",
            followers: "Подписчики",
            collaborators: "Совместные работники",
            addRelations: "Добавить отношения",
            relations: "отношения",
            main: "Главная вкладка",
            name: "имя",
            completedOfCheck: "{completed} из {total} задач выполнено",
            workflowUpdateMs: "Workflow Successfully Updated",
            taskUpdateMs: "Task Successfully Updated",
            workflowCreatedMs: "Workflow Successfully Created",
            workflowCreateError: "Не удалось создать рабочий процесс",
            taskCreatedMs: "Task Successfully Created",
            settingsDesc3:
                "Кроме того, модуль задач Supsis позволяет создавать собственный рабочий процесс с настраиваемой автоматизацией, что позволяет управлять задачами более эффективно и улучшать сотрудничество в команде.",
            settingsDesc4:
                "Таким образом, вы можете подробно отслеживать каждую из ваших задач, назначать задачи членам команды и общим образом управлять вашими бизнес-процессами более эффективно. Модуль задач Supsis предоставляет вам комплексное решение для управления задачами и координации команды.",
            settingsDesc2:
                "The Supsis task module leaves no task overlooked. You can filter tasks based on any parameter, track workloads for each workflow stage, and organize your calendar to align with your schedules.",
            settingsDesc1:
                "Модуль задач позволяет организовывать совместную работу, делегировать задачи и отслеживать прогресс вашей команды. Вы можете настроить ваши задачи в соответствии с вашими потребностями, выбрав любое представление, и создать собственные рабочие процессы с помощью автоматизации.",
            taskModuleSettingsTitle: "Настройки модуля задачи",
            high: "Высокий",
            medium: "Средний",
            low: "Низкий",
            priority: "Приоритет",
            addExistsSubtask: "Добавить существующую подзадачу",
            addSubtask: "Добавить подзадачу",
            add: "Добавить",
            newCheckList: "Новый список дел",
            subtaskTitle: "Заголовок подзадачи",
            view: "Посмотреть",
            attachFiles: "Прикрепить файлы",
            createTaskDesc: "Описание задачи",
            title: "заглавие",
            createWorkflow: "Создать рабочий процесс",
            editTask: "Редактировать задачу",
            createTask: "Создать задачу",
            deleteColumnCont: "Вы уверены, что хотите удалить этот столбец?",
            changeStage: "Изменить стадию",
            assignees: "Назначенные лица",
            owner: "Владелец",
            stage: "Стадия",
            writeSomething: "Напишите что-нибудь",
            selectAssginee: "Select Assignee",
            assignee: "Assignee",
            enterNewTaskDesc: "Enter New Task Description",
            enterNewTaskTitle: "Enter New Task Title",
            task: "Задача",
            deleteTaskCont: "Вы уверены, что хотите удалить эти задачи?",
            deleteWorkFlowCont: "Вы уверены, что хотите удалить этот рабочий процесс?",
            completed: "Завершено",
            todo: "Дела",
            kanbanBoard: "Доска Канбан",
            listView: "Список",
        },
        permissionErrors: {
            userCreate:
                "У вас нет разрешения на добавление пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            userRead:
                "У вас нет разрешения на просмотр пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            userUpdate:
                "У вас нет разрешения на обновление пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            userDelete:
                "У вас нет разрешения на удаление пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorBlock:
                "У вас нет разрешения на блокировку посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorUnblock:
                "У вас нет разрешения на разблокировку посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorDetailRead:
                "У вас нет разрешения на просмотр сведений о посетителях. Пожалуйста, проконсультируйтесь с администратором.",
            visitorListRead:
                "У вас нет разрешения на просмотр списка посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorDelete:
                "У вас нет разрешения на удаление посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorExcel:
                "У вас нет разрешения на получение Excel-вывода. Пожалуйста, проконсультируйтесь с администратором.",
            visitorUpdate:
                "У вас нет разрешения на обновление посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            bannedVisitorRead:
                "У вас нет разрешения на просмотр списка заблокированных посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            bannedWordCreate:
                "У вас нет разрешения на добавление запрещенных слов. Пожалуйста, проконсультируйтесь с администратором.",
            bannedWordRead:
                "У вас нет разрешения на просмотр запрещенных слов. Пожалуйста, проконсультируйтесь с администратором.",
            bannedWordDelete:
                "У вас нет разрешения на удаление запрещенных слов. Пожалуйста, проконсультируйтесь с администратором.",
            chatRead: "У вас нет разрешения на просмотр чатов. Пожалуйста, проконсультируйтесь с администратором.",
            chatUpdate: "У вас нет разрешения на редактирование чатов. Пожалуйста, обратитесь к вашему администратору.",
            archiveRead: "У вас нет разрешения на просмотр архивов. Пожалуйста, обратитесь к вашему администратору.",
            roleCreate: "У вас нет разрешения на добавление ролей. Пожалуйста, обратитесь к вашему администратору.",
            roleRead: "У вас нет разрешения на просмотр ролей. Пожалуйста, обратитесь к вашему администратору.",
            roleUpdate: "У вас нет разрешения на обновление ролей. Пожалуйста, обратитесь к вашему администратору.",
            roleDelete: "У вас нет разрешения на удаление ролей. Пожалуйста, обратитесь к вашему администратору.",
            departmentCreate:
                "У вас нет разрешения на добавление отделов. Пожалуйста, обратитесь к вашему администратору.",
            departmentRead: "У вас нет разрешения на просмотр отделов. Пожалуйста, обратитесь к вашему администратору.",
            departmentUpdate:
                "У вас нет разрешения на обновление отделов. Пожалуйста, обратитесь к вашему администратору.",
            departmentDelete:
                "У вас нет разрешения на удаление отделов. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentCreate:
                "У вас нет разрешения на создание готового контента. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentRead:
                "У вас нет разрешения на просмотр готового контента. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentUpdate:
                "У вас нет разрешения на обновление готового контента. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentDelete:
                "У вас нет разрешения на удаление готового контента. Пожалуйста, обратитесь к вашему администратору.",
            welcomeCreate:
                "У вас нет разрешения на создание приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            welcomeRead:
                "У вас нет разрешения на просмотр приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            welcomeUpdate:
                "У вас нет разрешения на обновление приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            welcomeDelete:
                "У вас нет разрешения на удаление приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            settingCreate: "У вас нет разрешения на создание настроек. Пожалуйста, обратитесь к администратору.",
            settingRead: "У вас нет разрешения на просмотр настроек. Пожалуйста, обратитесь к администратору.",
            settingUpdate: "У вас нет разрешения на обновление настроек. Пожалуйста, обратитесь к администратору.",
            settingDelete: "У вас нет разрешения на удаление настроек. Пожалуйста, обратитесь к администратору.",
            reportCreate: "У вас нет разрешения на создание отчетов. Пожалуйста, обратитесь к администратору.",
            reportRead: "У вас нет разрешения на просмотр отчетов. Пожалуйста, обратитесь к администратору.",
            reportUpdate: "У вас нет разрешения на обновление отчетов. Пожалуйста, обратитесь к администратору.",
            reportDelete: "У вас нет разрешения на удаление отчетов. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestCreate:
                "У вас нет разрешения на создание запросов в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestRead:
                "У вас нет разрешения на просмотр запросов в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestUpdate:
                "У вас нет разрешения на ответ на запросы в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestDelete:
                "У вас нет разрешения на удаление запросов в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            catalogCreate: "У вас нет разрешения на создание каталогов. Пожалуйста, обратитесь к администратору.",
            catalogRead: "У вас нет разрешения на просмотр каталогов. Пожалуйста, обратитесь к администратору.",
            catalogUpdate: "У вас нет разрешения на обновление каталогов. Пожалуйста, обратитесь к администратору.",
            catalogDelete: "У вас нет разрешения на удаление каталогов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryCreate:
                "У вас нет разрешения на создание историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryRead:
                "У вас нет разрешения на просмотр историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryUpdate:
                "У вас нет разрешения на обновление историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryDelete:
                "У вас нет разрешения на удаление историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotTemplateRead:
                "У вас нет разрешения на просмотр шаблонов чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotTemplateAiRead:
                "У вас нет разрешения на просмотр шаблонов искусственного интеллекта чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotIntegrationsRead:
                "У вас нет разрешения на просмотр интеграций чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotArchiveRead:
                "У вас нет разрешения на просмотр архивов чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesRead:
                "У вас нет разрешения на просмотр сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesCreate:
                "У вас нет разрешения на создание сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesUpdate:
                "У вас нет разрешения на обновление сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesDelete:
                "У вас нет разрешения на удаление сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotReportRead: "У вас нет прав на просмотр отчетов чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotTrainRead: "У вас нет прав на просмотр обучения чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentCreate:
                "У вас нет прав на создание сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentRead:
                "У вас нет прав на просмотр сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentUpdate:
                "У вас нет прав на обновление сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentDelete:
                "У вас нет прав на удаление сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            integrationsRead:
                "У вас нет прав на просмотр страницы интеграций. Пожалуйста, обратитесь к администратору.",
            whatsappIntegrationRead:
                "У вас нет прав на просмотр страницы интеграции WhatsApp. Пожалуйста, обратитесь к администратору.",
            instagramIntegrationRead:
                "У вас нет прав на просмотр страницы интеграции Instagram. Пожалуйста, обратитесь к администратору.",
            telegramIntegrationRead:
                "У вас нет прав на просмотр страницы интеграции Telegram. Пожалуйста, обратитесь к администратору.",
            integrationCreate: "У вас нет прав на активацию интеграций. Пожалуйста, обратитесь к администратору.",
            triggerCreate: "У вас нет прав на создание триггеров. Пожалуйста, обратитесь к администратору.",
            triggerRead: "У вас нет прав на просмотр триггеров. Пожалуйста, обратитесь к администратору.",
            triggerUpdate: "У вас нет прав на обновление триггеров. Пожалуйста, обратитесь к администратору.",
            triggerDelete: "У вас нет прав на удаление триггеров. Пожалуйста, обратитесь к администратору.",
            billingRead: "У вас нет разрешения на просмотр счетов. Пожалуйста, свяжитесь с вашим администратором.",
            taskCreate: "У вас нет разрешения на создание задач. Пожалуйста, свяжитесь с вашим администратором.",
            taskRead: "У вас нет разрешения на просмотр задач. Пожалуйста, свяжитесь с вашим администратором.",
            taskUpdate: "У вас нет разрешения на обновление задач. Пожалуйста, свяжитесь с вашим администратором.",
            taskDelete: "У вас нет разрешения на удаление задач. Пожалуйста, свяжитесь с вашим администратором.",
            calendarCreate:
                "У вас нет разрешения на создание календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            calendarRead:
                "У вас нет разрешения на просмотр календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            calendarUpdate:
                "У вас нет разрешения на обновление календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            calendarDelete:
                "У вас нет разрешения на удаление календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            mailCreate: "У вас нет разрешения на создание писем. Пожалуйста, свяжитесь с вашим администратором.",
            mailRead: "У вас нет разрешения на просмотр писем. Пожалуйста, свяжитесь с вашим администратором.",
            mailUpdate: "У вас нет разрешения на обновление писем. Пожалуйста, свяжитесь с вашим администратором.",
            mailDelete: "У вас нет разрешения на удаление писем. Пожалуйста, свяжитесь с вашим администратором.",
        },
        message: {
            createDepartment: "Создать отдел",
            goToLink: "Перейти по ссылке",
            emailAddressYouProvide: "Учётная запись с указанным адресом электронной почты уже существует.",
            channelPrivacyPolicyNotMet: "Политика конфиденциальности канала не соблюдена",
            userIsNotInDepartment: "Пользователь не в этом отделе",
            currentDepartment:"Текущий отдел",
            validDepartment:"Действительный отдел",
            youCanForwardToThisDepartment:"Вы можете перенаправить этот разговор в этот отдел",
            goToSettings:"Перейти к настройкам",
            changeDepartmentAndForward:"Изменить отделение и перенаправить",
            selectDepartmentToForwardAgent:"Пожалуйста, выберите, через какой отдел вы хотите направить разговор для агента по имени {selectAgentName}.",
            selectDepartmentToForward: "Пожалуйста, выберите отделение, к которому вы хотите перенаправить",
            packageConfirmationMessage: "Вы уверены, что хотите купить пакет? Приобретенный вами пакет подлежит оплате в реальном времени. Вы можете продолжать использовать его в течение одного года после отмены. Цена этого продукта указана без НДС 20%.",
            packagePurchaseConfirmation: "Вы уверены, что хотите купить пакет? Ежемесячные пакеты будут списаны в начале каждого месяца. Использование пакета закончится после даты отмены. Цена этого продукта указана без НДС 20%.",
            annualPurchaseDiscount: "Поймайте предложение скидки 30% на ежегодные покупки!",
            customerTables: "Таблицы клиентов",
            formIntegration: "Интеграция формы",
            automationIntegration: "Интеграция автоматизации",
            remainingAutomationTask: "Осталось автоматизаций",
            createUserError: "Произошла ошибка при создании пользователя",
            sendTemplateMessage: "Отправить шаблон сообщения",
            startChatWithDifferentChannel: "Начать чат с другим каналом",
            whatsappChatStarter: "Запуск чата WhatsApp",
            pressEnterToJoin: "Нажмите Enter, чтобы присоединиться к чату",
            pressEnterToStartChat: "Нажмите Enter, чтобы начать чат",
            cannotSendMessage: "Вы не можете отправить сообщение этому человеку",
            cannotSendSessionMessage: "Вы не можете отправить сессионное сообщение этому человеку",
            conversationNotInYourDepartments: "Этот разговор не принадлежит ни одному из ваших отделов",
            customizeImage: "Если вы хотите настроить изображение",
            clickToUpload: "Нажмите здесь, чтобы загрузить изображение",
            uploadNote: "Ниже приведены форматы файлов и их размеры, которые принимаются для загрузки",
            imageSize: "Изображение не может быть загружено, так как оно превышает 2 МБ",
            videoSize: "Видео не может быть загружено, так как оно превышает 20 МБ",
            documentSize: "Документ не может быть загружен, так как он превышает 2 МБ",
            uploading: "Загрузка изображения, пожалуйста, подождите...",
            uploadSuccess: "Изображение успешно загружено",
            note: "Примечание",
            gridView: "Колоночный вид",
            completedTasks: "Завершенные задачи",
            system: "Система",
            destroyedBy: "Уничтожен",
            brand: "Марка",
            channelCreatedSuccess: "Канал успешно создан",
            channelCreatedError: "Не удалось создать канал",
            plans: {
                types: {
                    supsis: "Пакеты Представителей",
                    chatbot: "Чат-бот",
                    automation: "Автоматизация",
                    customer_tables: "Таблица Клиентов",
                    mail: "Электронная почта",
                    tasks: "Задачи",
                    form: "Форма",
                    whatsapp: "WhatsApp",
                    whatsapp_business: "WhatsApp Business",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    "artificial_intelligence": "Искусственный интеллект",
                    "webhook": "Вебхук"
                },
            },
            vipCustomerDescription:
                "Отметка этого человека как VIP-клиента перемещает его на верх очереди и обеспечивает приоритетное обслуживание.",
            switchOn: "Включено",
            switchOff: "Выключено",
            ownerDescription:
                "Эта функция указывает владельца чата. Независимо от статуса владельца (в сети или оффлайн), чаты всегда назначаются владельцу. Владельцы чатов могут просматривать их только сами и не могут отвечать на них чат-бот.",
            permissionError: "У вас нет разрешения на выполнение этого действия!",
            copySuccess: "Содержимое успешно скопировано!",
            unowned: "Без владельца",
            jsonPreview: "Предварительный просмотр JSON",
            enterNewValue: "Введите новое значение",
            updatePreferredLanguage: "Обновить предпочитаемый язык",
            updateTags: "Обновить теги",
            updateEmail: "Обновить электронную почту",
            enterNewEmail: "Введите новый адрес электронной почты",
            deleteConfirmation: "Подтверждение удаления",
            confirmDelete: "Вы уверены, что хотите удалить эту функцию?",
            yesDelete: "Да, удалить",
            vipCustomer: "★ VIP-клиент",
            takeControlFromChatbot: "Взять контроль от чат-бота",
            enterJoin: "Вы можете присоединиться к чату, нажав клавишу Enter",
            watchChat: "Смотреть чат",
            untitledAutomation: "👉 Автоматизация нажатия на профиль без названия",
            event: "Событие",
            chatbotSettings: "Настройки маршрутизации чат-бота",
            chatbotScenarioNotFound: "Сценарий чат-бота не найден",
            noChatbotScenario: "В системе не найден сценарий чат-бота.",
            scenarioNotFound: "Сценарий не найден",
            descNotAvailable: "Описание недоступно",
            lastRegulation: "Последнее регулирование",
            taskCreator: "Создатель задачи",
            noPermission: "У вас нет разрешения на создание задач.",
            noPermissionDescription: "У вас нет разрешения на выполнение этого действия.",
            notAppointed: "Не назначен",
            changeStage: "Изменить стадию",
            selectedCandidates: "1 выбранный кандидат(ы)",
            coverPhotoRemove: "Удалить обложку",
            coverPhotoSet: "Установить в качестве обложки",
            autoTransfer: "Автоматически передать ваши контакты в Zoho",
            autoTransferDescription:
                "Контакты, поступающие в этот канал, автоматически передаются в модуль контактов Zoho CRM. Те, кто передан в Zoho, активируют виджеты Zoho.",
            zohoChannelRequiredTitle: "Требуется канал Zoho CRM",
            zohoChannelRequiredContent: "У вас нет канала Zoho CRM. Нажмите здесь, чтобы добавить его немедленно.",
            okText: "Добавить канал Zoho CRM",
            cancelText: "Отмена",
            forceQueueForNoOwnerContacts: "Принудить безвладельцев ждать в очереди",
            forceQueueDescription:
                "Только владельцы контактов автоматически назначаются, принуждая безвладельцев ждать в очереди.",
            showNoOwnerContactsToAdmins: "Показать безвладельцев только администраторам",
            showNoOwnerContactsDescription: "Безвладельцы видны только администраторам.",
            autoAssignOwner: "Автоматическое присвоение владельца контакта",
            autoAssignOwnerDescription:
                "Когда чат автоматически назначается представителю, он также назначается как владелец.",
            creator: "Создатель",
            hideShow: "Скрыть / Показать",
            url: "URL",
            cannedMessages: "Готовые сообщения",
            templateMessages: "Шаблонные сообщения",
            chatbots: "Чат-боты",
            noCannedMessages: "Готовых сообщений не найдено",
            filterToFindMore: "Вы можете найти больше готовых сообщений, изменив свои фильтры.",
            runPrompt: "Запустить Промпт",
            noLeadsFound: "Нет лидов для этого человека",
            deals: "Сделки",
            noDealsFound: "Сделки не найдены для этого человека",
            loadingDeals: "Загрузка сделок",
            zohoCRM: "Zoho CRM",
            viewContact: "Просмотреть контакт",
            noNotesAdded: "Заметок еще не добавлено",
            attachments: "Вложения",
            addNewNote: "Добавить новую заметку",
            saving: "Сохранение...",
            warningFillFields: "Пожалуйста, заполните поля заголовка и содержания.",
            successNoteAdded: "Заметка успешно добавлена.",
            errorAddingNote: "Произошла ошибка при добавлении заметки.",
            noteTitle: "Заголовок заметки",
            noteContent: "Содержание заметки",
            selectPreferredAgent: "Выберите предпочтительного агента, которого хотите назначить посетителю.",
            postOperations: "Пост операции",
            loadingPostOperations: "Загрузка пост операций",
            noPostOperations: "Пост операций не найдено для этого человека",
            postOperationDetails: "Детали пост операции",
            noMediaDocuments: "Нет доступных медиа или документов для этого человека.",
            selectionLimitError: "Вы можете выбрать максимум 30 элементов.",
            showNote: "Показать заметку всем",
            hideNote: "Скрыть заметку",
            updateNote: "Обновить заметку",
            addUserNote: "Добавить заметку о пользователе",
            privateNote: "Личная заметка",
            metaReferrals: "Meta Рекомендации",
            noMetaReferrals: "Не найдено взаимодействий с рекламой Meta.",
            searchPrompt: "Поиск чего-либо.",
            noRecentResults: "Недавние результаты не найдены.",
            contactInfo: "Информация о контакте",
            noPropertiesAdded: "Пока нет добавленных свойств.",
            propertyAddedUpdated: "Свойство успешно добавлено/обновлено.",
            propertyError: "Произошла ошибка при добавлении/обновлении свойства.",
            propertyDeleted: "Свойство успешно удалено.",
            propertyDeleteError: "Произошла ошибка при удалении свойства.",
            zohoSynchronization: "Синхронизация Zoho",
            zohoSyncConfirmation: "Вы хотите внести изменения в человека в Zoho?",
            hideOtherInfo: "Скрыть другую информацию",
            showOtherInfo: "Показать другую информацию",
            whatsappChatStart: "Начать чат в WhatsApp",
            ownership: "Право собственности клиента",
            countryAndLanguage: "Страна, Язык",
            calendarEvent: "Календарное событие",
            reservation: "Резервирование",
            contact: "Контакт",
            user: "Пользователь",
            customerOwnership: "Владение клиентом",
            ownerless: "Без владельца",
            preferredDepartment: "Предпочитаемый отдел",
            flowluTransfer: "Передать в Flowlu",
            mergeSuccess: "Операция слияния успешно завершена.",
            visitorOwnershipWarning: "Этот посетитель принадлежит другому пользователю.",
            newAutomation: "Новая автоматизация",
            automations: "Автоматизации",
            createProfileAutomation: "Создать автоматизацию профиля",
            profileButtonClicked: "Кнопка профиля нажата",
            profileButtonDescription: "Эта автоматизация будет запущена, когда нажата кнопка профиля.",
            automationName: "Название автоматизации",
            create: "Создать",
            dayRange: "Диапазон дней",
            hourRange: "Диапазон часов",
            last24Hours: "Последние 24 часа",
            today: "Сегодня",
            yesterday: "Вчера",
            thisWeek: "На этой неделе",
            lastWeek: "На прошлой неделе",
            last7Days: "Последние 7 дней",
            last30Days: "Последние 30 дней",
            thisMonth: "В этом месяце",
            lastMonth: "В прошлом месяце",
            startDateTime: "Дата и время начала",
            endDateTime: "Дата и время окончания",
            complaint: "Жалоба",
            opens: "Открытия",
            clicks: "Клики",
            mockData: "(Тестовые данные)",
            preferredRepresentative: "Выберите предпочтительного представителя",
            forwardToDepartment: "Переслать в отдел",
            toMobileAgents: "К мобильным агентам",
            noMediaAndDocuments: "У этого пользователя нет медиа или документов",
            reportBug: "Сообщить об ошибке",
            waitingForReply: "Ожидание ответа",
            memorySize: "Размер памяти",
            usedMemory: "Используемая память",
            availableMemory: "Доступная память",
            memoryLimit: "Ограничение памяти",
            memoryLimitPrice: "Цена за дополнительную память",
            pieView: "Pie View",
            chartView: "График",
            tableView: "Таблица",
            lastUpdate: "последнее обновление",
            workflow: "рабочий процесс",
            task: "задача",
            filterBy: "По фильтру",
            watchAllLive: "Смотреть все прямые трансляции",
            sessionsUnique: "Сессии (уникальные пользователи)",
            sessionsAll: "Сессии (все пользователи)",
            moreFeaturesDesc:
                "Больше функций, больше интеграций, больше агентов! Действуйте прямо сейчас, чтобы лучше управлять своей командой и раскрыть весь потенциал вашего бизнеса!",
            metaLeadForms: "Формы лидов Meta",
            metaLeadsConnectedSucs: "Meta Leads успешно подключены",
            failedToConnectMetaLeads: "Не удалось подключиться к Meta Leads",
            forbiddenChannel: "Запрещённый канал",
            forbiddenChannelDesc: "У вас нет доступа к просмотру этого канала",
            firstContact: "Первый контакт",
            needsAnalysis: "Анализ потребностей",
            offerSent: "Предложение отправлено",
            offerReview: "Рассмотрение предложения",
            decisionPhase: "Фаза принятия решения",
            personDeleted: "Человек удалён",
            metaLeadsIntegration: "Интеграция Meta Leads",
            phoneNumberIsInvalid: "Номер телефона недействителен",
            owner: "Владелец",
            addAnItem: "Добавить элемент",
            saveItem: "Сохранить элемент",
            customItem: "Пользовательский элемент",
            backgroundPhoto: "Фоновое изображение",
            whenYouActivateFeature:
                "Когда вы активируете эту функцию, она не будет отображаться на странице бронирования",
            logo: "Логотип",
            noLogo: "Без логотипа",
            addTeamMember: "Добавить члена команды",
            timezone: "Часовой пояс",
            selectDayys: "Выберите день(и)",
            selectStartHour: "Выберите время начала",
            selectEndHour: "Выберите время окончания",
            moveLeft: "Переместить влево",
            moveRight: "Переместить вправо",
            reply: "Ответить",
            replyToAll: "Ответить всем",
            deleteThreadMessage: "Удалить сообщение темы",
            totalEmailsBounced: "Всего писем отклонено",
            totalEmailsComplained: "Всего писем, на которые поступили жалобы",
            untilNowTotalEmailOpens: "Общее количество открытий писем на данный момент",
            untilNowTotalEmailLinkClicks: "Общее количество кликов по ссылкам электронной почты на данный момент",
            uniqueClicks: "Уникальные клики",
            untilNowTotalUniqueEmail:
                "Общее количество уникальных кликов по ссылке электронной почты (на одного получателя)",
            emailCampaignTimeline: "Временная шкала кампании электронной почты",
            receivedBroadcasts: "Полученные рассылки",
            groupDeletedSuccessfully: "Группа успешно удалена",
            verify: "Проверить",
            done: "Выполнено",
            pleaseSelectAnEmailAddress: "Пожалуйста, выберите адрес электронной почты",
            goBack: "Вернуться",
            show: "Показать",
            vueEmailEditor: "Редактор электронной почты Vue (демо)",
            saveDesign: "Сохранить дизайн",
            exportHTML: "Экспортировать HTML",
            saveAsEmailCustomerGroup: "Сохранить как группу клиентов по электронной почте",
            saveAsWhatsappCustomerGroup: "Сохранить как группу клиентов Whatsapp",
            deleteModalFormDesc:
                "Если вы удалите эту форму, все данные для нее будут безвозвратно удалены. Вы уверены, что хотите продолжить?",
            todo: "Дела, которые нужно сделать",
            inProgress: "В процессе",
            approval: "Одобрение",
            completed: "Завершено",
            transactionType: "Тип транзакции",
            previousBalance: "Предыдущий баланс",
            nextBalance: "Следующий баланс",
            amount: "Сумма",
            wpIntegrationChannelRequired: "Требуется канал веб-интеграции Whatsapp",
            wpIntegrationChannelRequiredDesc:
                "Для интеграции Chatbot + Whatsapp Web требуется Whatsapp Web Channel. Пожалуйста, создайте новый канал.",
            wabaIntegrationChannelRequired: "Требуется канал бизнес-интеграции Whatsapp",
            wabaIntegrationChannelRequiredDesc:
                "Для интеграции Chatbot + Whatsapp Business API требуется веб-канал Whatsapp. Пожалуйста, создайте новый канал.",
            instaIntegrationChannelRequired: "Требуется канал интеграции Instagram.",
            instaIntegrationChannelRequiredDesc:
                "Для интеграции Chatbot + Instagram требуется канал Instagram. Пожалуйста, создайте новый канал.",
            createWpChannel: "Создать веб-канал Whatsapp",
            createWabaChannel: "Создать канал Whatsapp Business API",
            createInstaChannel: "Создать канал Instagram",
            failedToDeleteGroup: "Не удалось удалить группу",
            failedToDeleteGroups: "Не удалось удалить группы",
            failedToFetchGroupContacts: "Не удалось получить контакты группы",
            mailAddressDeletedSuccessfully: "Почтовый адрес успешно удален",
            defaultMailAddressChangedSuccessfully: "Почтовый адрес по умолчанию успешно изменен",
            mailAddressAlreadyRegistered: "Почтовый адрес не может быть уже зарегистрирован или пуст.",
            pleaseVerifyByClicking:
                "Пожалуйста, проверьте, нажав на ссылку, отправленную на ваш адрес электронной почты.",
            signSucsRegistered: "Подпись успешно зарегистрирована",
            myContacts: "Мои контакты",
            unanswered: "Пропущено",
            emailBroadcasts: "Рассылки по электронной почте",
            monthlyLimit: "Ежемесячный лимит",
            totalShipments: "Общее количество отправлений",
            shippingStatus: "Статус отгрузки",
            lastAction: "Последнее действие",
            receiver: "Получатель",
            delivered: "Доставлено",
            opened: "Открыто",
            clicked: "Нажато",
            bounced: "Он вернулся",
            clickedLinks: "Нажатые ссылки",
            reason: "Причина",
            timer: "Таймер",
            implemented: "Реализовано?",
            module: "Модуль",
            excelDownload: "Загрузка Excel",
            serviceFeatures: "Особенности сервиса",
            mailAddressDeletedSucs: "Почтовый адрес удален успешно",
            inputSearchText: "Введите текст для поиска",
            createRecord: "Создать запись",
            separatorCharacter: "Символ-разделитель",
            exampleResultPreview: "Предварительный просмотр результатов",
            importRecords: "Импортировать записи",
            equals: "Равно",
            notEquals: "Не равно",
            startsWith: "Начинается с",
            endsWith: "Заканчивается с",
            greaterThan: "Больше",
            lessThan: "Меньше",
            before: "До",
            after: "После",
            is: "О",
            isNot: "Нет",
            empty: "Пустой",
            notEmpty: "Не пустой",
            isOneOff: "Один раз",
            field: "Поле",
            records: "Запись",
            addIntegration: "Добавить интеграцию",
            chatbotScenarioReleased: "Сценарий чатбота выпущен",
            chatbotScenarioHasBeenCancelled: "Сценарий чатбота был отменен",
            titleAndDesc: "Название и описание",
            templateAndMailSelection: "Выбор шаблона и почты",
            peopleToSend: "Люди, которым нужно отправить",
            submissionPlans: "План отправки",
            summary: "Резюме",
            broadcastTitle: "Заголовок трансляции",
            sentByEmail: "Отправленное электронное письмо",
            emailTemplate: "Шаблон электронной почты",
            onlyPeopleWithEmail: "Для отправки подходят только люди с адресом электронной почты",
            sendNow: "Отправить сейчас",
            plan: "План",
            senderEmail: "Электронная почта отправителя",
            totalBuyer: "Общее количество покупателей",
            estimatedDuration: "Предполагаемая продолжительность",
            person: "Человек",
            shippingIsNowComplete: "Доставка завершена!",
            back: "Назад",
            customerName: "Имя клиента",
            customerEmail: "Электронная почта клиента",
            customValue: "Пользовательское значение",
            selectMailTemplate: "Вы должны выбрать почтовый шаблон.",
            youMustSelectSendingMailAddress: "Вы должны выбрать почтовый адрес отправки.",
            youMustSelectCustomerGroupSend: "Вы должны выбрать группу клиентов для отправки",
            createBroadcast: "Создать трансляцию",
            broadcastDetails: "Детали трансляции",
            youCanCheckYourEmailStatus:
                "Вы можете проверить состояние своей электронной почты, повысив тарифный план. Вы можете проверить состояние своей электронной почты, повысив тарифный план.",
            sentDetails: "Подробности отправки",
            failed: "Не удалось",
            total: "Всего",
            totalEmailsProcessed: "Всего обработано писем",
            totalEmailsDelivered: "Всего отправленных писем",
            toAvailableAgents: "Для доступных агентов",
            toAvailableDepartments: "Для доступных отделов",
            toWithAgentAndDepartment: "С агентом и отделом",
            toMobilAgents: "Мобильным агентам",
            toPreferredAgents: "Предпочитаемым агентам",
            searchAgent: "Агент по поиску",
            searchDepartment: "Отдел поиска",
            searchMobileAgent: "Мобильный агент по поиску",
            searchAgentOrDepartment: "Агент или отдел поиска",
            searchPreferredAgent: "Поиск предпочтительного агента",
            noAgentsAvailableToForward: "Нет агентов, доступных для пересылки",
            noDepartmentsAvailableToForward: "Нет департаментов, доступных для пересылки",
            noMobileAgentsAvailableToForward: "Нет мобильных агентов, доступных для пересылки",
            noPreferredAgentsAvailableToForward: "Нет предпочтительных агентов, доступных для пересылки",
            ifYouSendThisConversationToTheQue:
                "Если вы отправите этот разговор в очередь, это удалит вас из чата и поместит разговор в очередь. Если включено автоматическое назначение чата, разговор будет назначен соответствующему агенту и может быть передан вам обратно.",
            ifAutomaticChatAssignmentIsDisabled:
                "Если автоматическое назначение чата отключено, звонок останется в очереди. Уполномоченные сотрудники могут принять звонок из очереди.",
            sendQueue: "Отправить в очередь",
            agentName: "Имя агента",
            departmentName: "Название отдела",
            toQueue: "Очередь",
            usageLimitExceeded: "Превышен лимит использования",
            featureIsNotAvailable: "функция недоступна.",
            web: "Web",
            mobile: "Mobile",
            noGrouping: "Нет группировки",
            groupByThis: "Группировать по этому",
            selectGroupingCriteria: "Выбрать критерии группировки",
            activeUsers: "Активные пользователи",
            passiveUsers: "Пассивные пользователи",
            noPlatform: "Платформа не указана",
            noRole: "Роль не указана",
            noDepartment: "Отдел не указан",
            noLanguage: "Язык не указан",
            group2: "Группа",
            groupedByStatus: "Сгруппировано по статусу",
            grouping: "Группировка",
            activeSubjects: "Активные субъекты",
            passiveSubjects: "Пассивные субъекты",
            groupSubjects: "Групповые субъекты",
            showAll: "Показать все",
            onlyActive: "Только активные",
            onlyPassive: "Только пассивные",
            groupBy: "Группировать по состоянию",
            selectTimezone: "Выберите часовой пояс",
            userFilter: "Пользовательский фильтр",
            confidenceScore: "Показатель уверенности",
            chatbotLanguage: "Язык чатбота",
            botScenerio: "Сценарий бота",
            selectTemplate: "Выбрать шаблон",
            importFromReadyTemplates: "Импорт из готовых шаблонов",
            classification: "Классификация",
            addClassification: "Добавить классификацию",
            expressionClassified: "Выражение для классификации",
            zohoModuleName: "Имя модуля Zoho",
            selectModule: "Выбрать модуль",
            standardFields: "Стандартные поля",
            selectStandardField: "Выбрать стандартное поле",
            customFields: "Пользовательские поля",
            selectCustomFields: "Выбрать пользовательское поле",
            aiFunction: "Функция искусственного интеллекта",
            aiFunctionDesc:
                "Управление функцией искусственного интеллекта для выполнения действий на основе вводимых пользователем данных",
            functionName: "Имя функции",
            functionDesc: "Описание функции",
            addParameter: "Добавить параметр",
            chooseAiStory: "Выбрать историю ИИ",
            chatbotAiPromptDesc:
                "Искусственный интеллект обучается и определяет, как ему следует себя вести, получая инструкции по конкретной задаче или проблеме с помощью функции «подсказки».",
            enterPrompt: "Введите подсказку",
            aiParameterTunings: "Настройка параметров ИИ",
            aiParameterTuningsDesc:
                "Вы можете настраивать параметры ИИ, чтобы сделать его более отзывчивым и точным. Эти параметры используются для управления поведением ИИ и его реакцией на ввод данных пользователем.",
            temperature: "Температура",
            temperatureDesc:
                "Какая температура выборки используется, от 0 до 2. Более высокие значения, такие как 0,8, сделают вывод более случайным, а более низкие, такие как 0,2, сделают его более целенаправленным и детерминированным.",
            topDesc:
                "В качестве альтернативы выборке по температуре, так называемой выборке ядра, модель рассматривает результаты токенов с массой вероятности top_p. Таким образом, 0,1 означает, что рассматриваются только токены с массой вероятности top 10 %. Обычно мы рекомендуем изменить этот параметр или температуру, но не оба.",
            toolChoices: "Опции инструмента",
            noneDesc:
                "None означает, что модель не будет вызывать никаких инструментов и вместо этого выдаст сообщение",
            autoDesc:
                "Автоматический режим является значением по умолчанию и означает, что модель может выбирать между генерацией сообщения и вызовом одного или нескольких агентов",
            requiredDesc:
                "Режим Required означает, что модель должна вызвать одного или нескольких агентов, прежде чем ответить пользователю",
            createArticles: "Создать статью",
            createArticlesDesc: "Создавайте статьи, чтобы помочь вашим пользователям найти ответы на их вопросы.",
            articlesTitle: "Название статьи",
            articlesContent: "Содержание статьи",
            createFaq: "Создать часто задаваемые вопросы (FAQ)",
            createFaqDesc:
                "Создайте новый FAQ для вашего чатбота. Это поможет вашему чатботу отвечать на вопросы пользователей.",
            question: "Вопрос",
            saveAndClose: "Сохранить и закрыть",
            contentPreview: "Предварительный просмотр содержимого",
            upgradePackageTitle: "Обновите свой пакет и избегайте ограничений",
            upgradePackageDescription:
                "Больше функций, больше интеграций, больше агентов! Примите меры прямо сейчас, чтобы лучше управлять своей командой и максимально увеличить потенциал своего бизнеса!",
            upgradePackage: "Обновление",
            deleteSelected: "Удаление выбранных файлов",
            newFolder: "Новая папка",
            newFile: "Новый файл",
            noFilesFound: "В этой папке не найдено ни одного файла",
            uploadFile: "Загрузить файл",
            enterFolderName: "Пожалуйста, введите имя папки",
            folderName: "Имя папки",
            dropFileHere: "Бросить файлы сюда",
            createFolder: "Создать папку",
            fileUploadingError: "При загрузке файла произошла ошибка",
            fileUploadingSucs: "Папка успешно создана",
            folderNameNotEmpty: "Имя папки не может быть пустым",
            deleteFolder: "Удалить папку",
            sureDeleteFolder: "Вы уверены, что хотите удалить эту папку и все файлы в ней?",
            deletionSucs: "Удаление прошло успешно",
            deleteFile: "Удалить файл",
            sureDeleteFile: "Вы уверены, что хотите удалить этот файл?",
            deletionError: "В процессе удаления произошла ошибка",
            selectFile: "Выбрать файл",
            moreThanOneSelect: "Вы можете выбрать более одного файла",
            selectAnFile: "Выберите файл",
            bulkSms: "Массовые SMS",
            sendBulkSmsCustomers: "Отправлять массовые SMS своим клиентам",
            writeYourMessage: "Напишите ваше сообщение здесь",
            sendSms: "Отправить SMS",
            sendSmsYourCustomers: "Отправить SMS своим клиентам",
            manageChannelDetail: "Управлять информацией о канале",
            details: "Детали",
            teamGramChannels: "Каналы TeamGram",
            newTeamGramIntegration: "Новая интеграция TeamGram",
            teamGramIntegration: "Интеграция TeamGram",
            notMoreThanOneTeamGramChannels: "Вы не можете создать более одного канала TeamGram",
            teamGramDetail: "Детали TeamGram",
            manageYourTeamGramIntegration: "Управление интеграцией TeamGram",
            trendyolChannels: "Каналы Trendyol",
            trendyolStoreIntegration: "Интеграция с магазином Trendyol",
            trendyolStoreConnection: "Подключите свой магазин Trendyol",
            deleteTrendyolIntegration: "Удалить интеграцию Trendyol",
            sureDeleteTrendyolIntegration:
                "Вы уверены, что хотите удалить интеграцию Trendyol? Это действие необратимо",
            trendyolStoreChannel: "Канал магазина Trendyol",
            deleteTrendyolChannel: "Удалить канал Trendyol",
            channelUpdatedSucs: "Канал успешно обновлен.",
            failedUpdateChannel: "Не удалось обновить канал",
            trendyolStoreIntegrationDetail: "Деталь интеграции магазина Trendyol",
            configureTrendyolStoreIntegrationDetail: "Настроить интеграцию с магазином Trendyol",
            trenyolStoreProductQuestManage: "Trendyol Store - Управление запросами продуктов",
            trendyolStoreDesc:
                "Вы можете использовать следующие настройки для управления запросами к продуктам магазина Trendyol.",
            zohoCrmChannels: "Каналы Zoho CRM",
            zohoPersonalChannel: "Личные каналы Zoho",
            connectZoho: "Подключиться к Zoho CRM",
            updateChannelDesc5: "Обновить канал Zoho CRM",
            zohoCrmIntegration: "Интеграция Zoho CRM",
            sureDeleteZohoChannel: "Вы уверены, что хотите удалить канал Zoho CRM?",
            createNotMoreThanOneZohoChannels: "Вы не можете создать более одного канала Zoho",
            removeZohoLink: "Удалить ссылку Zoho",
            connectToZoho: "Подключиться к Zoho",
            chatClosed: "Чат закрыт",
            scoreChat: "Чат забит",
            createdTicket: "Билет создан",
            updatedTicket: "Билет обновлен",
            newUserCreated: "Создан новый пользователь",
            updateUser: "Обновленный пользователь",
            deleteUsers: "Пользователь удален",
            changeStatusRepresent: "Статус представителя изменился",
            incomingMessage: "Входящее сообщение",
            outgoingMessage: "Исходящее сообщение",
            createdNewTicket: "Создан новый тикет",
            bitrix24Channels: "Каналы Битрикс24",
            sureDeleteBitrixChannel: "Вы уверены, что хотите удалить канал Битрикс24?",
            bitrix24Integrations: "Интеграции Битрикс24",
            notCreateMoreThenOneChannel: "Вы не можете создать более одного канала Ideasoft",
            connectToBitrix24: "Подключиться к Битрикс24",
            connectToBitrix24Api: "Подключиться к Битрикс24 Api",
            updateChannel: "Канал обновления",
            updateChannelDesc: "Обновить канал Битрикс24 Api",
            yourBitrix24Domain: "Ваше доменное имя Битрикс24",
            bitrix24ConnectedSucs: "Битрикс24 подключился успешно",
            failedToConnectBitrix24: "Не удалось подключиться к Битрикс24",
            channelCreatedSuccessfully: "Канал создан успешно",
            failedToCreateChannel: "Не удалось создать канал",
            holidayPlusChannels: "Каналы „Праздник+“",
            newHolidayPlusIntegration: "Новая интеграция Holiday+",
            holidayPlusIntegrations: "Интеграция Holiday+",
            notCreateMoreThanOneHolidayChannel: "Вы не можете создать более одного канала Holiday+",
            holidayPlusDetail: "Детализация Holiday+",
            manageHolidayPlusIntegration: "Управление интеграцией Holiday+",
            ideasoftChannels: "Каналы Ideasoft",
            connectToIdeasoft: "Подключиться к Ideasoft",
            connectToIdeasoftApi: "Подключиться к Ideasoft api",
            updateChannelDesc2: "Обновить канал Whatsapp business api",
            ideasoftIntegration: "Интеграция с Ideasoft",
            sureDeleteIdeasoftChannel: "Вы уверены, что хотите удалить канал Ideasoft?",
            moreThanOneChannelError: "Вы не можете создать более одного канала Ideasoft",
            websiteAddress: "Адрес веб-сайта",
            ideasoftConnectedSucs: "Ideasoft подключен успешно",
            failedToConnectIdeasoft: "Не удалось подключиться к Ideasoft",
            redirectURLcopiedToClipboard: "URL перенаправления скопирован в буфер обмена",
            openAIChannels: "Открыть каналыAI",
            newOpenAiChannel: "Новый канал OpenAI",
            createNewChannelOpenAi: "Создать новый канал для OpenAI",
            updateChannelDesc3: "Обновить Whatsapp business api канал",
            openAiIntegration: "Интеграция OpenAI",
            sureDeleteOpenAiChannel: "Вы уверены, что хотите удалить канал OpenAI?",
            createMoreThenOneOpenAiChannel: "Вы не можете создать более одного канала OpenAI",
            postaCellChannels: "PostaCell Channels",
            newPostaCellChannel: "Новые каналы PostaCell",
            createNewPostaCellChannel: "Создать новый канал для смс-провайдера PostaCell",
            updateChannelDesc4: "Обновить канал Whatsapp business api",
            accessControl: "Контроль доступа",
            leads: "Лиды",
            ensureFacebookAccount: "Убедитесь, что у него есть аккаунт и страница Facebook",
            ensureAdAccount: "Убедитесь, что у него есть рекламный аккаунт",
            page: "Страница",
            questions: "Вопросы",
            leadCount: "Количество лидов",
            showLeads: "Показывать лиды",
            syncLeeds: "Синхронизировать Лидс",
            wpStartChat: "Запуск чата Whatsapp",
            archivedIn: "Архивировано?",
            makeSelect: "Сделать выбор",
            newLead: "Новый Лид",
            initalContact: "Первый контакт",
            needsAssessnment: "Анализ потребностей",
            proposalSent: "Предложение отправлено",
            proposalReview: "Рассмотрение предложения",
            negotiation: "Переговоры",
            decisionStage: "Стадия принятия решения",
            closure: "Закрытие",
            followUp: "Следовать",
            campagin: "Кампания",
            adSet: "Набор объявлений",
            ad: "Реклама",
            inArchived: "Архивировано",
            deletedSelectedPerson: "Удалить выбранных людей",
            sureDelSelectedPerson: "Вы уверены, что хотите удалить выбранных людей?",
            deletePerson: "Удалить человека",
            sureDeletePerson: "Вы уверены, что хотите удалить человека?",
            phoneNumberNotAvailable: "Номер телефона недоступен",
            statusSucsUpdated: "Статус успешно обновлен",
            statusUpdatedFailed: "При обновлении статуса произошла ошибка",
            archivedContact: "Архивный контакт",
            sureWantArchivePerson: "Вы уверены, что хотите заархивировать этого человека?",
            personArchived: "Персона заархивирована",
            personArchivedHead: "Операция архивации не удалась",
            metaLeadChannels: "Каналы Meta Lead Channels",
            wpStartSpeech: "Запуск речи Whatsapp",
            pleaseSelectStartChat: "Пожалуйста, выберите канал, на котором вы хотите начать чат:",
            phoneNumber: "Номер телефона",
            phoneNumberDesc: "Код страны, содержащий только цифры без пробелов",
            channelDesc: "На каком канале вы хотите начать чат",
            pleaseSelectStartChatOn: "Пожалуйста, выберите канал, на котором вы хотите начать чат",
            notAuthorisedChannel: "Вы не авторизованы для доступа к этому каналу.",
            phoneNumberError: "Неверный номер телефона",
            chatStartError: "Произошла ошибка при запуске чата. Пожалуйста, попробуйте еще раз.",
            noRecordFailed: "Запись не найдена",
            metaLeadsChannel: "Канал Meta Leads",
            mlChannelDetails: "Подробная информация о канале Meta Leads",
            manageMlChannel: "Управление вашими Мета-лидами",
            deleteMetaLeadsChannelInfo: "Вы уверены, что хотите удалить канал Meta Leads?",
            contactPage: "Контактная страница",
            addRouted: "Добавить маршрутизацию",
            otherEmailProviders: "Другие поставщики электронной почты",
            visitorScreenNaming: "Именование экрана посетителя",
            enterCatalogTitle: "Введите название каталога...",
            passwordUpdate: "Обновить пароль",
            showCenterScreen: "Отображение в центре экрана",
            skipNow: "Перейти сейчас",
            confirm: "Подтвердите",
            newTable: "Новая таблица",
            actions: "Транзакции",
            integrationsTrendyol: "Подключите свой магазин Trendyol и автоматически отвечайте на вопросы клиентов.",
            integrationsHoliday: "Интегрируйте Holiday+, чтобы предоставлять отели и номера через чат-бот!",
            integrationsTeamgram:
                "Перенесите своих клиентов с Supsis на Teamgram, чтобы оптимизировать управление клиентами!",
            integrationsTicimax: "Отправьте автоматическое сообщение сегментированным участникам Ticimax.",
            integrationsBitrix24:
                "Активируйте API Bitrix24 для улучшенного опыта работы с чат-ботом для ваших клиентов.",
            integrationsIdeasoft:
                "Активируйте API Ideasoft для улучшенного опыта работы с чат-ботом для ваших клиентов.",
            integrationsOpenAI:
                "Активировать службы OpenAI, Ответ Chatbot AI, AI Ассистент CoPilot, База знаний Chatbot AI.",
            integrationsSMSPostacell: "Активируйте отправку SMS через провайдера PostaCELL SMS.",
            integrationsMetaLeads:
                "Управляйте потенциальными клиентами Meta через Supsis. Подключите лиды к тикетам, чат-боту или живой поддержке.",
            integrationsZoho: "Интегрируйте свои бизнес-процессы в Zoho CRM с помощью Supsis.",

            forward: "вперед",
            packUpRequired: "Требуется обновление пакета",
            upgradePack: "Пакет обновления",
            supsisMobilApp: "SUPSIS МОБИЛЬНОЕ ПРИЛОЖЕНИЕ",
            supsisMobilAppDesc: "Приложение для IOS и Android на рынке!",
            sendEmail: "Отправить электронное письмо",
            jumpToMessage: "Нажмите, чтобы перейти к сообщению",
            doesntMatter: "Неважно.",
            events: "События календаря",
            reservations: "Бронирование",
            designer: "Дизайнер",
            targetContacts: "Целевые контакты",
            scheduler: "Планировщик",
            planAndTask: "План и задачи",
            insights: "Инсайты",
            createRole: "Создать роль",
            createSubject: "Создать тему",
            createUser: "Создать пользователя",
            blockManuel: "Блок Мануэль",
            showHide: "показать/скрыть",
            contactSearch: "Контактный поиск",
            favorites: "избранное",
            downloadAllData: "загрузить все данные",
            downloadThePage: "страница загрузки",
            choosePoints: "выберите очки",
            channel: "Канал",
            createdAt: "Созданный на",
            action: "Действие",
            searchChannel: "Канал поиска",
            activeChannels: "Активные каналы",
            deleteChannels: "Удаленные каналы",
            selectChannel: "Выберите канал",
            channelFilter: "Канальный фильтр",
            noConversationDesc: "Здесь вы можете увидеть активные чаты и чаты, назначенные вам.",
            forMe: "Для меня",
            unAssigned: "Не назначено",
            agentDetails: "Детали агента",
            contactProperties: "Контактные данные",
            goToProfile: "Перейти к профилю",
            addNote: "Добавить заметку",
            noPreferredAgent: "Пока нет предпочтительного агента",
            toPrefer: "Предпочитать",
            inChat: "В чате",
            watching: "Смотрит",
            chatsTitle: "Чаты",
            dealyTimeMaxValueError: "Время задержки может быть максимум 15",
            dealyTimeTypeError: "Значение времени задержки должно быть числом",
            passedTimeHm: "{hour} Часов {min} Минут",
            passedTimeMs: "{min} Минут {sec} секунд",
            passedTimeSc: "{sec} секунд",
            translateMessage: "Ваше сообщение было переведено искусственным интеллектом.",
            toneChanged: "Тон сообщения изменен на {tone}",
            aiResponseAdded: "Ответ ИИ добавлен в сообщение",
            messageLonger: "Сообщение сделано длиннее",
            grammarFixed: "Грамматика исправлена",
            aiTranslate: "Перевод",
            other: "Другое",
            yourLanguage: "Ваш язык",
            contactLanguage: "язык клиента",
            myLanguage: "Мой язык",
            forwardToChatbot: "Переслать Чатботу",
            friendly: "Дружелюбный",
            confident: "Уверенный",
            straightForward: "Прямолинейный",
            casual: "Повседневный",
            professional: "Профессиональный",
            longSentence: "Длинное Предложение",
            changeTone: "Изменить Тон",
            fixGrammar: "Исправить Грамматику",
            aiResponse: "Ответ ИИ",
            templateButtonNote:
                "Для запрета контакта используйте следующие тексты на кнопке запрета. Независимо от заглавных или строчных букв",
            templateButtonTags: "#Отправить сообщение# | #Отписаться# | #Запретить# | #Заблокировать#",
            dashboard: "Панель инструментов",
            calendarModule: "Модуль календаря",
            taskModule: "Модуль управления задачами",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            searchForDepartment: "Поиск по отделу",
            assignPreferredDepartment: "Назначить предпочтительный отдел",
            smsChannel: "Канал SMS: ",
            whatsappv2Channel: "Канал Whatsapp V2: ",
            whatsappv1Channel: "Канал Whatsapp V1: ",
            wBChannel: "Канал Whatsapp Business: ",
            messengerChannel: "Канал Messenger: ",
            instagramChannel: "Канал Instagram: ",
            allPlatforms: "Все платформы",
            cbStartMessage: "Сообщение запуска чатбота",
            cbStartMessageDesc:
                "Первое сообщение, введенное пользователем, автоматически обрабатывается чатботом и направляется на соответствующий адрес.",
            messengerUserProfile: "Профиль пользователя Messenger",
            instagramUserProfile: "Профиль пользователя Instagram",
            noEventFound: "Событие не найдено",
            visitorMails: "Почта посетителя",
            visitorActions: "Действия посетителя",
            notVerified: "Не верифицировано",
            visitorEvents: "События посетителей",
            assignedTasks: "Назначенные задачи",
            mails: "Почта",
            prefferedAgents: "Предпочитаемые агенты",
            createEvent: "Создать событие",
            blockManagement: "Управление блокировкой",
            deleteUser: "Удалить пользователя",
            blocked: "Заблокированный",
            profiles: "Профили",
            similiarProfiles: "Найдены похожие профили",
            ReplyAsAPm: "Ответить как личное сообщение и закрыть",
            replyAsAComment: "Ответить как комментарий и закрыть",
            messengerAddDesc: "Нажмите на кнопку Подключить ниже и войдите в свою учетную запись Facebook.",
            instaAddPrivacyCheckDesc: "Я прочитал и согласен с {Privacy} и {Terms and Conditions}",
            instaAddDesc5: "Нажмите на кнопку Подключить ниже и войдите в свою учетную запись Facebook.",
            instaAddDesc4: "Зарегистрируйтесь в качестве разработчика Facebook",
            instaAddDesc3: "Убедитесь, что переключатель <b>'Разрешить доступ к сообщениям'</b> включен",
            instaAddDesc2: "Убедитесь, что ваш профессиональный аккаунт Instagram подключен к вашей странице Facebook",
            instaAddDesc1: "Убедитесь, что ваш аккаунт Instagram является профессиональным (бизнес) аккаунтом.",
            selectedDepartment: "Выбранный отдел",
            departmentForwardEnable: "Включено правило переадресации отдела",
            departmentForwardRule: "Правило переадресации отдела",
            departmentForwardDesc: "Выберите, в какой департамент будут направляться входящие чаты в канал.",
            channelName: "Название канала",
            forwardToLiveAgents: "👉 Переадресовать живым агентам",
            manageIgChannel: "Управление вашим Instagram каналом",
            igDetail: "Детали Instagram",
            manageVisibilityDesc: "Управление тем, кто может видеть этот канал",
            selectAnIgAccount: "Выберите аккаунт Instagram",
            connectToInsta: "Подключиться к Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Вы уверены, что хотите удалить канал Instagram?",
            instagramChannels: "Каналы Instagram",
            suspendedDescription: "Ваш аккаунт заблокирован из-за неоплаченных счетов",
            onlyChatbot: "Только чатбот",
            onlyAgents: "Только агенты",
            checkboxWarning: "Это поле должно быть обязательно отмечено",
            sendingAllow: "Отправка",
            receiving: "Получение",
            platform: "Платформа",
            banModalTitle: "Модальное окно запрета посетителя",
            selectDepartmentDesc: "Выберите отделы, для которых вы хотите изменить видимость",
            selectAgentDesc: "Выберите агентов, для которых вы хотите изменить видимость",
            selectDepartment: "Выберите отдел",
            selectAgent: "Выберите агента",
            visibleDepartments: "Видимые отделы",
            visibleAgents: "Видимые агенты",
            visibilityInfoCont: "Все агенты и отделы могут видеть этот канал",
            editDepartmentVisibility: "Изменить разрешения отдела",
            editAgentVisibility: "Изменить разрешения агента",
            typeSTToSearch: "Введите что-нибудь для поиска пользователей",
            exportToCSV: "Экспорт в CSV",
            clear: "Очистить",
            usedSessionCount: "Количество использованных сеансов",
            maxSessionCount: "Максимальное количество сеансов",
            leftSessionCount: "Оставшееся количество сеансов",
            planManagement: "Управление планом",
            maxAutomationTask: "Максимальное количество автоматизированных задач",
            teamChat: "Чат команды",
            templateNameIsNotValid: "Имя шаблона недействительно",
            relatedAdvertisement: "связанная реклама",
            whatsappNumber: "Номер WhatsApp",
            integrationsWhatsappV1:
                "Для беспроблемного взаимодействия между Supsis и WhatsApp требуется план WhatsApp.",
            integrationsWhatsappV2: "Вы можете легко передавать информацию о чате между Supsis и WhatsApp.",
            integrationsWhatsappBusiness:
                "Вы можете быстро и удобно передавать информацию о чате между Supsis и WhatsApp.",
            selectDays: "Выберите дни",
            addTime: "Выберите время",
            instagramContactList: "Список контактов Instagram",
            archiveAllRated: "Получить все разговоры с любыми оценками.",
            allChannels: "все каналы",
            comment: "комментарий",
            news: "что нового",
            conversation: "командный разговор",
            speechTermination: "закончить разговор",
            noSystemMessage: "Сообщений в системе пока нет!",
            supsisCustomerService: "Услуги для клиентов, предоставляемые Supsis,",
            supsisClickExperience: "Вы можете попробовать опыт, нажав.",
            customerPage: "Перейти на страницу клиента",
            buttonTitle: "Название кнопки",
            buttonType: "Тип кнопки",
            buttonSendMessage: "Отправить сообщение",
            buttonGoToBlock: "перейти в блог",
            buttonOpenUrl: "Открыть URL",
            buttonPhoneCall: "Телефонный звонок",
            buttonOpenMoment: "Открытый момент",
            buttonCloseChat: "Закрыть чат",
            buttonTransferChat: "Трансферный чат",
            buttonCreateTicket: "Создать тикет",
            deleteVisitor: "Вы уверены, что хотите удалить пользователя? Это действие не может быть отменено.",
            userProfile: "Профиль",
            addCalendarEvent: "Добавить +",
            apiIntegration: "разработчик",
            generateToken: "Создать токен",
            copyToken: "Копирование токена",
            dndBlocked: "Настройки отправки файлов отключены.",
            labels: "Этикетки",
            noData: "Нет данных",
            color: "Цвет",
            titleColor: "Цвет заголовка",
            secondTitleColor: "Цвет второго заголовка",
            tag_name_indicator: "Название этикетки",
            sendMessage: "Отправить сообщение",
            removeFromG: "Удалить из группы",
            delChannel: "Вы уверены, что хотите удалить этот канал?",
            new_name: "Новое имя",
            set_group_info: "Редактировать информацию о группе",
            shortcut_desc_num: "Переключение между активными разговорами с использованием цифровых цифр",
            copilot_desc_num: "Позволяет открыть Copilot на экране чата.",
            typing_w_chat: "пишет...",
            edit_group_info: "Редактировать информацию о группе",
            notif_sound: "Включить звук уведомлений",
            notif_mute: "Отключить уведомления",
            leave: "Уйти",
            group: "Группа",
            updateTag: "Обновить метку",
            ordered_desc: "Распределяет чаты сотрудникам по порядку.",
            random_desc: "Распределяет чаты сотрудникам случайным образом.",
            Rrobin_desc: "Распределяет чаты сотрудникам круговым методом. (Приоритет у наименее занятых сотрудников)",
            RrobinRev_desc:
                "Распределяет чаты сотрудникам круговым методом в обратном порядке. (Приоритет у наиболее занятых сотрудников)",
            algo_desc: "Выберите алгоритм для автоматического распределения чатов",
            algorithm: "Алгоритм",
            os_browser: "Операционная система и браузер",
            addTag: "Добавить тег",
            tags: "Теги",
            searchRepresentative: "Поиск представителя",
            voting: "Голосование",
            CHAT: "Чат",
            chatWidget: "Supsis Виджет чата",
            webhooks: "вебхуки",
            selectHooks: "Выберите веб-хуки",
            planRequired: "{integratable} Требуется план",
            allIntegrations: "Все интеграции",
            disableAgentSystemMessages: "Скрыть системные сообщения агента",
            disableAgentSystemMessagesDesc: "Скрыть системные сообщения агента.",
            disableAutoTranslate: "Автоматический перевод",
            disableAutoTranslateDesc:
                "Автоматически переводит сообщения с разных языков. Это позволяет вам легче общаться с клиентами.",
            shouldAddMethod:
                "Вы должны заполнить поля «Способ оплаты» и «Платежный адрес»! \nДеньги не будут сняты с вашего счета.\n" +
                "В конце месяца будет выставлен счет в соответствии с суммой использования.",
            approveSelection: "Утвердить выбор",
            trialDaysEndSelectPlan: "Подтвердить выбор плана",
            trialDaysEndSelectPlanDesc:
                "Ваша пробная версия закончилась. Вам необходимо подтвердить, выбрав план ниже.",
            infoAboutAnnouncement: "Краткая информация об объявлении",
            announcement: "Объявление",
            languageSelection: "Выбор языка",
            newAnnouncementForm: "Новая форма объявления",
            newAnnouncement: "Новое объявление",
            announcements: "Объявления",
            infinitePlay: "Играть непрерывно",
            vtippyHideBubbleOnMobile: "Чат Bubble скрыт от мобильных пользователей.",
            hideBubbleOnMobile: "Скрыть на мобильном",
            deleteSystemLanguage: "Удалить язык {code} из системы",
            assignedChat: "Assigned Chat",
            check: "Check box",
            newTicketSound: "Новый билет",
            vtippyDepartmentNotification: "Настройки уведомлений для сообщений из департаментского разговора",
            vtippyGroupNotification: "Настройки уведомлений для сообщений из созданных групп",
            vtippyAnnouncemenNotification: "Настройки уведомлений для новых объявлений",
            warning: "Предупреждение",
            billingAddress: "Адрес для выставления счета",
            addNewAddress: "Добавить новый адрес",
            adressTitle: "адрес Название",
            address: "адрес",
            systemStatus: "Статус системы",
            chatAssignedToUser: "Чат назначен новому пользователю",
            inactiveThresholdTime: "Время неактивного чата (минуты)",
            tippyInactiveThresholdTime:
                "Если в течение указанного времени не будет отправлено ни одного сообщения, разговор считается неактивным. Введите значение (минуты). Должно быть в диапазоне от 1 до 120 минут.",
            inactiveTerminateTime: "Время завершения неактивного чата (минуты)",
            tippyInactiveTerminateTime:
                "Неактивный чат будет завершен, если он не перейдет в активный режим в течение определенного времени. Введите значение (минуты). Должно быть в диапазоне от 1 до 120 минут.",
            removePendingMessage: "Отменить отправку сообщения",
            disconnected: "Отключено",
            visitorWriteEmptyChatTippy: "Клиент может писать в беседу до подключения агента.",
            visitorWriteEmptyChat: "Клиент может писать без подключения агента.",
            visitorConnectionEventSystemMessageEnabled:
                "Системные сообщения о состоянии соединения с посетителями Включить",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Системные сообщения «Посетитель ушел» и «Посетитель вернулся» позволяют",
            openBubble: "Открыть пузырь",
            showHeaderImage: "Показать изображение заголовка",
            askQuestion: "Задайте вопрос",
            locationPermsNeeded: "Необходимые разрешения на местоположение",
            useMyLocation: "Использовать мою локацию ",
            acceptingChat: "Прием чатов",
            notAcceptingChat: "Не принимает чаты",
            loggedOut: "Вышли из",
            websiteChatWidgetIntegration: "страница Реализация",
            hideInactiveAgents: "Скрыть неактивных агентов",
            hideMinorValues: "Hide Minor Values",
            agentActivities: "Деятельность агента",
            listStatuses: "Статусы",
            newHASHContent: "#Добавить метку",
            changeLogo: "Изменить логотип",
            changePhoto: "Изменить фотографию",
            addPhoto: "Добавить фотографию",
            seePhoto: "См. фото",
            deletePhoto: "Удалить фотографию",
            languageRemovalQuestion: "Вы собираетесь удалить язык {code} из системы!",
            hash: "Хэштег",
            hashText: "Хэш-текст",
            updateCompleted: "обновление завершено",
            CatalogUpdatedSuccessfully: "Каталог успешно обновлен",
            integrateSupsiswithIntegratable: "С легкостью передавайте информацию чата между Supsis и {integratable}.",
            installationOK: "установлены",
            exampleHash: "отслеживание заказа",
            notValidHash: "Не должно содержать пробелов.",
            videoCallEnabledDesc: "Активируйте, чтобы включить функцию видеозвонка.",
            videoCallEnabled: "Функция видеозвонка",
            audioCallDesc: "Активируйте, чтобы включить функцию голосового поиска.",
            audioCallEnabled: "Функция голосового поиска",
            assignPreferredAgent: "Назначить предпочтительного агента",
            representativeAssignedToTheVisitor:
                "Выберите предпочитаемого агента, которого хотите назначить посетителю.",
            agentFileSendEnabledDesc: "Позволяет отправлять файлы делегатам",
            agentFileSendEnabled: "Представители могут отправлять файлы",
            visitorFileSendEnabledDesc: "Позволяет включать и выключать функцию отправки файлов посетителям.",
            visitorFileSendEnabled: "Посетители могут отправлять файлы",
            visitorAutoLogin: "Автоматический вход посетителя",
            visitorAutoLoginDesc: "Автоматический запуск разговора, когда посетитель нажимает на всплывающее окно чата",
            agentVoiceRecordEnabledDesc: "Позволяет агентам записывать звук",
            agentVoiceRecordEnabled: "Агенты могут записывать аудио",
            visitorVoiceRecordEnabledDesc: "Позволяет посетителям записывать аудио",
            visitorVoiceRecordEnabled: "Посетители могут записывать аудио",
            startVideoCall: "Видеозвонок",
            startAudioCall: "Голосовой звонок",
            visitorGDPRDeleteEnabledDesc:
                "Позволяет включить/выключить возможность удаления всей информации о посетителях.",
            visitorGDPRDeleteEnabled: "Посетители могут удалить всю свою информацию",
            visitorLocationEnabled: "Посетители могут делиться местоположением",
            visitorLocationEnabledDesc:
                "Позволяет посетителям включать или выключать совместное использование местоположения",
            customerLocationEnabled: "Пользователи могут делиться местоположением",
            customerAutoMergeEnabled: "Автоматически объединяет одних и тех же людей",
            customerAutoMergeEnabledDesc:
                "Эта функция выполняет автоматическое объединение, эффективно собирая данные, относящиеся к одним и тем же людям. Это обеспечивает более последовательное и упорядоченное представление пользователей с похожими профилями в наборах данных.",
            chatAiCopilot: "Чат ИИ Копилот",
            chatAiCopilotDesc: "Автоматически отвечайте на вопросы ваших клиентов, используя Чат ИИ Копилот",
            customerLocationEnabledDesc:
                "Позволяет пользователям включать или выключать совместное использование местоположения",
            thoesNotOwners: "Держать в очереди тех, кто не является владельцем беседы",
            thoesNotOwnersDesc:
                "Вы включаете эту функцию, чтобы держать в очереди людей, которые не являются владельцами беседы",
            hideContactInfo: "Скрывать контактную информацию",
            hideContactInfoDesc:
                "Когда вы включаете эту функцию, номера и электронные адреса ваших клиентов будут скрыты от агентов",
            triggerAlreadyExists: "Триггер уже существует.",
            ticketStatusForm: "Форма статуса билета",
            statusFormTitle: "Название статуса заявки",
            allStatus: "Все статусы",
            triggers: "Триггеры",
            trigger: "Курок",
            noTrigger: "Вы еще не добавили ни одного триггера",
            triggerSkipLoginForm: "Форма входа",
            triggerSkipLoginFormTrue: "Показать форму входа",
            triggerSkipLoginFormFalse: "Пропустить форму входа и перейти к сообщению",
            noContent: "нет содержания",
            toCreate: "Создать",
            clickTheButton: "нажмите кнопку",
            noLiveSupportFoundWithDepartment: "Нет речи, принадлежащей отделу",
            triggerContent:
                "Введите описание, которое вы хотите отобразить в открывшемся модальном окне. Вам нужно только писать на одном языке, а перевод на другие языки выполняется автоматически.",
            triggerDrag: "Вы можете настроить продолжительность сообщения, перетащив или щелкнув полосу.",
            triggerNewCondition: "Вы можете добавить новое условие с помощью кнопки.",
            triggerNoConditionDescription1:
                "Вы можете создать нужные условия из опций. Если вы не создадите никаких условий ни для одного триггера, активным будет первый триггер.",
            triggerNoConditionDescription2:
                "На странице посетителя отображается только один из триггеров с одинаковыми условиями.",
            triggerShowAndHide: "Вы можете показать или скрыть триггеры, когда захотите.",
            countryLanguage: "Страна/Язык",
            addTrigger: "Добавить триггер",
            saveSystemCardInfo:
                "Ваша карта будет сохранена в нашей системе и оплачена автоматически, когда наступит срок оплаты.",
            cardNumber: "Номер карты",
            cardType: "Тип карты",
            skt: "сг",
            cvv: "CVV",
            saveCard: "Сохранить карту",
            cardNameSurname: "Имя и фамилия держателя карты",
            confidentialityAgreementCheck: "Я принимаю соглашение о конфиденциальности",
            confidentialityAgreement: "соглашение о конфиденциальности",
            yesPlease: "Да, пожалуйста!",
            noThanks: "Спасибо, не надо.",
            firstAnswer: "Вопрос Диалог Подтвердить Ответ",
            secondAnswer: "Вопрос Диалог Отклонить Ответ",
            noTitle: "Без названия",
            sumChat_MediaFile: "Медиа и документы",
            importantWarning: "ВАЖНОЕ ПРЕДУПРЕЖДЕНИЕ!",
            images: "Изображения",
            URLS: "Ссылки",
            files: "Файлы",
            noCondition: "Нет условий! Вы можете добавить Условия, щелкнув значок плюса.",
            showTriggers: "Нажмите, чтобы показать триггеры",
            showThisTrigger: "Нажмите, чтобы показать этот триггер",
            hideTriggers: "Нажмите, чтобы скрыть триггеры",
            hideThisTrigger: "Нажмите, чтобы скрыть этот триггер",
            updateTrigger: "Триггер обновления",
            conditions: "Условия",
            messageDurationPerRow: "Длительность сообщения в строке",
            vtippyTicketNotification: "Настройки уведомлений для каждого нового билета, который вы получаете",

            dayTime: "Час",
            weekDay: "День недели",
            spendTimePage: "Время, проведенное на странице",
            spendTimeSite: "Проведенное время на сайте",
            pageUrl: "URL-адрес страницы",
            pageTitle: "Заголовок страницы",
            vtippyNewVisitorNotification: "Звуковое оповещение о каждом новом посетителе вашего сайта",
            vtippyTranslateButton: "Переводит выбранный язык на другие языки",
            vtippyTranslateClearButton: "Очищает контент на других языках.",

            vtippySelectnotification: "Вы можете выбрать звук уведомления.",
            vtippyVoiceLevel: "вы можете регулировать громкость",
            vtippyStartVoice: "Слушать",
            vtippyInfiniteNotification:
                "Если вы не активны на новой панели чатов, она продолжит играть. Вы можете редактировать актив-пассив, нажав.",

            vtippyNewChatNotification:
                "Вы можете выбрать звуковое оповещение о новых разговорах, поступающих в систему, и отрегулировать громкость.",
            vtippyNewConversationNotification:
                "Вы можете выбрать звуковое уведомление и отрегулировать громкость, когда новые входящие разговоры назначаются вам.",
            vtippyNewMessageNotification:
                "Вы можете выбрать уведомления о входящих сообщениях в свои разговоры и настроить громкость.",
            vtippyPrivateMessageNotification:
                "Вы можете выбрать уведомление о входящем сообщении в командный разговор.",
            equal: "Равный",
            not_equal: "Не равный",
            less_than: "Меньше, чем",
            greater_than: "Лучше чем",
            less_than_or_equal: "Меньше или равно",
            greater_than_or_equal: "Больше или равно",
            visitorName: "Имя посетителя",
            seconds10: "10 секунд",
            seconds30: "30 секунд",
            minute1: "1 минута",
            minutes5: "5 минут",
            minutes10: "10 минут",
            minutes30: "30 минут",
            hour1: "1 час",
            hours2: "два часа",
            hours4: "4 часа",
            hours8: "8 часов",
            hours12: "12 часов",
            hours24: "24 часа",
            maxCondition: "Максимальное состояние",
            doYouWishToDeleteTrigger: "Вы хотите удалить триггер",
            contains: "Содержит",
            not_contains: "Не содержит",
            chatLanguage: "Язык чата",
            translating: "Идет перевод",
            buyWhatsapp: "Приобрести интеграцию с WhatsApp",
            liveSupportStartingWait: "Запуск поддержки в режиме реального времени, пожалуйста, подождите",
            noConnection: "Нет соединения!",
            integrations: "Интеграции",
            refundInvoiceSure: "Вы уверены, что хотите вернуть счет?",
            invoiceMarkedAsPaidSuccess: "Счет отмечен как успешно оплаченный",
            invoiceMarkedAsPaidError: "Ошибка, счет не помечен как оплаченный",
            deleteConfirm: "Вы хотите удалить этот {object}?",
            markPaidConfirm: "Вы уверены, что пометите этот счет как оплаченный?",
            startChatDesc: "Начать разговор",
            addLink: "Ссылка на сайт",
            selectStep: "Выберите шаг:",
            addGOTO: "Перейти к",
            sendFastLink: "Отправить Fast Link",
            or: "или",
            allTags: "Все теги",
            showDetail: "Показать детали",
            hideDetail: "Скрыть детали",
            weLlSendPhone: "Мы отправим на ваш телефон",
            weLlSendEmail: "Мы отправим на Ваш e-mail",
            linkSentToPhone: "Ссылка отправлена в смс",
            offerlinkSendToPhone: "Мы вышлем вам ссылку для скачивания нашего приложения в SMS.",
            offerlinkSendToMail: "Мы вышлем вам ссылку для скачивания нашего приложения в Почта.",
            theEmail: "Моя зарегистрированная электронная почта",
            differentEmail: "Другое электронное письмо",
            linkSentToMailBox: "Ссылка отправлена на ваш почтовый адрес",
            errorOccurred: "Произошла ошибка !",
            clickStoreIcon:
                "Вы можете получить доступ к мобильному приложению, нажав на значок, подходящий для вашего телефона.",
            meetWithSupsis: "Хотите познакомиться с нашим мобильным приложением SUPSIS?",
            downloadMobileApps: "Скачать мобильное приложение",
            getApps: "Получить приложения",
            info: "Информация",
            conversationHistory: "История разговоров",
            planInfoHeader: "Информация о плане",
            planInformation:
                "Ваш тарифный {selectedPlan} план ({detailMaxAgentCount} агент) ({freeAgent} свободный агент)",
            creditAvailable: "Ваш агентский кредит доступен в вашем плане: ",
            upDownGradePlan: "Если вы хотите повысить / понизить свой тарифный план, пожалуйста",
            click: "Нажмите",
            autoStartChat: "Автоматический запуск чата",
            bubbleColor: "Цвет пузыря чата",
            openFolder: "Открыть папку",
            preDefined: "Темы",
            customIcon: "Установить со своего компьютера",
            theme: "Тема",
            themeSettings: "Настройки темы",
            chatThemeSettings: "Настройки темы чата",
            bubbleSettings: "Настройки пузыря чата",
            inputHeightOfBubble: "Размер пузыря",
            inputPixelsOfChatBubble: "Нажмите, чтобы изменить расстояние от пузыря чата до краев",
            modalTitleIsMarginAsPixelInfo: "Расстояния от чат-пузыря до краев : ",
            inputPxOfXaxis: "Горизонтальное положение",
            inputPxOfYaxis: "Вертикальное положение",
            inputPxOfMobileXaxis: "(Mobil) Horizontal Position",
            inputPxOfMobileYaxis: "(Mobil) Vertical Position",
            animations: "Анимации",
            preferredAnimation: "Предпочтительная анимация",
            selectAnAnimation: "Выберите анимацию",
            inputOfBubbleMessage: "Добавляйте контент в большие пузыри чата.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "Это настройка для скрытия всплывающей подсказки чата в зависимости от статуса входа в систему.Показывается всем посетителям в случае Off.",
            showChatBubbleOnlyLoggedUser:
                "Показывать всплывающую подсказку только авторизованному пользователю. (ideasoft)",
            helloDoUNeedHelp: "Привет, тебе нужна помощь?",
            bubbleIcon: "Изображение пузыря чата",
            overrideMargins: "Настроить поля",
            autoHideBubble: "Скрыть пузырь чата",
            vtippyAutoHideBubble: "Скрывает всплывающее окно чата, когда агенты не в сети",
            hideBubble: "Отключить чат-пузырь",
            vtippyHideBubble: "Отключает пузырь чата.",
            overrideMobileMargin: "Customize Margins for Mobile",
            vtippyMobileMargin: "Customize Margins for Mobile",
            isFabsActive: "Показать плавающую кнопку действия",
            isAlwaysActive: "Меню всегда открыто",
            isAlwaysActiveDesc: "Хотите, чтобы меню чат-окна всегда оставалось открытым в веб-версии?",
            bubbleOpenableMenu: "Выпадающее меню чата",
            vtippyIsFabsActive: "Настройка отображения/скрытия плавающей кнопки действия",
            vtippyIsFabsAsIcon: "Это настройка того, будут ли значки отображаться в раскрывающемся меню.",
            isFabsAsIcon: "Показать значки меню.",
            setMarginAsPixel: "Установить как пиксель",
            returnDefaultMargins: "Настройки поля по умолчанию",
            deleteSite: 'Вы хотите удалить сайт " {siteName} " ?',
            deleteThisSite: "Удалить сайт",
            assetOversizeWithExt: "Размер файла должен быть менее 10 МБ и в формате png, jpg.",
            all: "Все",
            allDepartments: "Все отделы",
            preferredLanguage: "предпочтительный язык",
            kmkAutoDepartmentBind: "KMK Поиск автоотдела",
            kmkAutoDepartmentBindDesc:
                "Найдите продавца на сайтах клиентов KMK и настройте страницу входа в качестве отдела",
            chatBot: "Чат-бот",
            ticketResponse: "Представительский ответ:",
            archived: "Архив",
            chatbotChatCount: "ЧАТБОТ",
            visitorEmailUpdated: "Электронная почта посетителя обновлена",
            visitorEmailIsNotValid: "Электронная почта посетителя недействительна",
            visitorNameUpdated: "Имя посетителя обновлено",
            clickToEdit: "Нажмите, чтобы изменить",
            addEmail: "+ Добавить электронную почту",
            addFullname: "+ Add Fullname",
            partner: "Ref?",
            isIntegrated: "Интеграция?",
            agentCount: "Количество агентов",
            closePreviewColors: "Закрыть предварительный просмотр темы",
            previewColors: "Открыть предварительный просмотр темы",
            videoCalls: "Видеозвонки",
            filterLost: "Потерянные чаты",
            vtipyCustomLogin:
                "Вы можете настроить информацию, которая будет запрашиваться в форме входа, когда ваши посетители подключаются к системе.",
            vtipyLoginlessChat: "Форма входа посетителя будет скрыта. Посетитель может подключиться к чату напрямую.",
            loginlessChat: "Форма входа посетителя видна",
            imageUrl: "URL изображения",
            replied: "Ответил",
            solved: "Решено",
            openImage: "Открыть изображение",
            writeFeedback: "Вы можете написать свой отзыв о SUPSIS здесь.",
            feedbackFailed: "Ошибка при отправке отзыва.",
            feedbackSuccessful: "Отзыв отправлен.",
            sendFeedback: "Отправить отзыв",
            errorReport: "Вы можете сообщить нам о своих проблемах с SUPSIS.",
            sendErrorFeedBack: "Поделитесь с нами своим мнением о проблеме, с которой вы столкнулись.",
            successImgUpload: "Ваше изображение было успешно загружено.",
            successImgDelete: "Изображение успешно удалено.",
            errorImgUpload: "Произошла ошибка при загрузке вашего изображения.",
            errorImgDelete: "При удалении изображения произошла ошибка",
            chatBotEndStatics: "Коэффициент успешности разговора с чат-ботом",
            videoCallDist: "Распределение видеозвонков",
            departmentInfo: "Информация об отделе",
            infoAboutDepartment: "Дайте краткую информацию об отделении",
            deleteDepartmentQuestion: "Вы действительно хотите удалить этот отдел?",
            departmentDeleted: "Отдел удален",
            departmentTitle: "Название отдела",
            updateDepartmentForm: "Форма обновления отдела",
            newDepartmentForm: "Форма нового отдела",
            department: "отделение",
            newDepartment: "Новый отдел",
            departmentSaved: "Отдел сохранен",
            sameDepartment: "Существует отдел с таким же названием",
            sameValue: "Существует значение с таким же именем!",
            sameTag: "Существует тег с таким именем!",
            departments: "Отделы",
            chatTimingSettings: "Настройки времени чата",
            assetOversize: "Размер отправляемого файла не должен превышать 2 МБ.",
            assetOversizeMB: "Размер файла, который вы хотите отправить, не должен превышать {mb}МБ.",
            messageDeleted: "Это сообщение удалено",
            filterVideoCall: "Фильтр видеозвонков",
            filterLostChat: "Фильтры Потерянные чаты",
            filterClosedByAgent: "Фильтр закрыт агентом",
            notificationText: " Супсису нужно разрешение на",
            notificationTitle: "Уведомления отключены",
            deniedText:
                "Ваши уведомления закрыты, вам нужно включить свои уведомления, чтобы не пропустить своих клиентов.",
            deniedTitle: "Нажмите, чтобы открыть свои уведомления!",
            deniedHeader: "Чтобы не упустить своих клиентов, вам необходимо включить свои уведомления!",
            showNotificationGuide: "Нажми для деталей",
            howToEnableNotification: "Как я могу включить уведомления",
            notificationOK: "Ok",
            notificationUnderstood: "Понял!",
            notificationCancel: "Отмена",
            howToEnableNotificationInstruction1: "Нажмите на значок замка в адресной строке браузера",
            howToEnableNotificationInstruction2: "Если «Уведомления» отключены в разделе «Разрешения», включите их.",
            howToEnableNotificationInstruction3:
                "Если «Уведомления» не отображаются в разделе «Разрешения», нажмите «Настройки сайта».",
            howToEnableNotificationInstruction4:
                "Включите разрешение «Уведомления» в разделе «Разрешения» на странице настроек сайта.",
            checkPaymentMethod: "Пожалуйста, проверьте способ оплаты",
            pushNotificationEnabled: "Отлично, Push-уведомление включено",
            pushNotificationDenied: "Вы отказали в разрешении на уведомление",
            suspendedMessage: "Ваша учетная запись была приостановлена",
            enableNotification: "Включите уведомления на рабочем столе.",
            languageSettings: "выбранный язык",
            problemsSound:
                "Если у вас возникли проблемы с уведомлениями, вы можете щелкнуть изображение блокировки в окне поиска браузера (показано на рисунке), щелкнуть «Настройки сайта» и изменить «Звук» на «Разрешить».",
            betweenRepresentative: "Есть новое сообщение от представителя",
            desktopNotifications: "Уведомления на рабочем столе",
            notificationEnabled: "Уведомления на рабочем столе SUPSIS включены.",
            newMessageAlert: "У вас есть новое сообщение.",
            notificationDisable: "Вы можете отключить уведомление в настройках представителя",
            newConversationAlert: "У вас новый посетитель.",
            autoLoadIframe: "Живой трафик",
            autoLoadIframeDesc: "Автоматически загружать iframe, пропускать весь трафик посетителей",
            enableState: "Активный?",
            requiredFieldField: "Это поле обязательно к заполнению",
            catalogCategoryMenu: "Добавить меню категории каталога",
            catalogCategoryLeaf: "Добавить подменю категории каталога",
            closeChat: "Завершить обмен сообщениями",
            ticket: "Билет",
            formStep: "Шаг формы",
            menuStep: "Шаг меню",
            contentStep: "Шаг содержания",
            menuTitle: "Заголовок меню",
            messageContent: "Содержание сообщения",
            goToLive: "Передача представителю",
            prevStep: "Вернуться к предыдущему шагу",
            button: "Кнопка",
            addImage: "Изображение",
            addText: "Текст",
            stepTitle: "Название шага",
            addTicket: "Проездной билет",
            formDescription: "Вопрос",
            addInput: "Вопрос",
            addRandomText: "Случайный текст",
            changeTitle: "Изменить заголовок",
            changeVisitorTitle: "Изменить заголовок посетителя",
            catalog: "Название каталога",
            openTheCatalog: "Открытый каталог",
            catalogNotOpen:
                "Функция каталога отключена. Вы можете включить функцию каталога, чтобы поддерживать своих клиентов заранее подготовленным контентом. ",
            showCatalogCategories: "Измените способ отображения меню каталога в пузыре чата. ",
            showChatBot: "Измените статус меню чат-бота, чтобы он отображался в пузыре чата.",
            openCatalog: " Каталог ",
            unreadMessages: " Непрочитанные сообщения ",
            personalFirstMsg: "Среднее время первого ответа агента (сек)",
            personalRating: " Средний балл персонала",
            soundSettings: " Настройки звука ",
            newPrivateMessage: " Личное сообщение ",
            addNewGroup: "Создать новую группу",
            newMessage: " Новое сообщение ",
            newConversation: "новый чат ",
            newVisitor: " Новый посетитель ",
            chatPosition: " Расположение чата ",
            bottomLeftCorner: "нижний левый угол",
            leftDocked: "оставил в пристыкованном виде",
            bottomRightCorner: "нижний правый угол",
            rightDocked: "справа закреплено",
            chatPositionSelect: " Выберите место ",
            teamChatGroup: "Групповые сообщения",
            teamChatDepartment: "Сообщения отдела",
            teamChatTeam: "Сообщения команды",
            teamChatDm: "Личные сообщения",
            bottomLeft: " Внизу слева ",
            left: "Слева",
            bottomRight: "Внизу справа ",
            right: "Справа",
            mailorname: " Электронная почта или имя ",
            breaksByTime: " Количество перерывов по времени ",
            clPlaceholder: " Имя, которое будет отображаться в форме клиента ",
            fieldName: " Имя ключа ",
            value: "Значение",
            addSetting: " Добавить новую настройку ",
            globalSettings: "Общие настройки",
            target: " Адрес нагрузочного теста ",
            duration: " Время нагрузочного теста(сек)",
            arrivalCount: " Количество ботов(шт)",
            bootMaxLife: "Время жизни бота(сек)",
            startLoadTest: " Начать нагрузочный тест ",
            noClusterInstanceFound: "Сервер не найден",
            stopLoadTest: " Завершить нагрузочный тест ",
            integrationDesc: "Просто добавьте на свой сайт приведенный ниже однострочный код.",
            integrationDemoCode: " Пример демо кода интеграции ",
            integrationWindow: " Как мне интегрировать мой сайт?",
            notIntegrated: "интеграции",
            help: " Помощь",
            notIntegratedDesc:
                " Мы поняли, что вы не добавляли чат на свой сайт. Когда вы интегрируете его на свой сайт и начнете первый разговор, вы завершите интеграцию. Нажмите, чтобы увидеть СЦЕНАРИЙ ИНТЕГРАЦИИ ",
            backToLogin: " Войдите снова",
            passwordlessLoginUnsuccessful:
                " Ошибка входа. Возможно, срок действия ссылки для входа истек или она использовалась ранее.",
            passwordlessLogin: " Вход без пароля ",
            loginWithEmail: "Войти по электронной почте",
            loginWithPassword: "Войти с паролем",
            enteringPasswordless: " Войти без пароля ...",
            toMainPath: " Перенаправить на домашнюю страницу ",
            userRoleChanged: " Ваши права доступа изменились. Вы попадете на главную страницу, чтобы продолжить.",
            passwordChangeSuccess: " Ваш пароль успешно изменен ...",
            feedback: " Обратная связь ",
            showFeedbackHistory: " Показать сообщения, на которые были отправлены отзывы.",
            newSelfServiceSite: " Новый сайт самообслуживания ",
            subdomain: "Субдоменное имя",
            rootUserEmail: "Электронная почта пользователя",
            rootUserName: "Ваше имя",
            newVersion: "Доступна новая версия",
            closeLiveSupport: "Закрыть онлайн-поддержку",
            newVersionShort: "новая версия",
            bannedWordRestrict: " Блокировка запрещенных слов ",
            ticketShow: "Разрешить клиентам создавать заявки",
            ticketShowDesc: "Включить опцию создания заявок в меню чата",
            bannedWordRestrictDesc:
                " Когда включена блокировка запрещенных слов, представителям запрещается вводить посетителям запрещенные слова, определенные в системе. ",
            agentDown: " Представитель отлючился",
            delayChat: " Отложенный чат ",
            tableSettingTippy: "Здесь вы можете изменить информацию, которая будет отображаться в таблице.",
            tableSettings: " Настройки таблицы",
            tableSettingsInfo:
                " Здесь вы можете изменить информацию, которая будет отображаться в таблице. Вы можете выбрать до 7 столбцов ",
            privateParametry: "Индивидуальные параметры пользователя",
            systemOperetor: "Системная информация",
            cityAndDistrict: " Город / Район ",
            general: " Общий ",
            availability: "Доступность",
            home: "Главная",
            successful: " Успешно ",
            forgetPasswordSent: " Письмо для сброса пароля отправлено, проверьте свою электронную почту.",
            saturday: " Суббота ",
            friday: " Пятница ",
            thursday: " Четверг ",
            wednesday: "Среда ",
            tuesday: " Вторник ",
            monday: " Понедельник ",
            sunday: " Воскресенье ",
            download: " Скачать",
            calendarPassedTimeHour: "{час} время {имя}",
            calendarPassedTime: "{час} время {мин} мин {имя}",
            calendarPassedTimeMinSec: "{мин}час{сек}сек{имя}",
            calendarPassedTimeMin: "{значение} мин {имя}",
            calendarPassedTimeSec: "{час} часы {мин} мин {сек} сек {имя}",
            workScheduleOneDay: "График работы на {sDate} день пользователя по имени {name} ",
            workSchedule: "График работы с {sDate} - {eDate} от {name} ",
            calendar: "Календарь",
            noRating: " Нет подсчета оценок ",
            rateDist: " Диаграмма распределения оценок ",
            distConversation: "Распределение выступлений по представителям",
            distributionConversa: "Распределение очков",
            distChatbotAgent: "Каналы связи",
            distAgent: "Чат-бот и агент",
            distFugitive: "Пропущенная речь и полученная речь",
            distLive: "Живой чат",
            distChatbot: "Чат-бот",
            distComplex: "Чат-бот + Живой чат",
            distHandled: "ответил в чате",
            distMissed: "речь без ответа",
            distWeb: "Веб-сайт",
            distWhatsapp: "Whatsapp",
            distTelegram: "Телеграмма",
            distInstagram: "Инстаграм",
            totalWhatsappChatCount: "чатов в Whatsapp",
            statsByTime: " Количество диалогов по времени",
            selectRep: " Выберите представителя ",
            allRepresentatives: "Все представители",
            avgRating: " Распределение оценок ({оценка}) ({count} оценка)",
            avgFirstMessageTime: " Среднее время первого ответа ",
            totalBreakTime: "Время перерыва системы",
            totalBreakNum: "Количество перерывов",
            averageConTime: "Среднее время разговора",
            multiWpReportTitle: "Количество разговоров в WhatsApp",
            multiWpReport: "Количество нескольких чатов WhatsApp",
            multiWpReportExplanation: "Вы можете увидеть количество чатов на ваших нескольких каналах WhatsApp.",
            longestConTime: " Самое долгое время разговора",
            shortestConTime: " Наименьшее время разговора",
            refresh: "Обновить",
            waitingReply: "В ожидании ответа",
            organizationName: " Название организации",
            companySlogan: "Полное название организации",
            messageSentErr: "Сообщение не может быть отправлено, попробуйте еще раз.",
            messageSent: " Сообщение отправлено.",
            openPrivateChat: "Открыть межпользовательский диалог ",
            escKey: " Скрыть активный диалог ",
            archiveChatKey: "Позволяет присоединиться к чату в нижней части страницы архива.",
            chatCopilot: "Включает Chat CoPilot",
            privateChat: " Межпредставительская дискуссионная панель ",
            multiModeAlertDesc:
                " SUPSIS открыт в другом окне. Нажмите «Использовать здесь», чтобы использовать SUPSIS в этом окне. ",
            useHereText: " Используйте здесь",
            brandVisibility: "Тег бренда SUPSIS появляется в иконке чата",
            focusInput: " Наведите курсор на область письма активного диалога",
            send: "Отправить",
            notYet: "Еще нет",
            sending: "Отправка",
            onlyRepresentative: "Ваше сообщение увидят только агенты.",
            yourMessage: "Ваше сообщение",
            liveFabListDescription: "Живая поддержка",
            messengerIntegrationDesc:
                "Общайтесь со своими клиентами через страницу Facebook, отправляйте автоматические сообщения с помощью чат-бота.",
            checkDepartmentToAgent: "Проверить отдел на наличие онлайн-агента",
            ifAllOfflineStory: "Сюжет для направления, если все в оффлайне",
            AssignMessagesToAgents: "Назначить все сообщения агентам",
            firstChatbotAndAssign: "Сначала чатбот отвечает, а затем назначает агенту",
            hybridAssign:
                "Система проверяет отдел, чтобы увидеть, есть ли онлайн-агент, и если онлайн-агента нет, она назначает его чатботу.",
            ticketFabListDescription: "Проездной билет",
            whatsappFabListDescription: "WhatsApp",
            phoneFabListDescription: "Телефон",
            emailFabListDescription: "Эл. адрес",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Введите в это поле ссылку на свой канал {channelLink}.",
            typeYourAccountLink: "Введите в это поле ссылку на свой аккаунт в {accountLink}.",
            typeYourMessage: "Пишите ваше сообщение здесь",
            typeYourMessageMail:
                "Сообщение, введенное в это поле, будет отправлено Клиентом на указанный выше почтовый адрес в качестве первого сообщения.",
            typeYourMessageDesc:
                "Сообщение, введенное в это поле, будет отправлено Клиентом на указанный выше номер телефона в качестве первого сообщения.",
            sendNumber: "Номер телефона для отправки сообщения: {path}",
            callNumber: "Номер телефона, по которому должен звонить ваш клиент: {phoneNumber}",
            numberIsNotCorrect: "Введен пропущенный номер!!",
            emailIsNotCorrect: "Электронная почта неверна!",
            selectFab: "Выберите Фаб",
            notValid:
                "Вы можете вводить только буквы (один символ). Буквы e, d, f, z, a, x, c, v, w, t, n недействительны ",
            forMacUsers: " Пользователи Mac могут использовать клавишу Control (⌃) ",
            basePriceValue: "Базисная цена",
            basePriceDiscount: "Скидка",
            basePriceCurrency: "Валюта",
            customerDBEnabled: " Выбор базы данных: используйте собственный сервер базы данных клиента",
            customerDBDisabled: " Выбор базы данных: используйте базу данных Supsis сервер ",
            mongoConnectionString: " Подключение Мongo ",
            whatsappBasePriceValue: "Базовая цена WhatsApp",
            whatsappPlusBasePriceValue: "Базовая цена WhatsApp Plus",
            instagramBasePriceValue: "Instagram Base Price",
            instagramPlusBasePriceValue: "Instagram  Plus Base Price",
            clientAddress: " Адрес клиента",
            customerClientAddress: "Клиентский адрес посетителя ",
            apiAddress: " Адрес API",
            socketAddress: "Soket адрес ",
            backendAddress: "BackEnd Адрес",
            panelLogoUrl: " Адрес логотипа панели",
            panelCustomCssUrl: " Адрес пользовательской панели Css ",
            customerLogoUrl: " Адрес логотипа клиента ",
            customerCssUrl: " Адрес CSS клиента ",
            siteAlias: " Название сайта",
            language: "Язык",
            features: "Функции",
            interactionPopularity: "Популярность взаимодействий",
            interactionCount: "Количество взаимодействий",
            uniqueUserCount: "Количество уникальных пользователей",
            allUserPercentage: "(%) Процент всех пользователей",
            represantativeSettings: "Настройки представителя",
            documentTitle: "Форма вспомогательного документа",
            supsisDocument: "Дополнительный документ",
            ApiDoc: "Документация по API",
            chatBalloonTehemeSettings: "Настройки иконки чата и темы",
            customLoginFormSettingsTitle: "Специальная форма входа",
            addNewField: "Добавить новый вопрос",
            editField: " Редактировать вопрос",
            typeHere: " Введите здесь",
            pco: "СРП",
            perPage: "/страница",
            perPageInFilter: "Кусок",
            noUserInfoFound: "Информация о пользователе не найдена",
            startFilter: "Начать поиск",
            showMyChats: " Показать мои чаты",
            showOnlineAgents: " Показать только онлайн",
            showWaitingChats: " Показать ожидающих представителя",
            addNewStatus: "добавить статус",
            newTitleContent: " Добавить заголовок ",
            roleName: "Название должности",
            error: " Ошибка ",
            contentType: " Тип содержимого",
            contentTitle: " Заголовок содержимого ",
            newSiteForm: " Форма регистрации нового сайта ",
            updateSiteForm: " Форма обновления сайта",
            newBannedWordForm: " Новая форма регистрации запрещенных слов",
            updateBannedWordForm: "Форма обновления запрещенного слова",
            newWelcomeMessageForm: "Новая регистрационная форма приветственного сообщения",
            updateWelcomeMessageForm: "Форма обновления системных сообщений",
            newDefaultContentForm: "Новая форма регистрации содержимого по умолчанию",
            updateDefaultContentForm: "Форма обновления контента по умолчанию",
            newSubjectForm: " Форма регистрации новой темы ",
            updateSubjectForm: " Форма обновления темы ",
            showIntro: " Показать презентацию ",
            showChatColorMeaning: " Цвета чата ",
            options: " Опции ",
            resetPassword: " Сброс пароля ",
            audioLevel: " Громкость звукового предупреждения ",
            privateChatNotificationSound: " Звук уведомления",
            continue: " Продолжить",
            newRoleForm: " Форма регистрации новой должности",
            updateRoleForm: " Форма обновления должности ",
            newUserForm: " Форма регистрации нового пользователя",
            updateUserForm: " Обновить форму пользователя ",
            changeOSRForm: " Изменить офлайн-сообщение ",
            tooltipOSRForm: " Вы можете изменить офлайн-сообщение.",
            newOSRForm: " Форма офлайн-поддержки ",
            newOSRMessages: " Добавить автономное сообщение ",
            updateOSRForm: " Форма офлайн-обновления",
            osrTitle: " Заголовок ",
            osrTitleDescription: " Вы можете добавить заголовок в форму офлайн- поддержки ",
            osrContent: " Содержание",
            osrContentDescription: " Вы можете добавить содержание в форму офлайн-поддержки ",
            hello: "Привет",
            cantProceedPayment: "Потому что нам не заплатили",
            and: "а также",
            suspendedPlan: " ваш план был приостановлен",
            payNow: "ЗАПЛАТИТЬ СЕЙЧАС!",
            KeepUsingFeatures: "Продолжайте использовать функции",
            date: " История ",
            startDate: " Дата начала ",
            finish: "Закончить",
            start: "Начать",
            search: " Поиск",
            endDate: " Дата окончания",
            representative: " Представители",
            representative_: " Представитель",
            star: "Оценка",
            filter: "Фильтр",
            reset: "Сброс настроек",
            dailyChatList: " Список ежедневных диалогов",
            dailyChatDuration: " Ежедневное время диалогов",
            chatDuration: " Время диалогов",
            dailyChatGraph: " Таблица ежедневных диалогов",
            ok: "Ок",
            cancel: "Отмена",
            chatCount: "Количество диалогов",
            shortest: " Самый быстрый",
            longest: "Самый долгий",
            average: " В среднем",
            count: "Количество",
            averagePoint: "Средняя оценка",
            pointDist: "Распределение оценок",
            point: "Оценка",
            filters: " Фильтры",
            totalCustomer: " Всего клиентов",
            avResponseTime: "Среднее время первого ответа",
            breakDuration: " Перерыв",
            breakCount: " Количество перерывов ",
            lastLoginPlatform: "Platform",
            active: "Активный",
            passive: "Пассивный",
            userForm: " Форма пользователя ",
            sender: "отправитель",
            profile: "Профиль",
            name: "Имя",
            number: "Число",
            username: "Имя пользователя",
            updateUserName: "Обновить имя пользователя",
            email: "Эл. адрес",
            password: "Пароль",
            oldPassword: "Старый пароль",
            newPassword: "Новый пароль",
            passwordAtLeast: "Пароль (не менее {num} символов)",
            passwordRepeat: " Пароль снова ",
            changePassword: " Изменить пароль ",
            status: "Статус",
            douYouWishToDeleteUser: " Вы действительно хотите удалить этого пользователя?",
            userDeleted: " Пользователь удален ",
            userSaved: " Пользователь зарегистрирован.",
            oldPasswordError: " Старый пароль неверен.",
            chooseAnOption: "Пожалуйста, выберите звук уведомления.",
            userVolumeUpdated: " Настройки звука обновлены.",
            save: "Сохранить",
            update: "Обновить",
            addNewMenu: " Добавить новое меню ",
            addNewContent: " Добавить новый контент ",
            pleaseTitleEnter: "Пожалуйста, введите заголовок",
            like: "Рейтинг",
            disLike: "Не нравится ",
            users: "Представители",
            visitor: "Посетители",
            allContacts: "Все контакты",
            allUsers: "Все представители",
            allSites: " Все сайты ",
            newUser: "Новый представитель",
            noNewUser: " Представителя пока нет.",
            noNewAdminUser: " Еще нет представителя с правами администратора.",
            noRoleFound: "Должности ещё нет.",
            noBannedWordFound: " Запрещенных слов пока нет.",
            noWelcomeMessageFound: "Системного сообщения пока нет.",
            noSubjectFound: " Пока нет тем.",
            noVisitorFound: " Посетителей не найдено.",
            noContactFound: "Нет контакта",
            sendResponse: " Напишите ответ.",
            delete: " Удалить",
            duplicate: "Дублировать",
            makeDefault: "Использовать по умолчанию",
            checkMore: "Проверить больше",
            useReadyTemplates: "Используйте готовые шаблоны",
            noRePresentativeFound: " Представитель не найден.",
            noLiveSupportFound: " Пока нет записи о живой поддержке.",
            noBannedVisitorFound: "Забаненных посетителей пока нет.",
            removeBanDescription: " Снять запрет ",
            editThisItem: " Обновить эту запись",
            removeThisItem: " Удалить эту запись ",
            role: "Должность",
            newRolePlaceHolder: " Щелкните, чтобы добавить новую должность...",
            autoChatAssignLimit: " Предел автоматического присвоения речи ",
            chatAssignInfo:
                "-1 = Системное значение по умолчанию, 0 = Нет назначения,> 0 = Назначить столько, сколько заданное значение.",
            relatedDepartments: "Связанные отделы",
            subjectInfo: " Если тема не выбрана, будут разрешены все темы..",
            archive: "Архив",
            offlineSupportRequests: " Офлайн-поддержка ",
            offlineModeMessage: " Автономное сообщение ",
            offlineMode: " Автономный режим ",
            first: " Первый ",
            last: "Последний",
            query: " Начать поиск ",
            clean: "Очистить",
            loading: " Загрузка ",
            loadMore: " Загрузи больше",
            noMessage: " Нет сообщений...",
            selectChat: " Выбрать чат",
            noMessageInChat: " В этом чате сообщений не найдено ",
            noMediaToShow: "Нет средств массовой информации для показа",
            firstSeen: "Впервые увидено",
            userInfo: " Информация о пользователе ",
            chatId: " ID чата",
            visitorId: "ID посетителя",
            visitingPage: " Посещение страницы",
            osAndBrowser: " Операционная система и браузер ",
            customerClientVersion: " Клиентская версия",
            visitorFeedback: " Обратная связь с клиентами ",
            notes: "Заметки",
            nameSurname: " Имя Фамилия ",
            chats: "Чаты",
            bannedVisitors: " Запрещенные посетители ",
            country: " Страна ",
            city: " Город ",
            cityDistrict: " Район ",
            browser: "Браузер",
            os: " Операционные системы ",
            ipAddress: "IP Адрес",
            connectionDate: " Время подключения ",
            transaction: " обработка ",
            banRemoved: " Блокировка снята.",
            bannedWords: " Запрещенные слова ",
            newBannedWord: " Новое запрещённое слово ",
            noBannedWord: "Нет запрещённых слов.",
            bannedWordForm: " Запрещенная форма слова ",
            word: " Слово",
            bannedWordAndWordGroup: " Запрещенное слово / фраза ",
            doYouWishToDeleteBannedWord: " Вы действительно хотите удалить это запрещенное слово?",
            doYouWishToOfflineSupportRequest: " Вы хотите удалить это сообщение?",
            bannedWordSaved: " Запрещенное слово было записано ",
            deletedSuccessfully: " Успешно удалено ",
            deleteErrorMsg: " Не удалось удалить, попробуйте еще раз. ",
            socketError: " Sockete Проблема с подключением. Обновите страницу и попробуйте еще раз. ",
            socketConnecting: " Связь с сервером ",
            offlineModeDescription:
                " Система не работает, клиенты не смогут получить доступ к поддержке в реальном времени.",
            offlineModeSettingsDescription: " Проверьте функцию 'Автономный режим' в меню настроек..",
            offlineModeUser: " В системе должен быть хотя бы один онлайн-представитель.",
            adminCannotConnectSocket: "Администраторы не могут подключиться к soket.",
            liveSupport: " Живая поддержка ",
            siteVisitors: " Посетители сайта ",
            visitors: " Посетители ",
            thoseConnectedToLiveSupport: " Подключено к Live Support ",
            visitorHistory: " История посетителей ",
            visitorHistoryDescription: "Вы можете просматривать и загружать историю чатов посетителей.",
            privateMessage: " Личное сообщение ",
            addRepresentative: " Добавить представителя ",
            forwardRepresentative: " Обратитесь к представителю ",
            keyboardShortcuts: " Горячие клавиши ",
            chatColorMeanings: "Значение цвета чата",
            connLostCheckInternet: " Ваше соединение потеряно. Убедитесь, что у вас есть подключение к Интернету.",
            wishToEndThisChat: " Вы хотите закончить этот разговор?",
            defaultContents: "Контент по умолчанию",
            contents: "Содержание",
            newDefaultContent: "Новый контент по умолчанию",
            newCTRLContent: "CTRL Добавить содержание ",
            newALTContent: "ALT Добавить содержание ",
            newTABContent: "TAB Добавить содержание ",
            title: " Заголовок ",
            shortcutChar: " Ярлык",
            pickOne: " Выберите один ",
            writeSomething: " Введите символ (a-z | 0-9)",
            letterSequence: "Последовательность букв",
            exampleText: " Пример: фут - > футбол ",
            anyChar: "anyChar",
            shorcutKey: " Быстрая клавиша ",
            content: " Содержание ",
            shortcutName: " Название ярлыка ",
            type: "тип",
            shortcut: "Ярлык",
            deleteContentQuestion: "Вы действительно хотите удалить это содержимое по умолчанию?",
            defaultContentDeleted: "Контент по умолчанию удален",
            defaultContentSaved: "Контент по умолчанию сохранен.",
            defaultContentForm: "Форма содержимого по умолчанию",
            titleContentForm: "Готовый контент Заголовок",
            contentMoved: " Системное сообщение перемещено.",
            cannotMoveFullParent: "Вы не можете переместить этот элемент",
            yourEmail: " Адрес электронной почты ",
            yourName: "Ваше имя и фамилия",
            lostPassword: " я забыл мой пароль ",
            login: "Авторизоваться",
            forgotPassword: "Забыл мой пароль",
            multipleSession: "Вы вошли в систему где-то еще.",
            notAuthorizedToDisplayPage: " У вас нет разрешения на просмотр этой страницы!",
            permissions: "Разрешения",
            newPermission: " Новое Разрешение ",
            permissionForm: "Форма разрешения",
            displayTitle: " Отображать заголовок ",
            key: "ключ",
            keyToUseInSystem: "Sistemde kullanılacak anahtar değer",
            deletePermissionQuestion: " Вы действительно хотите удалить это разрешение?",
            permissionDeleted: " Разрешение удалено.",
            permissionSaved: "İzin kaydedildi.",
            newRole: "Новая должность",
            selectARole: " Выберите должность ",
            yes: "Да",
            no: "Нет",
            fullAuth: " Полные полномочия ",
            roleDeleted: " Должность удалена.",
            sameRole: "Существует роль с таким же именем.",
            roleSaved: " Должность сохранена.",
            roleForm: " Должностная форма ",
            roles: "Должности",
            settings: " Настройки ",
            selectTopic: " Выбор темы ",
            autoCallTransfer: " Автоматический перевод вызова ",
            customerTyping: " Типы пользователей ",
            typing: "печатание",
            agentTyping: " Представитель пишет ",
            disconnectTime: "Конец разговора (сек)",
            tippyDissconnectTime:
                " Устанавливает количество секунд, по истечении которых стационарный разговор будет отключен. ",
            queueNumberVisibleFeature: " Показать количество посетителей в очереди ",
            privateChatEnabled: " Показать чат между представителями ",
            delayedTalkTime: " Время задержки (сек)",
            employeeAverageChatCount: " Среднее количество разговоров в чате персонала ",
            customerDownTimeWhenRepExit: " Время ожидания клиента при выходе представителя (сек.)",
            autoAssignLimit: "Предел автоматического назначения",
            wasted: "потрачено (сек)",
            settingsSaved: " Настройки сохранены.",
            settingsCannotSaved: "Настройки не могут быть сохранены",
            noAuthorization: "нет авторизации",
            warningBadInput: "Рекомендуется вводить число от 0 до 70.",
            warningBadInputMarginY: "Предупреждение о вводе вертикального поля ⚠️",
            warningBadInputMarginX: "Предупреждение о вводе горизонтального поля ⚠️",
            warningBadInputBubbleSize: "Предупреждение о вводе всплывающих окон чата ⚠️",
            settingFormWrong: " Введенные вами данные неверны, проверьте и попробуйте еще раз.",
            delayTime: " Время задержки (сек.)",
            sites: " Сайты ",
            newSite: " Новый сайт ",
            noSiteYet: " Сайта пока нет.",
            siteAddress: " Адрес сайта ",
            turnBack: "Вернуться Назад",
            customerRepLimit: "Лимит представителя клиента",
            siteSaved: " Сайт зарегистрирован.",
            siteSaveError: " Произошла ошибка при создании сайта.",
            subjects: " Темы ",
            newSubject: " Новая тема ",
            noSubject: " Темы пока нет.",
            subject: " Тема ",
            subjectTitle: " Заголовок темы ",
            description: " Описание ",
            infoAboutSubject: " Краткая информация по теме ",
            deleteSubjectQuestion: " Вы действительно хотите удалить эту тему?",
            subjectDeleted: " Тема удалена ",
            subjectSaved: " Тема сохранена.",
            osrFromMessageSaved: " Автономное сообщение записано.",
            welcomeMessages: "Системные сообщения",
            newWelcomeMessages: "Новое приветственное сообщение",
            noWelcomeMessage: "Нет системного сообщения.",
            welcomeMessageContent: "Содержание системного сообщения",
            makeChoice: " Сделайте выбор...",
            welcomeMessage: "Приветственное сообщение",
            repLoggedIn: " Представитель вошел в систему ",
            loginMessage: " Сообщение о выходе ",
            message: " Сообщение ",
            deleteWelcomeMessageQuestion: "Вы действительно хотите удалить это системное сообщение?",
            welcomeMessageDeleted: "Системное сообщение удалено",
            welcomeMessageSaved: "Системное сообщение сохранено.",
            welcomeMessageForm: "Форма системного сообщения ",
            noRep: " Пока нет представителя.",
            addChat: " Добавить в разговор ",
            forwardChat: "переадресовать чат кому-нибудь",
            ago: "тому назад",
            repName: " Имя представителя ",
            lastOnline: " Последнее подключение / время в сети ",
            lastStatusChange: " Последнее изменение статуса ",
            activeChat: " Активная беседа ",
            userMaxCapacity: " Максимальная емкость чата ",
            noActiveChat: " Нет активного разговора.",
            watch: " СМОТРЕТЬ ",
            join: " ПРИСОЕДИНИТЬСЯ ",
            open: " ОТКРЫТО ДЛЯ ДИАЛОГА ",
            directMessage: " ЛИЧНОЕ СООБЩЕНИЕ ",
            block: " ЗАБЛОКИРОВАТЬ ",
            transactions: " Операции ",
            informations: " Информация ",
            visitStart: " Начало визита ",
            fullName: " Имя и фамилия ",
            waitChatTime: " Время ожидания / время разговора ",
            blockUserConfirm: " Вы действительно хотите заблокировать этого пользователя ?",
            messaging: " Обмен сообщениями ",
            hideChat: " Скрыть диалог",
            block_: " Заблокировать ",
            privateMessage_: " Секретное сообщение ",
            assignRep: " Назначить представителя ",
            joinChat: "Присоединиться к чату",
            forwardRep: " Перенаправить ",
            leaveChat: "Выйти из разговора",
            endChat: " Завершить разговор ",
            translatedTextDescription: "Амазонка перевел это сообщение {from} -> {to}.",
            autoTranslate: "Автоматический перевод",
            translateThisMessage: "Перевести это сообщение",
            autoTranslateDetectedDesc:
                "Язык посетителя: {visitorLanguage}. Нажмите здесь, чтобы активировать автоматический перевод",
            on: "вкл",
            off: "выкл",
            copy: " Копировать ",
            prevChats: " Предыдущие диалоги ",
            noShortCut: " Нет ярлыка ",
            leaveChartConfirm: " Вы уверены, что хотите выйти из разговора?",
            endChatConfirm: " Вы хотите закончить этот разговор?",
            chatBar: " Панель разговора ",
            endConversation: " Завершить разговор ",
            onlyOneRep: " Вы единственный представитель в этом разговоре!",
            chatList: " Список диалогов",
            unreadTitle: " Непрочитанные",
            visitorLeftTitle: " Выход посетителя ",
            activeChatTitle: " Активный диалог",
            autoAssignedTitle: " Назначено автоматически ",
            watchModeTitle: " Режим просмотра",
            lostChat: " Соединение представителя прервано ",
            repLostConn: " Фон диалога становится розовым, если представитель отключен от диалога.",
            chatWidthDelay: "Отложенный чат",
            repChatWidthDelay:
                " Когда в системе нет активного представителя или когда нет посетителей из-за плотности, фон речи становится зеленым. ",
            unreadMsg: " Если есть непрочитанное сообщение, фон будет голубым.",
            visitorLeftChat: " Если посетитель покидает беседу, фон становится темно-серым..",
            activeChatMsg: " Если разговор активен, фон будет зеленым ",
            autoAssignMsg:
                " Если назначено автоматическим назначением и разговор еще не просматривался, фон будет горчичным",
            watchModeMsg: " Фон становится красным, когда чат открыт в режиме просмотра ",
            online: " В сети ",
            beRightBack: "Скоро вернусь",
            away: " Скоро вернусь",
            busy: " Занят",
            offline: " Не в сети ",
            logout: " Выйти",
            forWindows: " Для Windows ",
            forMac: "Для Mac",
            nextChatFromActive: " Переключиться с активного разговора на следующий разговор ",
            previousChatFromActive: " Перейти от активного разговора к предыдущему разговору ",
            hideActiveChat: " Скрыть активную беседу ",
            closeActiveChat: " Остановить активный разговор ",
            firsthiddenChat: " Подключиться к чату самого ожидающего клиента ",
            firstChatWaiting: " Переключиться на ожидающий разговор ",
            previousOpenedChat: " Перейти к первому открытому разговору вне зависимости от порядка ",
            historyDetails: " Подробности истории",
            chat: "Чат",
            chatNotFound: "Речь не найдена.",
            dataNotFound: "Данные не найдены.",
            visitorInfo: " Информация для посетителей ",
            timeSpent: "Время вышло",
            noActiveVisitors: " Нет активных посетителей ",
            select: " Всплывающее меню ",
            fullname: " ФИО",
            text: " Текст ",
            numeric: "Числовой",
            phone: " Телефон",
            optionsPlaceholder: "Значение параметра",
            selectField: " Щелкните, если хотите добавить раскрывающееся меню ",
            fullnameField: "Нажмите, если хотите добавить поле Полное имя.",
            textField: " Щелкните, если хотите добавить текстовое поле.",
            labelField: "Щелкните, если хотите добавить поле описания.",
            numericField: " Щелкните, если хотите добавить числовое поле.",
            phoneField: " Нажмите, если хотите добавить поле телефона.",
            departmentField: "Щелкните, если вы хотите добавить поле отдела.",
            emailField: " Нажмите, если хотите добавить домен электронной почты.",
            visible: " Видимый ",
            required: " Обязательство ",
            label: "Описание",
            totalConnected: "Количество диалогов",
            missedChat: " Количество пропущенных диалогов",
            workTime: " Рабочее время ",
            closedChatCount: " Закрытые диалоги",
            activeConvo: "Активные диалоги",
            notAnswered: "Ещё не ответили",
            delayedConvo: " Отложенные диалоги",
            leavingRep: " Выделенный представитель",
            staffRate: " Уровень занятости сотрудников ",
            customLoginAlert: "Ваша форма входа должна содержать хотя бы одно поле.",
            atLeastOneLanguage: " Должно быть хотя бы одно языковое описание.",
            requiredField: " Это поле обязательно к заполнению.",
            notRequiredField: " Это поле не обязательно.",
            visibleField: "Это поле видно.",
            notVisibleField: "Это поле не отображается.",
            connectServer: " Вы подключены к серверу ",
            disconnectServer: " Ваше соединение с сервером было потеряно ",
            liveChatOff: " Живая поддержка отключена ",
            visitorScreen: " Отображение посетителей ",
            viewOnTheSite: "Посмотреть на странице",
            viewOnTheSiteTippy: "Click Here To See How Your Changes Hold Up.",
            showHint: " Показать подсказку ",
            dontShowHint: " Показать подсказку",
            liveChatOn: " Онлайн-поддержка открыта ",
            nightModeOff: " Ночной режим выключен ",
            nightModeOn: " Ночной режим включен ",
            edit: " Редактировать ",
            deleteField: " Удалить ",
            arrow_upward: " Переместить вверх ",
            arrow_downward: " Переместить вниз ",
            doubleClickEdit: " Дважды щелкните или нажмите «Редактировать», чтобы отредактировать.",
            newCatalogCategory: "Новая категория каталога",
            childCreate: " Нажмите, чтобы создать дополнительный контент ",
            updateCatalogCategoryFrom: "Форма обновления категории каталога",
            newCatalogCategoryFrom: "Форма новой категории каталога",
            catalogMenu: " Меню ",
            catalogContent: " Содержание ",
            catalogCategoryName: " Название категории каталога ",
            newCatalogContentFrom: "Форма содержания нового каталога",
            catalogContentName: " Название содержимого каталога ",
            catalogCategorySaved: " Категория каталога сохранена ",
            catalogCategoryDeleted: " Категория каталога удалена.",
            catalogCategoryRate: " Оценка содержания ",
            catalogContentFeature: "Каталог Особенности",
            vtipyAudioLevel: " Используется для отключения или включения звуков уведомлений.",
            vtipyOrganizationName: " Вы можете изменить название организации и обновить его.",
            vtipyBrandVisibility: " Supsis - это настройка отображения тега в пузыре чата.",
            vtipyBrandVisibilityForced: "Только пользователи ProPlan могут изменять!!",
            vtipyClientDefault: " Здесь вы можете изменить язык страницы представителя.",
            vtipyCustomerClientDefault: " Здесь вы можете изменить язык страницы клиента (чата).",
            vtipyVisitorPreferredLang: "Клиент может выбрать разговорный язык на странице (Чат).",
            vtipyCustomerClientLanguageDetect: " Вы можете автоматически определять язык страницы клиента (чат).",
            vtipySelectTopic: "Происходят автоматические назначения существующим представителям в выбранном отделе.",
            vtipyAutoCallTransfer: " Автоматически назначает ожидающие вызовы доступным операторам.",
            vtipyCustomerTyping: " Позволяет вам видеть, что написал клиент на экране чата на экране чата агента.",
            vtipyAgentTyping: " Показывает статус записи представителя в пузыре клиента.",
            vtipyQueueNumberVisibleFeature:
                " Когда представители заняты, это показывает клиентам, которые хотят подключиться, в каком порядке они находятся.",
            vtipyPrivateChatEnabled: " Показывает панель разговора между агентами.",
            vtipyDelayedTalkTime: ' Ярлык "Отложенная речь ", если в это время к разговору не подключены агенты.',
            vtipyOfflineMode: " Позволяет перевести систему в автономный режим.",
            vtipyAutoAssignLimit: " Определяет, сколько клиентов (чатов) будет автоматически назначено представителю..",
            vtipyCustomerDownTimeWhenRepExit: " Время ожидания клиента (сек.)",
            tippyDisconnectTime: " Время закрытия чата после отключения клиента (сек.).",
            changeSettings: " Изменить глобальную настройку ",
            totalBg: "ВСЕГО ЧАТОВ",
            activeBg: "АКТИВНЫЕ ЧАТЫ",
            watchBg: "ОТСЛЕЖИВАНИЕ",
            waitingBg: "ОЖИДАЮЩИЕ РАЗГОВОРЫ",
            lateBg: " проходящие чаты",
            freeBg: "праздный",
            maxCapacityBg: "МАКС МОЩНОСТЬ",
            addNewSettings: " Добавить новую глобальную настройку",
            darkMode: "Ночной режим",
            clientDefault: "Язык панели по умолчанию",
            customerClientDefault: "Язык по умолчанию для клиентской части",
            customerClientLanguageDetect: "Автоматическое определение языка клиентской части",
            visitorPreferredLang: "Позвольте клиенту выбрать разговорный язык",
            preferredThemeColor: " Настройка темы разговорного экрана ",
            detail: "Рассмотрение",
            supportUs: "Свяжитесь с нами (Живая поддержка)",
            langSetting: "Настройка языка",
            changeLang: "изменение языка",
            fontSizeSetting: "Настройка увеличения экрана",
            changeLangDesc: "Устанавливает язык приложения на {code}.",
            trLang: "Турецкий",
            enLang: "Английский",
            fieldRequired: "{field} Поле, обязательное для заполнения.",
            selectALanguage: "Выберите язык",
            selectATheme: "Выберите тему",
            responseForm: "Форма ответа",
            clientRequestInfo: "Информация о запросе клиента ",
            createdDate: "Дата создания",
            descMessage: "Сообщение",
            new: "Новое",
            selectAllPermission: "Выбрать все",
            catalogCategories: "Каталог",
            copiedClipboard: "Скопировано в буфер обмена",
            organizationLogo: "Логотип организации",
            changePlan: "Изменить план",
            close: "Закрывать",
            vtipyUploadLogo:
                "Загрузив логотип своей компании из этой области, вы можете использовать свой собственный логотип в электронных письмах клиентов и на страницах клиентов.",
            tagName: "Название тэга",
            tagDescription: "Метка Описание",
            tagColor: "Цвет этикетки",
            userInformations: "информация о пользователе",
            incomingChat: "Входящий чат",
            support: "Поддерживать",
            team: "Набор",
            groups: "Группы",
            newConversationStarted: "Новый разговор начался",
            allHistoryLoaded: "Вся история загружена",
            chatCreator: "Создатель чата",
            enterGroupTitle: "Введите название группы",
            requiredTitle: "Нельзя оставлять поле заголовка пустым",
            requiredChannel: "Имя канала не может быть пустым",
            next: "Подтверждать",
            selectPeople: "Выберите людей",
            textLimitAlertMessage:
                "Ограничение на количество символов в WhatsApp составляет 19 символов, за пределами этого ограничения оно отображаться не будет. Однако в Интернете тексты, длина которых превышает лимит в 19 символов, автоматически перемещаются на следующую строку и отображаются.",
        },
        telegram: {
            typeInTelegramToken: "Введите токен Telegram",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Интеграция с Telegram",
            telegramAlertForm: "Вы можете получить токен бота Telegram от",
            telegramAlertTitle: "Вы действительно хотите удалить токен?",
            telegramAlertText: "Токен исчезнет навсегда!",
        },
        wp: {
            sendAgain: "Отправить снова",
            shippingDetails: "Детали доставки",
            whatsapp: "Whatsapp",
            importContactsFromFile: "Импорт Контактов из Файла",
            chatStarted: "Чат начался",
            chatNotStarted: "Чат не запущен",
            contactSelected: "контакт выбран",
            startChatWithAnyNo: "Начать чат с любым номером",
            toLittleChar: "Отсутствует номер !",
            typeInANumberDesc: "Введите номер, чтобы начать чат с:",
            wpPlusAndLicenceRequired: "Требуется план Whatsapp Plus и лицензия.",
            wpPlusAndLicenceRequiredDesc:
                "Прежде чем вы сможете начать чаты с номерами, которые не зарегистрированы в ваших контактах, вы должны обновить свой план WhatsApp и получить лицензию.",
            chatStartingWait: "Разговор начинается, пожалуйста, подождите",
            agreement: "Соглашение",
            purchase: "Покупка",
            activating: "Активация сервиса WhatsApp",
            authenticating: "Аутентификация по QR-коду",
            ready: "Готовый",
            activationTitle: "Чтобы активировать интеграцию с WhatsApp на Supsis:",
            wpIntegrationInstruction1: "Откройте WhatsApp на своём телефоне",
            wpIntegrationInstruction2: "Нажмите «Меню» или «Настройки». Щелкните Связанные устройства.",
            wpIntegrationInstruction3: "Наведите свой телефон на этот экран, чтобы считать код",
            qrGeneratingWait: "Генерируется QR-код, пожалуйста, подождите...",
            pleaseContinueToWaitUntilCompleted:
                "После проверки QR-кода он автоматически переключится на заполненное поле. Пожалуйста подождите...",
            authenticatingWait: "Аутентификация, пожалуйста, подождите...",
            enableFeature: "Включить функцию WhatsApp",
            readAndAgree: "Я подтверждаю прочитал",
            subscribe: "Подписаться",
            subscribed: "Подписан",
            toEnableWpDescription: "Чтобы включить функции WhatsApp, нажмите кнопку ниже.",
            waitForWpActivationDescription:
                "Служба вашей учетной записи WhatsApp активируется. Пожалуйста, подожди минутку. Это занимает около 10-30 секунд.",
            greatWpActivatedDescription: "Отлично, услуга «Ваша учетная запись WhatsApp» активирована!",
            unsubscribe: "Отписаться",
            planDetails: "Детали интеграции",
            sendReceiveMessage: "Отправка и получение текстовых сообщений",
            sendReceiveImage: "Отправка и получение файлов изображений",
            sendReceiveAudio: "Отправка и получение аудиофайлов",
            sendReceiveGif: "Отправка и получение файлов GIF",
            startChat: "Начать чат на Supsis",
            supsisFunctionality: "Полезный функционал Supsis Chat",
            onePhoneMultiAgent: "Один телефон и несколько агентов",
            basicIntegration: "Базовая интеграция и нулевая конфигурация",
            unsubscribeWpInetgration: "Отписаться от WhatsApp",
            unsubscribeIGIntegration: "Unsubscribe Instagram Integration",
            wpBack: "назад",
            terminatelWpInetgration: "При нажатии кнопки «Отписаться» ваша интеграция с WhatsApp прекратится.",
            cancelWpInetgration: "Вы хотите отменить интеграцию WhatsApp?",
            terminatelIGIntegration: "When clicked the 'Unsubscribe' button, your instagram integration will terminate",
            cancelIGIntegration: "Do you want to cancel instagram integration?",
            startChatWp: "Начать Чат",
            purchaseHeader: "Покупка интеграции Supsis-Whatsapp",
            wpServices: "Служба WhatsApp",
            wpServicesIntegrationCompleted:
                "Ваша интеграция WhatsApp завершена. Теперь вы можете пользоваться сервисом.",
            purchasePaymentDescription:
                "Функция WhatsApp оплачивается ежемесячно. Ваша служба WhatsApp будет активирована после того, как вы примете подписку.",
            wpIntegrationFeatures: "Возможности интеграции WhatsApp",
            saveChanges: "Сохранить изменения",
            contactList: "Список контактов",
            broadcast: {
                broadcast: "Транслировать",
                detail: "Деталь",
                customer: "Покупатель",
                phoneNumbers: "Контактные телефоны",
                showMore: "Показать больше",
                showLess: "Показывай меньше",
                groupName: "Название группы",
                messages: "Сообщения",
                status: "Статус",
                usageCost: "Стоимость использования",
                sendingTime: "Время отправки",
                progress: "Прогресс",
                groupDetail: "Подробная информация о группе",
                messagesPerContact: "Сообщений на контакт",
                successRatio: "Коэффициент успеха",
            },
            messages: "Сообщения",
            broadcastRequests: "Запросы трансляции",
            customerGroups: "Группы клиентов",
            messageTemplates: "Шаблоны сообщений",
            plans: "Планы",
            wpIntegrationRequired: "Требуется интеграция с WhatsApp",
            wpRequiredIntegrationDescription:
                "Извините, страница, которую вы посетили, будет активирована при интеграции вашего WhatsApp.",
            integrateWp: "Поехали, интегрируем WhatsApp",
            active: "Активный",
            archived: "В архиве",
            createBroadcastMessage: "Создать широковещательное сообщение",
            title: "Заголовок",
            description: "Описание",
            createdAt: "Создано на",
            numbers: "Числа",
            actions: "Действия",
            action: "Действие",
            createCustomerGroup: "Создайте пользовательскую группу клиентов",
            search: "Поиск",
            name: "ИМЯ",
            contacts: "Контакты",
            noContactFound: "Контакт не найден",
            broadcastTitle: "Дайте название вашей трансляции.",
            recipients: "Получатели",
            selectRecipients: "Выберите получателей",
            writeYourMessage: "Напишите свое сообщение.",
            schedule: "Расписание",
            scheduleNowOrLater: "Запланируйте сейчас или позже",
            summary: "Резюме",
            cancel: "Отмена",
            send: "Отправлять",
            sending: "Отправка",
            deleteCustomerGroup: "Вы уверены, что хотите удалить эту группу клиентов? {name}",
            customerGroupDeleting: "Удаление группы клиентов ...",
            customerGroupDeletingSuccess: "Группа клиентов успешно удалена",
            customerGroupDeletingError: "Ошибка при удалении группы клиентов",
            wpPlusRequired: "Требуется план Whatsapp Plus.",
            broadcastMessageArchived: "Широковещательное сообщение как заархивированное",
            broadcastMessageNotArchived: "Широковещательное сообщение не архивируется",
            groupNameSearch: "Введите имя группы клиентов",
            groupNameDesc: "Название группы клиентов идентифицирует ваши группы клиентов",
            save: "Сохранять",
            number: "КОЛИЧЕСТВО",
            addColumn: "Добавить столбец",
            addColumnDesc: "Добавить столбец в таблицу",
            addNewContact: "Добавить новый контакт",
            addNewContactDesc: "Добавить контакт в таблицу",
            importFile: "Импорт из файла",
            importFileDesc: "Импорт контактов из файла excel или csv",
            contactAdded: "Контакт добавлен",
            updateCustomerGroup: "Обновление группы клиентов...",
            updateCustomerGroupSuccess: "Группа клиентов успешно обновлена",
            sendBroadcastMessage: "Отправить широковещательное сообщение",
            columnName: "Имя столбца",
            columnType: "Тип столбца",
            defaultValue: "Значение по умолчанию",
            setDefaultValue: "Установите значение по умолчанию для существующих контактов",
            age: "Возраст",
            location: "Расположение",
            gender: "Пол",
            selectContactFile: "Выберите контактный файл",
            selectContactCsvOrExcel: "Выберите файл CSV или EXCEL.",
            importConfiguration: "Импорт конфигурации",
            customizeFile: "Настройте конфигурацию импорта.",
            sendMessageTo: "Кому вы хотите отправить сообщение?",
            allContact: "Все контакты",
            messageTypes: "Типы сообщений",
            whenSendMessage: "Когда вы хотите отправить сообщение?",
            instantlyRightNow: "Мгновенно прямо сейчас",
            completed: "Завершенный",
            scheduleFuture: "Расписание на будущую дату",
            messageDesc: "Ваше сообщение будет отправлено мгновенно всем получателям",
            messageSendAt: "Ваше сообщение будет отправлено всем получателям на",
            estimatedPrice: "Ориентировочная цена",
            estimatedTime: "Расчетное время",
            now: "в настоящее время",
            tenMinute: "10 минут",
            cancelled: "Отменено",
            failed: "Не удалось",
            running: "Бег",
            queued: "В очереди",
            scheduled: "Запланированное",
            noNumberAdded: "Номера не добавлены",
            csvOrExcelFile: "CSV или файл Excel",
            broadcastMessagesToContactFile: "Рассылка сообщений в список контактов",
            broadcastMessageTemplates: "Шаблоны широковещательных сообщений",
            messageFlow: "Поток сообщений",
            textMessageSupport: "Поддержка текстовых сообщений",
            imageMessageSupport: "Поддержка графических сообщений",
            spamPreventions: "Защита от спама",
            includesAllBasicPlans: "Включает все в базовом плане",
            chatbotIntegration: "Интеграция с чат-ботом",
            messageToNewNumbers: "Сообщение на новые номера",
            broadcastMessageToEveryone: "Рассылка сообщений всем",
            personalizedBroadcastMessage: "Персонализированные широковещательные сообщения",
            customerGroupSegmentation: "Сегментация групп клиентов",
            scheduleBroadcastMessage: "Запланировать широковещательное сообщение",
            locationMessageSupport: "Поддержка сообщений о местоположении",
            advancedSpamPreventions: "Усовершенствованная защита от спама",
            whatsappPlans: "WhatsApp планы",
            selectBestPlan: "Выберите план, который вам подходит",
            comingSoon: "Вскоре...",
            selectFile: "Выберите файл",
            created: "Созданный",
            message: "Сообщение",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            instagramComments: "Комментарии Instagram",
            messengerComments: "Комментарии Messenger",
            trendyolComments: "Комментарии Trendyol",
            ticketSelection: "Тикет Выбран",
            bulkClose: "Массовое Закрытие",
            igComment: "Комментарий в Instagram",
            igMentioned: "Упоминания в Instagram",
            incomingReqChatbot: "Входящие запросы с чатботом",
            incomingReqWebForm: "Запросы из веб-формы",
            incomingReqAutomation: "Запросы от автоматики",
            thisPersonEmailAnswered: "Этот человек хочет получить ответ по электронной почте",
            thisPersonWpAnswered: "Этот человек ожидает ответа по WhatsApp",
            clickStartWpChat: "Нажмите, чтобы начать чат WhatsApp",
            requestProgress: "Прогресс запроса",
            requestMessage: "Запрос сообщения",
            clickAddMailAddress: "Нажмите, чтобы добавить почтовый адрес",
            sendReplyCloseTicket: "Отправить ответ и закрыть билет",
            closeTicket: "Закрыть билет",
            selectEmailSender: "Выбрать отправителя электронной почты",
            withEmailWillNotRecievice: "Вы не сможете получать ответы на письма при отправке с этим почтовым адресом!",
            deleteCommentAndClose: "Удалить и закрыть комментарий",
            sendReplyAndClose: "Отправить ответ и закрыть",
            startChatWp: "Начать чат WhatsApp",
            sureWantToDeleteTicket: "Вы уверены, что хотите удалить билет?",
            bulkDeleteConfirmation: "Подтверждение массового удаления",
            selectedTicketSucsDelete: "Выбранные билеты были успешно удалены.",
            thereErrorDeletingTicket: "При удалении билетов произошла ошибка.",
            deleteConfirm: "Подтвердите удаление",
            sureDeleteTicket: "Вы уверены, что хотите удалить этот билет?",
            ticketSucsDelete: "Билет успешно удален",
            represantiveSucsAppoint: "Агент был успешно назначен",
            ticketClosedSucs: "Билет успешно закрыт",
            ticketCloureFailed: "Не удалось закрыть билет",
            unprocessed: "Не обработано",
            pleaseSelectValidStatus: "Пожалуйста, выберите действительный статус",
            ticketStatusBeenUpdated: "Статус билета был обновлен.",
            doYouWantCloseTicket: "Вы хотите закрыть билет?",
            ticketWillMarkedClosed: "Тикет будет помечен как закрытый и заархивирован.",
            errorUpdatingTicketFailed: "Произошла ошибка при обновлении статуса тикета.",
            igCommentDeleteIgPost: "Комментарий Instagram был удален из вашего поста IG.",
            igCommentHideChange: "Статус скрытия комментария в Instagram был изменен.",
            pleaseChooseRepresent: "Пожалуйста, выберите представителя",
            selectedTicketSucsDelegated: "Выбранные билеты были успешно делегированы.",
            errorOccuredDuringDelegation: "Во время процесса делегирования произошла ошибка.",
            bulkTicketClosing: "Массовое закрытие билетов",
            sureWantCloseTicket: "Вы уверены, что хотите закрыть билет?",
            selectedTicketSucsClosed: "Выбранные билеты были успешно закрыты.",
            thereErrorClosingTicket: "При закрытии билетов произошла ошибка.",
            changeFilterTicketPage: "Изменить фильтры на странице билетов",
            nameOfFilter: "Имя фильтра",
            filterValue: "Значение фильтра",
            deletesSelectedTickets: "Удаляет выбранные билеты",
            idTicketBeDelete:
                "Идентификаторы билетов, которые нужно удалить (идентификаторы выбранных билетов или идентификаторы всех перечисленных билетов)",
            assignsAgentSelectedTickets: "Назначает представителя на выбранные билеты",
            idTicketBeAssigned:
                "Идентификаторы билетов, которые нужно назначить (идентификаторы выбранных билетов или идентификаторы всех перечисленных билетов)",
            idAgentAssigned: "Идентификатор представителя, который будет назначен",
            changesStatusSelectedTicket: "Изменяет статус выбранных билетов",
            idTicketWhoseStatus:
                "Идентификаторы билетов, статус которых будет изменен (идентификаторы выбранных билетов или идентификаторы всех перечисленных билетов)",
            newStatus: "Новый статус",
            selectedTicketsSucsUpdated: "Статус выбранных билетов успешно обновлен.",
            errorWhileChangingStatus: "Произошла ошибка при изменении статуса билетов.",
            thisPageVoiceAssistant: "На этой странице есть голосовой помощник",
            hello: "Здравствуйте!",
            voiceAssistantContent: `Знаете ли вы, что на этой странице есть <strong>Искусственный Интеллект Ассистент</strong>, который может помочь вам?
                Вы можете попробовать следующие методы, чтобы использовать ассистента:`,
            commandHoldingDownTheKey: "Вы можете дать команду, удерживая комбинацию клавиш и говоря.",
            topRightContent: "в верхнем правом углу",
            clickOnTheIcon: "вы можете запустить ассистента, нажав на иконку.",
            sampleVoiceCommands: "Образцы голосовых команд:",
            showMyTickets: "Показать мои билеты",
            showMeZeynepsOpenTicket: "Показать открытые билеты Зейнеп на сегодня",
            deleteTicketsScreen: "Удалить билеты на экране",
            assigntLastTicketAli: "Назначить последний билет Али",
            changeStatusAllTicket: "Изменить статус всех билетов на выполненный",
            setStatusTicketsScreen: "Установить статус билетов на экране на .......",
            assigntUserTicketScreen: "Назначить билеты на экране пользователю .....",
            assigntFirstTicket: "Назначить первый билет мне",
            showIgTickets: "Показать билеты из Instagram за прошлый месяц",
            makeChoice: "Сделать выбор",
            makeAssignment: "Сделать назначение",
            tickets: "Билеты",
            instagramTickets: "Билеты Instagram",
            facebookTickets: "Билеты Facebook",
            trendyolTickets: "Билеты Trendyol",
            automationTickets: "Билеты автоматизации",
            supsisFormTickets: "Билеты Supsis Form",
            columnSettings: "Настройки колонок",
            ticketField: "Билетная зона",
            contactPropertyFields: "Достичь территории объекта",
            ticketFilterList: {
                archivedRequests: "Архивные запросы",
                comingFromFacebook: "Из Facebook",
                comingFromInstagram: "Из Instagram",
                unassignedOpenRequests: "Нераспределенные открытые заявки",
                openRequests: "Открытые запросы",
                requestsOpenedThisWeek: "Заявки открыты на этой неделе",
                specialList: "Специальный список",
                creationDate: "Дата создания",
                supsisFromTheForm: "Супсис из формы",
                fromTrendyol: "От Trendyol",
                comesWithAutomation: "Происходит от автоматизации",
                label: "Этикетка",
                status: "Статус",
                subject: "Тема",
                email: "Электронная почта",
                name: "Имя",
                phone: "Телефон",
                type: "Тип",
                assignedUser: "Назначенный пользователь",
            },
            appointingRepresentative: "Назначьте представителя",
            ticketTagFilter: "Тег фильтра билетов",
            ticketEmails: "Список рассылки для пересылки билетов",
            save: "Сохранить",
            delete: "Удалить",
            transactions: "Параметры",
            noEmailTicketNotifications: "Нет данных",
            emailIsNotValid: "Email не является допустимым",
            emailNotificationDeleted: "Товар удален успешно",
            emailNotificationDeleteError: "Произошла ошибка",
            tagFilterRequired: "Требуется тег фильтра заявки, используйте тег * (подстановочный знак) для всех заявок",
            emailsRequired: "Пересылка писем не должна быть нулевой",
            emailNotificationCreated: "Создано правило пересылки билетов",
            emailNotificationCreateError: "Произошла ошибка",
            ticketForwarding: "Пересылка билетов по электронной почте",
            ticketTagFilterDesc:
                "Он использует темы тикетов, которые вы использовали в дизайне чат-бота, для фильтрации тикетов. Вы можете написать другой тег и нажать Enter, чтобы добавить его. Если вы выберете тег '*', он выберет все билеты",
            ticketEmailsDesc:
                "Список адресов электронной почты, на которые будут отправлены билеты. Вы можете добавить адреса представителей в систему, выбрав их. Вы также можете добавить несистемные адреса электронной почты.",
            ticketList: "Правила пересылки билетов",
            ticketTagFilterPlaceHolder: "Фильтр билетов, выберите '*' для всех",
            ticketEmailsPlaceHolder: "Список рассылки для пересылки",
        },
        theme: {
            opacity: "Непрозрачность",
            headerColor1: "Секция Хадера, цвет 1",
            headerColor1A: "Непрозрачность раздела Хадера 1",
            headerColor2: "Цвет раздела заголовка 2",
            headerColor2A: "Непрозрачность раздела заголовка 2",
            backgroundColor: "Цвет фона 1",
            backgroundColorA: "Прозрачность фона 1",
            backgroundColor2: "Цвет фона 2",
            backgroundColor2A: "Прозрачность фона 2",
            textColor: "Цвет текста",
            errorTheme: "Цвет ошибки",
            selectCustom: "Выберите настраиваемую тему",
            bubbleBackground: "Репрезентативный цвет пузыря",
            bubbleVisitorBackground: "Цвет кружка клиента",
            bubbleBackgroundA: "Репрезентативная непрозрачность пузырька",
            bubbleVisitorBackgroundA: "Непрозрачность пузырька клиента",
            bubbleText: "Репрезентативный цвет текста",
            bubbleVisitorText: "Цвет текста клиента",
            textFormColor: "Цвет формы",
            headerColorSecond: "Цвет верхней части заголовка",
            headerColorFirst: "Нижний цвет заголовка",
            backgroundColorFirst: "Фон Верхний цвет",
            formColor: "Цвет текста формы",
            buttonColor: "Цвет кнопки",
            backgroundColorSecond: "Цвет фона снизу",
            chatBotButtonText: "Цвет шрифта чат-бота",
            chatBotButtonColor: "Цвет кнопки чат-бота",
        },
        billing: {
            billingContactInfo: "Контактная информация биллинга успешно обновлена.",
            defaultRootEmail: "По умолчанию: Основной адрес электронной почты",
            invoiceEmailAddress: "Адрес электронной почты счета",
            invoiceSettings: "Настройки счета",
            updateChannelDesc6: "Обновить канал Whatsapp business api",
            newWabaChannel: "Новый бизнес-канал Whatsapp",
            newWabaChannelDesc: "Создать новый канал для Whatsapp business api",
            popular: "Популярный",
            selectedPlan: "Выбранный план",
            editPlan: "Редактировать план",
            removePlan: "Удалить план",
            showPlan: "Показать план",
            hiddenPlan: "Скрыть план",
            contactSales: "Контактные продажи",
            showLess: "Показать меньше",
            more: "Больше",
            selectTransactionType: "Выберите тип транзакции",
            walletLogs: "Журналы кошелька",
            addBalance: "Пополнить баланс",
            availableBalance: "Доступный баланс",
            appsumoPack: "Appsumo Pack",
            updatePlan: "Обновить план",
            createPlan: "Создать план",
            freePack: "Бесплатный пакет",
            instantFee: "Будет взиматься мгновенная плата",
            planSequence: "Последовательность плана",
            requiredCodes: "Необходимое количество кодов",
            subHeading: "Подзаголовок",
            featureKey: "Ключ характеристики",
            customerKey: "Ключ клиента",
            monthlyPrice: "Месячная цена",
            monthlyNonDiscounted: "Ежемесячная недисконтированная цена (нефункциональное отображение)",
            twoYearDiscount: "Скидка на 2 года",
            yearDisccount: "Годовая скидка",
            sixMonthDiscount: "Скидка на 6 месяцев",
            threeMonthDiscount: "Скидка на 3 месяца",
            features: "Характеристики",
            sessionCount: "Количество сеансов",
            subType: "Тип подписки",
            skipTrialVersion: "Пропустить пробную версию",
            skipTrialVersionDesc:
                "Вы можете пропустить пробную версию и продолжить, выбрав подходящий пакет для вашего бизнеса. Если вы пропустите пробную версию, это действие нельзя будет отменить.",
            skipStep: "Пропустить этот шаг",
            switchToPay: "Переключиться на оплату",
            forward: "Вперед",
            pleaseFillInCard: "Пожалуйста, заполните данные карты!",
            fillInTheBillingAddress: "Пожалуйста, заполните информацию о платёжном адресе!",
            cardNumberWrong: "Номер карты неверен!",
            pleaseConfirmTheUser: "Пожалуйста, подтвердите пользовательское соглашение.",
            pleaseCheckYourCard: "Пожалуйста, проверьте вашу карту и ваши данные.",
            site: "Сайт",
            period: "Период",
            billStatus: "Статус счета",
            totalPrice: "Общая цена + НДС",
            depotMoneyWallet: "Пополнение кошелька",
            threeMonthly: "Каждые 3 месяца",
            sixMonthly: "Каждые 6 месяцев",
            twoYearly: "2 года",
            forever: "Навсегда",
            extraPackage: "Дополнительный пакет",
            teamPackage: "Командные пакеты",
            adventPackage: "Выгодные пакеты",
            cupponError: "Код ваучера неверен или истек.",
            enterYourCard: "Пожалуйста, введите вашу кредитную карту",
            invalidCard: "Недействительная кредитная карта, платеж не получен",
            calculateThis: "Рассчитать для:",
            adventageousPackage: "Выгодные скидки на пакеты!",
            cuponApplied: "Купон успешно применен",
            subStart: "Подписка начата",
            subSuccessStart: "Ваша подписка успешно начата",
            success: "Успешно",
            succesDesc: "Подписка успешно создана",
            successDesc: "Ваша функция была успешно активирована.",
            maxNumber: "Максимальное количество представителей для выступления",
            currentAmountDetails: "Сведения о текущей сумме",
            endOfMonthForecastDetails: "Сведения о прогнозе на конец месяца",
            totalAmount: "Общая сумма",
            vatAmount: "Сумма НДС (20%)",
            totalAmountIncludingVAT: "Общая сумма с учетом НДС",
            hideDetails: "Скрыть детали",
            createInvoice: "Создать счет-фактуру",
            reimbursementMade: "Произведено возмещение",
            invalidInvoice: "Недействительный счет-фактура",
            balanceTopUp: "Пополнение баланса",
            paidSuccesfully: "Счет-фактура был успешно оплачен",
            paymentFailed: "Процесс оплаты счета завершился неудачно",
            areYouSurePaid: "Вы уверены, что хотите, чтобы этот счет был отмечен как оплаченный?",
            invoiceMarkedPaid: "Счет-фактура был отмечен как оплаченный.",
            invoiceMarkedFailed: "Произошла ошибка, и счет-фактуру не удалось пометить как оплаченный.",
            areYouSoreRefundInvoice: "Вы уверены, что хотите обработать возврат для этого счета?",
            youMustFillInEmpty: "Вы должны заполнить все пустые места.",
            createdNewInvoice: "Новый счет-фактура был создан успешно",
            createdNewInvoiceFailed: "При создании счета-фактуры произошла ошибка.",
            invoiceUpdated: "Сумма счета-фактуры успешно обновлена...",
            invoiceUpdatedFailed: "При обновлении счета-фактуры возникла проблема.",
            plans: "Планы",
            companyName: "Название компании",
            compony: "Компания",
            person: "Человек",
            invoiceAddressInfo: "Информация об адресе счета-фактуры",
            idNo: "Турецкий идентификатор",
            taxOffice: "Налоговая инспекция",
            taxNumber: "Налоговый номер",
            packageCanNotDownSupsis:
                "Ваш пакет не может быть понижен. Пожалуйста, удалите или деактивируйте несколько ваших Агентов, чтобы понизить уровень вашего пакета.",
            packageCanNotDownWp:
                "Ваш пакет не может быть понижен. Пожалуйста, удалите несколько ваших каналов Whatsapp, чтобы понизить рейтинг вашего пакета.",
            packageCanNotDownWPBussiness:
                "Ваш пакет не может быть понижен. Чтобы понизить статус пакета, удалите несколько своих бизнес-каналов Whatsapp.",
            chooseYourPlan: "Выберите план",
            numberOfRepresentatives: "Количество представителей",
            numberOfChannels: "Количество каналов",
            wpNumberOfChannels: "Количество каналов Whatsapp",
            igNumberOfChannels: "Количество каналов Instagram",
            msNumberOfChannels: "Количество каналов Messenger",
            cancelIt: "Отмена",
            activePlan: "Активный план",
            activate: "Активировать",
            noTransition: "Без перехода",
            daysLater: "дня спустя",
            payBack: "Оплатить",
            paid: "Оплаченный",
            unPaid: "Неоплачиваемый",
            editPrice: "Редактировать цену",
            payNow: "заплатить сейчас",
            youAreCurrentlyOnTrial:
                "В настоящее время вы находитесь на испытательном сроке. Вы можете пропустить испытательный срок, чтобы увидеть эксклюзивные пакеты.",
            youAreCurrentlyLimited:
                "В настоящее время вы ограничены системой, поскольку ваши пакеты не соответствуют условиям.",
            youHaveOneRepresentative: "У вас есть один представитель.",
            deactivateOrDeleteYourPiece:
                "Деактивируйте или удалите своего представителя Piece или купите представителя.",
            youHaveOneWhatsappQRChannel: "У вас есть один QR-канал Whatsapp.",
            deleteYourWhatsAppQR: "Удалить свой Whatsapp QR-канал или купить канал.",
            youHaveAWhatsappBusiness: "У вас есть один канал Whatsapp Business.",
            deleteYourWhatsapp: "Удалить свой канал Whatsapp Business или купить канал.",
            youHaveAnInstagram: "У вас есть канал Instagram.",
            deleteYourInstagram: "Удалить свой канал Instagram или купить канал.",
            youHaveAMessenger: "У вас есть канал Messenger.",
            deleteYourMessenger: "Удалите свой канал Messenger или купите канал.",
            additionalPackages: "Дополнительные пакеты",
            availablePackages: "Доступные пакеты",
            buyNow: "Купить сейчас",
            invoiceInformation: "Информация о счете",
            invoiceAddress: "Адрес для счета",
            invoiceType: "Тип счета",
            review: "Обзор",
            viewDetails: "Просмотреть детали",
            addNewAddress: "Добавить новый адрес",
            enterYourBillingAddress: "Введите адрес для выставления счета",
            selectPlan: "Выберите план",
            paymentStatus: "Статус оплаты",
            amount: "Сумма",
            invoiceID: "Идентификатор счета",
            expected: "Ожидается..",
            currentAmount: "Текущая сумма",
            monthlyEstimatedAmount: "Ежемесячная примерная сумма",
            creationDate: "Дата создания",
            invoiceStatus: "Статус счета",
            invoicePeriod: "Период выставления счета",
            newPaymentMethod: "Новый способ оплаты",
            channelCount: "Количество каналов",
            remainingTime: "Оставшееся время",
            chatbotLimit: "Лимит чатбота",
            free: "Бесплатно",
            maxChatbotSession: "Максимальное количество сеансов чатбота",
            buyIt: "Купить",
            renewalDate: "Дата обновления",
            monthly: "Ежемесячно",
            yearly: "Ежегодно",
            packagePeriod: "Период пакета",
            packageType: "Тип пакета",
            packageManagement: "Управление пакетами",
            invoiceManagement: "Управление счетами",
            futureInvoice: "Будущий счет",
            pastInvoices: "Прошлые счета",
            creditCard: "Кредитная карта",
            invoice: "Инвойс",
            mustBeUpgradePlanForChatBot: "Чтобы активировать функцию ChatBot, вы должны перейти на тариф Pro!",
            incorrect: "Неправильно",
            cardInfo: "Информация о карте",
            billingDetails: "Платежные реквизиты",
            firstPreferredCard: "Сделать основной картой",
            primary: "Начальный",
            addCardIyzico:
                "У вас нет зарегистрированной карты. Чтобы оплачивать ежемесячную плату за использование, вам необходимо добавить карту. Платежная система предоставляется iyzico.",
            billingPlanSettings: "Биллинг и счет-фактура",
            startWith: "Карточка {cardFamily} начинается с {binNumber}",
            paymentMethod: "Способ оплаты",
            billingDate: "Дата оплаты",
            isPaid: "Платеж получен?",
            billingHistory: "История счетов",
            markPaid: "Отметить как оплаченное",
            paymentDate: "Дата платежа",
            pay: "Платить",
            newInvoice: "Создать счет-фактуру",
            updateBilling: "Обновить платежную информацию",
            updateCard: "Сменить кредитную карту",
            paymentBilling: "Метод Paymnet и платежные реквизиты",
            price: "Цена",
            billingAddress: "Платежный адрес",
            billingCity: "Город",
            billingCountry: "Страна",
            contactName: "Имя контактного лица по счетам",
            expireMonth: "Срок действия месяца",
            expireYear: "Год истечения",
            cardNumber: "Номер карты",
            cardHolderName: "Имя владельца карты",
            cardAlias: "Псевдоним карты",
            identityNumber: "Идентификационный номер",
            name: "Имя",
            surname: "Фамилия",
            email: "Эл. адрес",
            addCard: "Добавить карту",
            update: "Обновлять",
            cancel: "Отмена",
            save: "Сохранить",
            saving: "Экономия",
            noInvoiceFound: "Нет счета",
            year: "Год",
            updating: "Обновление...",
            newInvoiceForm: "Форма создания нового счета",
            error: "Ошибка",
            transactions: "Параметры",
            paymentMethodAdded: "Способ оплаты успешно добавлен",
            paymentMethodAddError: "Способ оплаты не добавлен, произошла ошибка",
            creditCardChanged: "Кредитная карта успешно изменена",
            errorOccurred: "Произошла ошибка, попробуйте еще раз",
            billingDetailUpdated: "Платежная информация успешно обновлена",
            invoiceCreated: "Счет-фактура успешно создана",
            paymentSuccess: "Оплата прошла успешно, спасибо",
            paymentFail: "Платеж не прошел, попробуйте еще раз",
            billingAddressChanged: "Платежный адрес успешно изменен",
            hidePlan: "Скрыть план",
            informationShopping:
                "Ваша платежная информация, платежная информация, информация о кредитной карте контролируются Shopify.",
            trialTimeInformation:
                "Пробная версия заканчивается через {dayCount} дней после. Если вы не укажете способ оплаты до истечения этого периода, система автоматически переключит вас на БЕСПЛАТНЫЙ ПЛАН.",
            trialTimeInformationShort: "Последний {dayCount} День",
            currentPlanLabel: "Текущий план: {planName} ({agentCount} Агент )",
            changeCancelPlan: "Изменить / отменить тарифный план",
            oneAgent: "Агент",
            agent: "Агент",
            yourCurrentPlan: "Текущий план",
            month: "Месяц",
            billedMonthToMonth: "(выставляется счет от месяца к месяцу)",
            selectAgentCount: "Выберите количество агентов",
            selectFreePlan: "Выберите бесплатный план",
            planDetails: "Детали плана",
            multiAgent: "(Мультиагент)",
            selectProPlan: "Выберите план Pro",
            foreverFree: "Вечно свободный",
            websiteIntegration: "интеграция с сайтом",
            websiteIntegrationUnlimited: "интеграция с сайтом (неограниченный)",
            ChatBotUnlimited: "ChatBot (неограниченный)",
            videoCallUnlimited: " видеозвонок (неограниченный)",
            multiAgentUpTo: "Мультиагент (до {agentCount} агентов)",
            audioCallUnlimited: "Аудиовызов (неограниченный)",
            screenSharingUnlimited: "Совместное использование экрана(неограниченный)",
            fileTransferUnlimited: "Передача файлов (неограниченный)",
            autoChatAssignerUnlimited: "Автоматическое назначение чата (неограниченный)",
            multiLanguageTranslationUnlimited: "Многоязычный перевод (неограниченный)",
            detailedReporting: "Подробная отчетность",
            days30TrialsAvailable: "Доступны 30-дневные пробные версии",
            fullCustomizationUnlimited: "Полная настройка (неограниченный)",
            limitedArchiveLookupLastMo: "Ограниченный архив Поиск (Последний {monthCount}-мес)",
            planUpdated: "Отлично, ваш план обновлен.",
            planUpdating: "Ваш план обновляется...",
            planUpdatingDescription: "Подождите, пока ваш план обновится",
            done: "Выполнено",
            freePlanUpdated: "Ваш план обновлен как бесплатный (1 Агент)",
            proPlanUpdated: "Ваш план обновлен как план PRO {agentCount} Агент ",
            canNotDwnGrade:
                "Невозможно понизить ваш тарифный план с PRO {agentCountFirst} Агент до {valNewPlnToUppr} {agentCountSecond}.  ",
            deleteWarning: "Вы должны удалить или отключить {valDif} Агент.",
            warnMessage: "Выбранный план должен отличаться от текущего.",
            add: "Добавлять",
            cancelYourPlan: "Отменить тарифный план",
            upgradeYourPlan: "Обновите свой план",
            downgradeYourPlan: "Понизьте свой план",
            agree: "ДАТЬ СОГЛАСИЕ",
            disagree: "Не согласен",
            invoices: "Счета",
            priceIntervals: "Ценовой интервал",
            selectSiteAlias: "Выберите или введите название сайта",
            selectPriceInterval: "Выберите или введите ценовой интервал",
            isRefunded: "Возврат сделан?",
            invoiceId: "Счет №",
            siteId: "Сайт №",
            createdDate: "Дата создания",
            failCount: "Количество неудачных попыток получения платежа",
            failDate: "Неудачная дата платежа",
            Dashboard: "Панель приборов",
            Agents: "Агенты",
            Integration: "Интеграция",
            Settings: "Настройки",
            Contacts: "Контакты",
            Domain: "Домен",
            lastActivity: "Последняя активность",
            basePrice: "Базисная цена",
            packagePrice: "Базисная цена",
            whatsappPrice: "WhatsApp Цена",
            realtimeVisitorCount: "Посетитель в реƒжиме реального времени",
            suspend: "Приостановить",
            partner: "Партнер",
            plan: "Строить планы",
            trialDay: "Пробные дни",
            mobile: "Мобильный",
            webSite: "Веб-сайт",
            websiteOrigins: "Происхождение веб-сайта",
            ownerName: "Имя владельца",
            ownerEmailAddress: "Электронная почта владельца",
            discount: "Скидка",
            daysLeft: "Осталось дней",
            newTrialPopUp: "Сколько дней должен длиться новый пробный период?",
            newWpPricePopUp: "Сколько стоит новый тариф WhatsApp?",
            newIGPricePopUp: "Сколько стоит новый тариф Instagram?",
            newBasePricePopUp: "Сколько стоит новая базовая цена?",
            siteInfoUpdated: "Информация о сайте обновлена",
            siteInfoNotUpdated: "Информация о сайте не обновлена",
            siteInfoNotUpdatedErr: "Произошла ошибка! Информация о сайте не обновлена.",
        },
        tour: {
            stats: " ПАНЕЛЬ СТАТИСТИКИ ",
            chats: " ЧАТ ПАНЕЛЬ ",
            settings: " НАСТРОЙКИ ",
            status: " СТАТУС ",
            prevStep: " Предыдущий шаг ",
            nextStep: " Следующий шаг ",
            finish: " Закончи это ",
            skip: " Прыжок ",
            skip2: " Я знаю систему, больше не показываю",
            startTour: "Начать тур",
            firstTimeIntro:
                " Я обнаружил, что вы впервые вошли в систему, если вы позволите, я хочу начать небольшой вводный тур. ",
            hi: " Привет ",
            welcomeTo: " Добро пожаловать в службу поддержки Supsis Live ",
            statsPanel:
                " Это строка состояния, показывающая общее количество активных номеров чата, которые мгновенно ожидают вместе с системой.",
            sidebarMenu: " Меню ",
            sidebarMenuContent: " Здесь вы можете переключаться между страницами.",
            representativePrivateMessage: "Межпредставительская дискуссионная панель",
            representativePrivateMessageContent: " Здесь вы можете увидеть личные разговоры между агентами.",
            helpMenu: "Меню помощи",
            helpMenuContent: " Здесь вы можете найти справочную информацию о системе.",
            settingsMenu: " Меню настроек ",
            settingsMenuContent: " Здесь вы можете выбрать язык, ночной режим и увеличение экрана.",
            startChat: "Начать Чат",
            profileMenu: " Меню профиля ",
            profileMenuContent: " Здесь вы можете изменить доступность и настроить параметры делегата.",
            visitorsTab: " Посетители ",
            visitorsTabContent: " Вы можете увидеть посетителей здесь. ",
            visitorTabHistory: " История посетителей ",
            visitorTabHistoryContent: " Вы можете увидеть историю посетителей здесь.",
            representativeTab: " Представители ",
            representativeTabContent: " Вы можете увидеть представителей здесь.",
            liveSupport: " Живая поддержка ",
            liveSupportContent:
                " Здесь вы можете увидеть количество клиентов, получающих поддержку в реальном времени.",
            siteVisitors: "Посетители сайта",
            siteVisitorsContent: " Здесь вы можете увидеть количество посетителей сайта.",
            tableSettings: " Настройки стола ",
            tableSettingsContent: "Отсюда вы можете показать или скрыть столбцы в таблице.",
            watchModeButton: "Кнопка просмотра",
            watchModeContent:
                " Вы можете присоединиться сюда в режиме просмотра, и вы можете просматривать только то, что было опубликовано.",
            popoverInfo: " Подробная информация о посетителе ",
            popoverInfoContent: " Дает информацию о посетителе.",
            popoverButton: " Расширенные настройки речи ",
            popoverButtonContent:
                " Вы можете открыть беседу, отправить сообщение напрямую представителю или заблокировать посетителя.",
            openChat: " Кнопка: Присоединиться к разговору",
            openChatContent: " Вы можете начать разговор здесь ",
            pagination: " Меню подкачки.",
            paginationContent: " Здесь вы можете увеличить количество страниц.",
            chatwindow: {
                chatWindowSettingsButtons: " КНОПКА НАСТРОЕК ОКНА РАЗГОВОРА ",
                chatWindowActionButtons: " ОКНО РЕЧИ КНОПКИ ОБЩИХ ОПЕРАЦИЙ ",
                chatPanelActions: " РАБОТА С РЕЧНОЙ ПАНЕЛЬЮ ",
                otherPanels: "ДРУГИЕ ПАНЕЛИ",
                settingsButton:
                    "Вы можете заблокировать речь, пересылку, конфиденциальное сообщение и назначить делегатов.",
                chatColorButton: " Вы можете узнать, что означает цвет в речевых пузырях, здесь.",
                keyboardShortcutButton:
                    " Здесь вы можете найти ярлыки для функций, которые упрощают ведение переписки или других функций, которые вы используете. ",
                hideButton: "Откладывает открытое выступление и остается открытым на заднем плане",
                closeButton: " Вы заканчиваете откровенный разговор и уходите из разговора ",
                ellipsisButton:
                    " Сюда включены другие транзакции. Здесь выполняются такие операции, как отправка личных сообщений, запрет посетителей, назначение представителей. ",
                userInfoWidget: " Подробная информация о посетителе будет доступна здесь. ",
                preparedContentWidget:
                    "Есть готовые шаблоны контента. Вы можете быстро добавить готовый контент, щелкнув ярлык или набрав серию ярлыков в области письма на экране речи.",
                chatHistoryWidget:
                    " Если у этого посетителя есть прошлые разговоры, они будут перечислены здесь. Вы можете просмотреть старые детали речи здесь ",
                chatBarButton:
                    " Здесь вы можете заблокировать активный разговор, отправить личное сообщение агенту и выйти из разговора.",
            },
        },
        adminUser: {
            newAdminUserForm: " Форма регистрации нового администратора ",
            updateAdminUserForm: " Форма обновления пользователя-администратора ",
            adminUsers: " Пользователи с правами администратора ",
            newAdminUser: " Новый пользователь-администратор ",
            noAdminUser: " Еще нет пользователя с правами администратора.",
            adminUserName: " Имя пользователя администратора ",
        },
        report: {
            incomingMessages: "Входящие сообщения",
            outgoingMessages: "Исходящие сообщения",
            customerCount: "Подсчет клиентов",
            mailCount: "Подсчет почты",
            answered: "Ответил",
            unanswered: "без ответа",
            selectaChannel: "выбор канала",
            sentMails: "Отправленные письма",
            sentMailCount: "Количество отправленных писем",
            eventCount: "Количество событий",
            ticketDistribution: "Распространение билетов",
            selectWorkflow: "Выберите рабочий процесс",
            distributionOfTasks: "Распределение заданий",
            mostMissioned: "Больше всего задач",
            leastTasked: "Наименьшее количество задач",
            totalNumberTasks: "Общее количество заданий",
            errorFetchingTask: "Ошибка при получении данных задачи:",
            pipelinePhase: "Фаза конвейера",
            status: "Статус",
            numberOfTasks: "Количество задач",
            insufficientData: "Недостаточно данных",
            hourly: "(Часовой)",
            hourlyAverage: "Средний за час",
            hourlyMax: "Максимум за час",
            hourlyMin: "Минимум за час",
            totalAmount: "Общая сумма",
            averageAmount: "Средняя сумма",
            minAmount: "Минимальная сумма",
            maxAmount: "Максимальная сумма",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Временной ряд каналов",
            channelPies: "Пироги каналов",
            pieView: "Круговая диаграмма",
            topVisitorCountry: "Страна с наибольшим количеством посетителей",
            websiteTrafficByCountry: "Трафик веб-сайта по странам",
            visitorCount: "Количество посетителей",
            websiteVisitorTraffic: "Трафик посетителей на сайте",
            websiteTraffic: "Трафик сайта",
            author: "Автор",
            topWorstComments: "Худшие комментарии",
            topBestComments: "Лучшие комментарии",
            topComments: "Лучшие комментарии",
            noComment: "Комментариев пока нет",
            minWaitingTime: "Минимальное время ожидания",
            maxWaitingTime: "Максимальное время ожидания",
            averageWaitTime: "Среднее время ожидания",
            waitTime: "Время ожидания (секунды)",
            agentWaitDurationTitle: "График времени ожидания агента",
            incomingMessage: "Входящее сообщение(я)",
            outgoingMessage: "Исходящее сообщение(я)",
            totalSpent: "Общие расходы",
            avgSpent: "Средние расходы",
            totalPayment: "Общая оплата",
            walletStatus: "Состояние кошелька",
            walletBalanceStatus: "Состояние баланса кошелька",
            messageTraffic: "Сообщения",
            breakCount: "Количество перерывов",
            agentBreakTime: "Количество перерывов агентов ☕",
            agentStatusHour: "Часовой статус агента",
            agentWorkTimeCalendar: "Календарь рабочего времени агента",
            agentActivity: "Активность агента",
            noEnoughtData: "Достаточно данных нет",
            averageFirstResponse: "Среднее время первого ответа",
            slowestResponser: "Самый медленный отвечающий",
            fastestResponder: "Самый быстрый отвечающий",
            firstAnswerTimeSec: "Время первого сообщения (в секундах)",
            firstAnswerByAgent: "Время первого сообщения от агента",
            averageSolutionTime: "Среднее время решения",
            slowestSolver: "Самый медленный решатель",
            fastestSolver: "Самый быстрый решатель",
            averageChat: "Средний чат",
            leastChatReceiver: "Наименее активный получатель чата",
            mostChatRecipients: "Наибольший количество получателей чата",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Время разрешения (мин)",
            resolveTimeByUser: "Время разрешения чата пользователем (в минутах)",
            chatResolveTimeByAgent: "Время разрешения чата агентами",
            chatDistByHandleType: "Распределение чатов по обработчику",
            chatDistByHandDesc: "Сколько чатов обработали агенты, чатботы и гибриды?",
            chatCountsByHandleType: "Число чатов по типу обработки",
            missed: "Пропущено",
            chatDistByAnsDesc: "Сколько чатов было ответов или пропущено?",
            chatCountsByAns: "Количество чатов по ответу",
            chatCountByPlatform: "Количество чатов по платформе",
            chatDistByPDesc: "Сколько чатов поступило на какую платформу?",
            chatDistByPlatform: "Распределение чатов по платформе",
            ticketCountByUser: "Подсчет билетов по агентам",
            ticketCountByStatus: "Количество билетов по статусу ответа",
            user: "Пользователь",
            saveAsImage: "Сохранить как изображение",
            fullScreen: "Полноэкранный режим",
            download: "Скачать",
            tableView: "Вид таблицы",
            chartView: "Вид диаграммы",
            chatDistByUsers: "Распределение чатов по пользователям",
            chatCountsByUsers: "Количество чатов по пользователям",
            minDuration: "Минимальная продолжительность",
            maxDuration: "Максимальная продолжительность",
            totalDurationByAgent: "Общая продолжительность сеанса по агенту",
            averageDurationByAgent: "Средняя продолжительность сеанса по агенту",
            totalDurationByCB: "Общая продолжительность сеанса по чатботу",
            averageDurationByCB: "Средняя продолжительность сеанса по чатботу",
            viewUnitAs: "Просмотреть единицу как",
            hybrid: "Гибридный",
            handledBy: "Обработано",
            sessionDurationOverall: "Общая продолжительность сессии",
            allChannels: "Все каналы",
            sessionsDurationOverall: "Общая длительность сессий",
            sessionsOverall: "Общее количество сессий",
            calendarEvents: "Календарные события",
            reservationEvents: "События бронирования",
            incomingMails: "Входящие письма",
            incomingMailCount: "Количество входящих писем",
            reservation: "Бронирование",
            event: "Событие",
            reservationEventCount: "Количество событий бронирования",
            channelBreakdown: "Разбивка каналов",
            websiteAnalysis: "Анализ веб-сайта",
            customerSatisfaction: "Удовлетворенность клиентов",
            teamBreakAnalysis: "Анализ работы команды/перерыва",
            dailyAgentActivity: "Ежедневная активность агента",
            agentPerformance: "Производительность агента",
            chatDistributions: "Распределение чатов",
            users: "Пользователи",
            segmentTimeseries: "График сегмента",
            segmentsOverall: "Общие сегменты",
            unmatchRatio: "Коэффициент несовпадения",
            totalMatchCount: "Общее количество совпадений",
            totalUnmatchCount: "Общее количество несовпадений",
            matchRatio: "Коэффициент совпадения",
            matched: "Совпадает",
            trainingOverall: "Общая тренировка",
            trainingStatusTimeseries: "График статуса обучения",
            duration: "Продолжительность",
            totalSessionDuration: "Общая продолжительность сессии",
            averageSessionDuration: "Средняя продолжительность сессии",
            second: "секунда",
            minute: "минута",
            hour: "час",
            aggregateAs: "Агрегировать как",
            chatbotSessionDurationOverall: "Общая продолжительность сессии чатбота",
            ratingTimeSeries: "График оценок",
            chatCountTimeseries: "Временной ряд количества чатов",
            notRated: "Не оценено",
            totalRatingCount: "Общее количество оценок",
            averageRating: "Средний рейтинг",
            weightedAverageRating: "Взвешенный средний рейтинг",
            rate: "Оценить",
            ratingOverall: "Общие оценки клиентов",
            session: "Сеанс",
            total: "Всего",
            average: "Среднее",
            max: "Максимум",
            min: "Минимум",
            sessionCount: "Количество сеансов",
            uniqueUsers: "Уникальные пользователи",
            viewAs: "Просмотреть как:",
            overall: "Общий",
            detailReport: " Детальный отчет ",
            dailyReports: " Ежедневный отчет ",
            pointBasedReports: " Отчеты на основе оценок ",
            personDateBasedPointReport: " Отчет об оценке по количеству людей и дней ",
            personDateBasedReport: " Персональный и дневной отчет ",
            personBasedReport: " Персональные отчеты ",
            personAndDateBasedGraph: " График  людей и дней ",
            noReport: " Нет отчета ",
            reports: " Отчеты ",
            totalBar: " Общее ",
            ticketCount: "Ticket Count",
        },
        stats: {
            total: " Количество активных разговоров в системе.",
            active: " Количество принадлежащих вам активных разговоров.",
            waiting: " Количество новых активных разговоров, ожидающих делегирования.",
            late: " Количество новых разговоров, прошедших определенный период времени и ожидающих делегирования.",
            free: " Количество разговоров, ожидающих назначения нового представителя после выхода представителя из системы..",
            pco: "[Personel Çalışma Oranı] : Это коэффициент занятости от общего количества звонков, которые могут получить онлайн-представители в системе. ",
            maxCapacity:
                " Это максимальное количество чатов, которое система может назначить представителям без ожидания. ",
            chatbot: ` Количество активных разговоров чат-бота `,
        },
        time: {
            lastYear: "Прошлый год",
            thisYear: "Этот год",
            last3Months: "Последние 3 месяца",
            last7: "Последние 7 дней",
            today: " Сегодня ",
            yesterday: "Вчера",
            lastWeek: " Прошлая неделя ",
            currentWeek: " Эта неделя ",
            currentMonth: " Этот месяц ",
            lastMonth: " Прошлый месяц ",
            last30Day: " Последние 30 дней ",
            allTime: " Все время ",
            custom: " Другое время ",
        },
        fastWizard: {
            generalColors: "Общие цвета",
            tellUsMore: "Расскажите нам больше, чтобы мы могли персонализировать ваш опыт",
            moreInfo: "Больше информации",
            display: "Отображать",
            availability: "Доступность",
            preview: "Предварительный просмотр",
            installCode: "Установить код",
            previous: "Предыдущий",
            setupSupsisLiveChat: "Настроить чат SUPSIS LIVE",
            continue: "Следующий шаг",
            completeInitialize: "Завершить инициализацию",
            completedMessage: "Настройка чата SUPSIS LIVE успешно завершена.",

            websiteIntegration: "Адрес вашего веб-сайта для интеграции онлайн-чата supsis",

            customizeLiveChat: "Настройте свой онлайн-чат",
            createBrandedExperience: "Создайте фирменный чат для ваших посетителей.",
            chatColor: "Цвет чата",
            chatBubble: "Пузырь чата",
            selectBubble: "Выберите всплывающее окно чата",
            chatBubbleColor: "Цвет пузыря чата",
            selectChatBubbleColor: "Выберите цвет пузыря чата",
            customSelection: "Пользовательский выбор:",

            chatAvailability: "Доступность чата",
            onlineSupportVisitorTime: "Когда вы в сети, чтобы поддержать посетителей?",
            channelAvailability: "Доступность канала",
            availability724: "Чат доступен 7/24",
            basedOnTeam: "На основе статуса члена команды",
            basedOnTeamExplanation: "Чат появится в сети, если хотя бы 1 участник станет доступным.",
            customHours: "Индивидуальные часы работы",
            customHoursExplanation: "Настройте свое рабочее время",
            customHoursTimezone: "Часовой пояс:",
            customHoursFrom: "Из:",
            customHoursTo: "К:",
            customHoursAddHours: "+Добавить часы",

            previewDesktop: "Рабочий стол",
            previewIpad: "IPad",

            installationAndInstructions: "Инструкция & установке",
            installationTrackingCode: "Установите код отслеживания на свой сайт",
            installationTrackingCodePlease:
                "Вставьте код в соответствии с приведенными ниже инструкциями непосредственно перед концом тега {bodyTag} на любую страницу, на которой вы хотите включить чат SUPSIS Live.",
            installationInstructionsJavascript:
                " Вставьте приведенный выше код интеграции в тег {bodyTag} непосредственно перед закрывающим",
            installationInstructionsShopify1: "1. Войдите в свою панель Shopify",
            installationInstructionsCopy: "Копировать",
            installationInstructionsCoppyMessage: "Скрипт интеграции скопирован в буфер обмена",
            installationInstructionsShopify2:
                "2. Перейдите в Интернет-магазин> Темы> раскрывающееся меню Действия в разделе Текущая тема> Изменить код> тема.жидкость.",
            installationInstructionsShopify3:
                "3. Вставьте приведенный выше код интеграции непосредственно перед тегом {bodyTag} в конце скрипта theme.liquid.",
            installationInstructionsIdeaSoft1: "1. Войдите в свою дилерскую панель.",
            installationInstructionsIdeaSoft2: "2. Зайдите в Настройки -> SEO -> Службы поисковых систем.",
            installationInstructionsIdeaSoft3:
                "3. Выберите «Проверка сайта с помощью метатега» в разделе «Код отслеживания».",
            installationInstructionsIdeaSoft4:
                "4. Скопируйте и вставьте приведенный выше код интеграции в открывшееся поле и сохраните.",
            installationInstructionsIdeaSoft5:
                "5. Внутри настроек -> Оптимизация нажмите кнопку «Очистить кеш». На этом интеграция завершена.",
            installationInstructionsWordPress1: "1. Войдите в свою админ панель WordPress.",
            installationInstructionsWordPress2: "2. Перейдите в Внешний вид> Редактор тем.",
            installationInstructionsWordPress3:
                "3. В разделе «Файлы темы» (крайний справа) найдите нижний колонтитул темы (footer.php) и выберите его.",
            installationInstructionsWordPress4:
                "4. Вставьте приведенный выше код интеграции перед тегом {bodyTag} внизу.",
            installationInstructionsWordPress5: "5. Нажмите «Обновить файл», чтобы сохранить изменения.",
            installationInstructionsOpenCart1: "1. Войдите в свою админ панель Opencart.",
            installationInstructionsOpenCart2: "2. Перейдите в Внешний Дизайн > Редактор тем.",
            installationInstructionsOpenCart3: "3. Выберите «общую» папку и откройте файл 'header.twig'.",
            installationInstructionsOpenCart4:
                "4. Вставьте приведенный выше код интеграции перед тегом {headTag} внизу.",
            installationInstructionsOpenCart5: "5. Нажмите кнопку сохранения.",
            installationInstructionsTicimax1: "1. Войдите в свою административную панель Ticimax.",
            installationInstructionsTicimax2:
                "2. Откройте «Дизайн» > «Настройки дизайна» > «Дизайн нижнего колонтитула верхнего колонтитула».",
            installationInstructionsTicimax3: "3. Нажмите кнопку «Источник» в разделе дизайна логотипа.",
            installationInstructionsTicimax4: "4. Вставьте код интеграции выше под HTML-кодом.",
            installationInstructionsEticaretteyim1: "1. Войдите в панель администрирования вашего интернет-магазина",
            installationInstructionsEticaretteyim2:
                "2. Просто назовите SUPSIS из «Плагины»> «Создать HTML»> и скопируйте код.",
            installationInstructions: "инструкции",
            installationVerify: "Убедитесь, что на вашем сайте установлен SUPSIS",
            installationVerifyChecking: "Проверка",
            installationVerifyCheck: "Проверять",
            installationVerifyCheckingStatus: "Проверка статуса интеграции SUPSIS на {website} сайт",
            installationCheckingStatusMessageYes: "Отлично, SUPSIS интегрирован в {website} сайт !!",
            installationCheckingStatusMessageNo:
                "SUPSIS в настоящее время не интегрирован с веб-сайтом {website}. Вы можете завершить процесс интеграции сейчас или позже.",

            vtippyPreferredLanguage: "предпочтительный язык",
        },
        akinon: {
            typeOrSelectSKU: "Введите или выберите артикул",
            akinonUserId: "Идентификатор пользователя Акинон",
            userEmail: "Электронная почта пользователя",
            userEmailDesc: "Введите или выберите адрес электронной почты пользователя...",
            send: "Отправлять",
            selectCity: "Выберите город",
            city: "Город",
            selectState: "Выберите штат",
            state: "Состояние",
            useMap: "Использовать карту",
            chooseAddress: "Выберите адрес",
            selectCountry: "Выберите страну",
            country: "Страна",
            productIdDesc: "Введите или выберите продукт...",
            productId: "Код товара",
            userIdDesc: "Введите идентификатор пользователя Akinon...",
            productSKU: "Артикул продукта",
            latitudeDesc: "Введите или выберите широту целевого местоположения...",
            longitudeDesc: "Введите или выберите долготу целевого местоположения...",
            orderNumber: "Ваш номер заказа",
            orderDesc: "Введите номер заказа...",
            longitude: "Долгота",
            latitude: "Широта",
        },
        headBar: {
            source: "Источник",
            label: "Этикетка",
            completed: "Завершено?",
            email: "Электронная почта",
            phone: "телефон",
            name: "Имя",
            date: "История",
            subject: "Предмет",
            situation: "Ситуация",
            representative: "Представитель",
            transactions: "Транзакции",
        },
        login: {
            loginTitle1: "Добро пожаловать в",
            loginTitle2: "SUPSIS",
            email: "Ваш адрес электронной почты",
            emailPlaceholder: "Пожалуйста, введите Ваш адрес электронной почты.",
            emailError: "Пожалуйста, введите действительный адрес электронной почты",
            password: "Ваш пароль",
            passwordLogin: "Пароль Бесплатный вход",
            passwordAndLogin: "Войти с паролем",
            passwordNew: "Сбросить пароль",
            loginAnd: "Или",
            passwordPlaceholder: "Пожалуйста введите ваш пароль.",
            loginMemory: "Запомнить это устройство",
            passwordForget: "Я забыл свой пароль",
            passwordNewAgain: "Новый пароль",
            passwordNewAgainTwo: "Повторить новый пароль",
            passwordNewAgainPlaceholder: "Пожалуйста, введите новый пароль.",
            passwordNewAgainPlaceholderTwo: "Пожалуйста, введите новый пароль еще раз.",
            login: "Авторизоваться",
            loginFooter: "Или войдите с электронной почтой",
            emailLogin: "Войти с помощью электронной почты",
        },
        settings: {
            ipAddress: "Мой IP-адрес",
            whiteList: "Список защищенных IP-адресов",
            whiteListAdd: "Добавить безопасный IP",
            whiteListDeletedSuccessfully: "Контроль доступа удален успешно",
            whiteListDeletedFailed: "Контроль доступа не удален",
            whiteListAddedSuccessfully: "Контроль доступа добавлен успешно",
            whiteListAddedFailed: "Контроль доступа не добавлен",
            deleteWhiteListTitle: "Вы уверены, что хотите удалить этот белый список?",
            talkSettings: "Настройки речи",
            talkSubtitles: "Управление настройками речи",
            changeSettings: "Изменение настроек для автоматического назначения чата",
            dateAndTime: "Дата и время",
            actor: "Актер",
            event: "Событие",
            accessControl: "Контроль доступа",
            organizationLongName: "Длинное имя организации",
            visitorNewDesc: "Вы можете использовать новую версию темы для посетителей.",
            transactionType: "Тип транзакции",
            priorBalance: "Предыдущий баланс",
            nextBalance: "Следующий баланс",
            amount: "Сумма",
            phoneNumber: "Номер телефона",
            profileInfoRemoved: "Информация о профиле удалена",
            newValueUpdated: "Обновлено новое значение",
            balanceToTransferred: "Баланс, подлежащий переводу",
            availableBalance: "Доступный баланс",
            balanceReceived: "Полученный баланс",
            totalBalance: "Общий баланс",
            paymentCard: "Платежная карта",
            wpPhoneNumber: "Номер телефона Whatsapp",
            wpSendingMessage: "Whatsapp отправляет первое сообщение",
            auditlogs: "Журналы аудита",
            myaccount: "Мой аккаунт",
            notifications: "Уведомления",
            company: "Компания",
            features: "Особенности",
            general: "Общий",
            chat: "Чат",
            wallet: "кошелек",
            timings: "Время",
            language: "Язык",
            "bubble-settings": "Настройки пузыря",
            "bubble-actions": "Действия пузыря",
            "theme-settings": "Настройки темы чата",
            visitorLoginForm: "Форма входа посетителя",
            visitorAttribute: "Информация о профиле посетителя",
            timing_settings: "Настройки времени чата",
            auto_assign: "Auto Chat Assign",
            availability: "Доступность",
            "website-integration": "Интеграция веб-сайта",
            General: "Общий",
            Chat: "Чат",
            Timings: "Время",
            Integration: "Интеграция",
            developer: "Разработчик",
            visitorNew: "Новый посетитель",
            companySubtitles: "Управляйте настройками компании.",
            featuresSubtitles: "Управляйте функциями.",
            languageSubtitles: "Управляйте языковыми настройками.",
            bubbleSettings: "Настройки пузыря",
            bubbleSettingsSubtitles: "Управляйте настройками пузыря.",
            bubbleActionsSubtitles: "Управляйте действиями пузыря.",
            chatThemeSettingsSubtitles: "Управляйте настройками темы чата.",
            visitorLoginFormSubtitles: "Управляйте настройками формы входа посетителя.",
            chatTimingSettingsSubtitles: "Управляйте настройками времени чата.",
            webSiteIntegrationSubtitles: "Управляйте настройками интеграции веб-сайта.",
            apiAccessTitle: "Доступ к API",
            apiAccessSubtitles: "Управляйте доступом к API.",
            youTubeActionForm: "Добавьте свой канал YouTube",
            linkedinActionForm: "Добавьте свою учетную запись Linkedin",
            telegramActionForm: "Добавить учетную запись Telegram",
            facebookActionForm: "Добавьте свою страницу Facebook",
            tiwitterActionForm: "Добавьте свою страницу Twitter",
            instagramActionForm: "Добавьте свою страницу Instagram",
            liveSupportDescription: "Поддержка в реальном времени",
            ticketDescription: "Откройте чат с вашими клиентами",
            whatsappDescription: "Ваши клиенты могут связаться с вами через WhatsApp",
            phoneDescription: "Ваши клиенты могут связаться с вами по телефону",
            emailDescription: "Ваши клиенты могут связаться с вами по электронной почте",
            facebookDescription: "Ваши клиенты могут связаться с вами через Facebook",
            twitterDescription: "Ваши клиенты могут связаться с вами через Twitter",
            instagramDescription: "Ваши клиенты могут связаться с вами через Instagram",
            youtubeDescription: "Ваши клиенты могут связаться с вами через YouTube",
            linkedinDescription: "Позвольте вашим клиентам связаться с вами с помощью LinkedIn",
            telegramDescription: "Позвольте вашим клиентам достичь большего с помощью Telegram",
            whatsappModalTitle: "Форма обработки WhatsApp",
            whatsappModalDescription: "Чтобы подключить свой номер WhatsApp, заполните форму ниже.",
            phoneModalTitle: "Форма обработки телефона",
            phoneModalDescription: "Чтобы подключить свой номер телефона, заполните форму ниже.",
            emailModalTitle: "Форма обработки электронной почты",
            emailModalDescription: "Чтобы подключить свой адрес электронной почты, заполните форму ниже.",
            facebookModalTitle: "Форма обработки Facebook",
            facebookModalDescription: "Чтобы подключить свою страницу Facebook, заполните форму ниже.",
            twitterModalTitle: "Форма обработки Twitter",
            twitterModalDescription: "Чтобы подключить свою страницу Twitter, заполните форму ниже.",
            instagramModalTitle: "Форма обработки Instagram",
            instagramModalDescription: "Чтобы подключить свою страницу Instagram, заполните форму ниже.",
            youtubeModalTitle: "Форма обработки YouTube",
            youtubeModalDescription: "Чтобы подключить свой канал YouTube, заполните форму ниже.",
            linkedinModalTitle: "Форма транзакции LinkeIn",
            linkedinModalDescription: "Пожалуйста, заполните форму ниже, чтобы связать свою учетную запись LinkedIn.",
            telegramModalTitle: "Форма транзакции Telegram",
            telegramModalDescription:
                "Введите ссылку на свой профиль Telegram в форму ниже, чтобы связать свою учетную запись Telegram.",

            instagramAlertTitle: "Требуется интеграция с Instagram",
            instagramAlertDesc:
                "Извините, посещенная вами страница будет активирована при интеграции с вашим Instagram.",
            instagramActivateText: "Поехали, интегрируем Instagram",
            remove: "Удалить",
            edit: "Редактировать",
            connected: "Подключенный",
            add: "Добавить",
            themeDescription: "Выберите тему чата.",
            fontDescription: "Выберите шрифт чата.",
            isFabsAsIcon: "Показать тексты значков меню.",
            chatBubbleTextSetting: "Настройка текста чата",
            textOnChatBubble: "Вы можете настроить параметры текста, которые будут отображаться в пузыре чата.",
            textToAppearOnChatBubble: "Текст, который будет отображаться в пузыре чата",
            newVisitorProfileInformation: "Информация о профиле нового посетителя",
            newVisitorProfileInformationDescription: "Добавляет новую ценность информации профиля посетителя",
            create: "Создавать",
            newAdd: "Добавить новое",
            toInform: "Довести до сведения",
            toInformDescription:
                "Вы можете сопоставить значения, которые вы добавляете на этой странице, с формой входа посетителя.",
            showVisitor: "Показать посетителя",
            label: "Билет",
            text: "ПисьмоПисьмо",
            email: "почта",
            phone: "телефон",
            number: "Число",
            url: "URL",
            date: "Время",
            dropdown: "выбираемый",
            languageTimeZone: "Язык и регион",
            timeZoneTitle: "Регион и часовой пояс",
            timeZoneDescription: "Настройки региона и часового пояса",
        },
        userInfoWidget: {
            userInformation: "Информация о пользователе",
            fullName: "Имя и фамилия",
            newValue: "Новое значение",
            newProfileInfo: "Информация о новом профиле",
            affiliatedRepresentatives: "Представители",
            preferredAgents: "Предпочтительный агент(ы)",
            labels: "этикетки",
            agentNotes: "Примечания агента",
            newNote: "Новая заметка",
            note: "заметка",
            available: "Имеются заметки.",
            systemInformation: "Системная информация",
            speechID: "Идентификатор речи",
            customerVersion: "Версия клиента",
            IPAddress: "Айпи адрес",
            pageVisited: "Посещенная страница",
            systemAndBrowser: "Операционная система и браузер",
            countryAndLanguage: "Страна и язык",
            clickToEdit: "Изменить Нажмите внутри поста",
            adsYouAreInterestedIn: "Рекламы, которые вас интересуют",
            detail: "Деталь",
            adsTitle: "Заголовок",
            adUrl: "URL рекламы",
            sourceID: "Идентификатор источника",
            resourceType: "Тип ресурса",
            adsBody: "Содержание",
            adsCreateDate: "Дата создания",
            adsUpdateDate: "Дата обновления",
        },
        newWizartV2: {
            generalSettings: "общие настройки",
            themeSettings: "Настройки темы",
            representativeWorkingHours: "График работы представителя",
            preview: "предварительный просмотр",
            setup: "Настраивать",
            formStepTitle: "Дайте нам больше информации, чтобы мы могли персонализировать ваш опыт",
            supsisEntergation: "На каком вашем веб-сайте вы будете использовать Supsis?:",
            goToNextStep: "Сделайте следующий шаг",
            readytemplate: "Сделайте следующий шаг",
            customSettings: "Özel Ayarlar",
            customerMessageView: "Сообщение клиента Посмотреть",
            backcgroundColor: "Фоновый цвет",
            textColor: "Цвет шрифта",
            agentMessageView: "Представление сообщений агента",
            workingHours: "В какие промежутки времени вы обслуживаете своих посетителей?",
            continuousService: "Непрерывное обслуживание",
            continuousServiceDescription: "Пузырь чата всегда активен. Даже если вы не в системе.",
            vote: "Сделай свой выбор",
            representativeWorking: "График работы представителя",
            representativeWorkingDescription:
                "Чат появляется в сети, когда хотя бы 1 агент находится в сети. Если онлайн-представителя нет, он будет отображаться как офлайн.",
            computer: "Компьютер",
            tablet: "планшет",
            uploadTrackingCodeToYourWebsite: "Загрузите код отслеживания на свой веб-сайт",
            password: "Установить новый пароль",
        },
        whatsappChannel: {
            whatsappTitleV1: "Каналы Whatsapp V1 (QR)",
            whatsappTitleV2: "Каналы Whatsapp V2 (QR)",
            channelName: "Имя канала",
            phoneNumber: "Номер телефона",
            forwardToChatbot: "Переслать боту",
            forwardingChatbotOrLiveAgent: "Пересылка (бот или живой агент)",
            addChannel: "Добавить канал",
            newWhatsappChannel: "Новый канал WhatsApp",
            newWhatsappChannelDescription: "Создайте новый канал WhatsApp, отсканировав QR-код",
            editWhatsappChannel: "Редактировать канал WhatsApp",
            editWhatsappChannelDescription: "Редактирование канала WhatsApp",
            whatsappChannel: "Канал WhatsApp",
            deleteWhatsappChannelDescription: "Вы уверены, что хотите удалить этот канал?",
            whatsappIntegration: "Интеграция WhatsApp",
            deleteChannel: "Удалить канал",
            restartChannel: "Перезапустить канал",
            wantRestartChannel: "Хотите перезапустить канал?",
            deleteSMSChannelDescription: "Вы уверены, что хотите удалить канал SMS?",
            smsChannel: "СМС-канал",
            maxChannelCount: "Вы не можете создать более одного SMS-канала!",
            smsModalText:
                "Наша интеграция с современными коммуникационными решениями дает вам возможность легко и эффективно отправлять SMS. Устраните границы в общении, общайтесь напрямую со своими клиентами!",
            smsModalBtn: "Нажмите, чтобы открыть канал SMS...",
            postaCellDetail: "Подробности о канале PostaCell",
        },
        noPermission: "У вас нет разрешения на выполнение этой операции.",
        mail_integration_detail: {
            title: "Детали почты",
            integration: "Интеграция",
            sender: "Отправитель",
            signature: "Подпись",
            inbox: "Входящие",
            medias: "Медиа",
            visibility: "Видимость",
            settings_group: "Настройки",
            contacts: "Контакты",
        },
        whatsapp_business_api: {
            userVisibility: "Видимость пользователя",
            userVisibilityDesc:
                "Каналы, к которым могут получить доступ пользователи, зависят от их роли и настроек видимости канала. Пользователи с ролью Full Admin или root могут видеть все каналы. Если настройки видимости канала пусты, канал является общедоступным. Однако если канал определен для конкретных пользователей или отделов, его могут видеть только эти пользователи или сотрудники отделов.",
            searchTemplate: "Шаблон поиска...",
            forwardToChatbot: "Переслать чатботу",
            forwarding: "Переадресация (чатботу или живому агенту)",
            forwardLiveAgents: "👉 Переслать в службу поддержки",
            forwardingToDepartment: "Переадресация в отдел",
            selectDepartment: "Выбрать отдел",
            createWbChannel:
                "Чтобы создать канал Whatsapp Business, вы должны приобрести пакет Whatsapp Business. Вы можете получить доступ к доступным пакетам немедленно.",
            wbCreateChannelMax: "Вы достигли предела создания канала Whatsapp Business. Максимум",
            wbContinue:
                "Вы можете создать бизнес-канал Whatsapp. Чтобы продолжить, обновите свой пакет или удалите некоторые из ваших каналов Whatsapp Business.",
            chatInitiatorTemplate: "Шаблон инициатора чата",
            selectChatInitiatorTemplate: "Выберите шаблон инициатора чата",
            dailyUsageReport: "Отчет о ежедневном использовании",
            freeChat: "Бесплатный чат",
            paidChat: "Платный чат",
            templateMessage: "Сообщение шаблона",
            outgoingSession: "Исходящая сессия",
            incomingSession: "Предстоящая сессия",
            totalCost: "Общая стоимость",
            allOptNumbers: "Все номера, на которые вы подписались",
            startChat: "Начать чат",
            lastMessageDate: "Дата последнего сообщения",
            sureDeleteTemplate: "Вы уверены, что хотите удалить этот шаблон?",
            manageWhoChannelChat: "Управлять тем, кто может видеть чаты этого канала",
            profileImageDesc: "Это будет скриншот вашего бизнеса в WhatsApp",
            bussinesDesciption: "Описание бизнеса",
            descOfWork: "Описание вашего бизнеса в нескольких словах (не более 512 символов)",
            accountStatus: "Статус аккаунта",
            dockerStatus: "Статус докера",
            phoneQuality: "Качество телефона",
            customersOrDay: "CustomersDay",
            messagingLimit: "Лимит сообщений",
            canSendMessage: "Сообщение может быть отправлено",
            officialDetails: "Официальные данные",
            officialDetailsDesc:
                "Эти адреса всегда будут отображаться в разделе профиля для пользователей, которые общаются с вами в WhatsApp. После редактирования мы отправим его в WhatsApp для утверждения.",
            addressLine: "Адресная строка",
            stateIfApplic: "Штат (если применимо)",
            zipCodeOrPostCode: "Почтовый индекс/почтовый код",
            selectCountry: "Выберите страну",
            selectBussVertical: "Выберите район деятельности",
            saveInfo: "Сохранить информацию",
            active: "Активный",
            banned: "Запрещено",
            low: "Низкий",
            medium: "Средний",
            high: "Высокий",
            connected: "Подключен",
            disConnected: "Отключено",
            flagged: "Flagged",
            pending: "Отложенный",
            restricted: "Ограничено",
            unknown: "Неизвестно",
            available: "Доступный",
            limited: "Ограниченный",
            blocked: "Заблокировано",
            success: "Успех",
            succesDesc: "Информация о вашем профиле успешно обновлена",
            wabaOverview: "Обзор здоровья WABA",
            manageChannelDetail: "Управление информацией о вашем канале",
            wpBussChannelDetail: "Деталь бизнес-канала Whatsapp",
            manageWpBussChannel: "Управление бизнес-каналом Whatsapp",
            channelName: "Название канала",
            phoneNumberE164: "Номер телефона (формат E164)",
            phoneNumberE164Place: "Номер телефона (формат E164). например, 908501234455",
            channelUpdatedSucs: "Канал успешно обновлен",
            faieldUpdateChannel: "Не удалось обновить канал",
            title: "Каналы Whatsapp Business API",
            integration: "Интеграция",
            detail: "Детали",
            visibility: "Видимость",
            templates: "Все шаблоны сообщений",
            settings_group: "Настройки",
            template_message_group: "Шаблоны сообщений",
            chat_initiator_template: "Шаблон инициирования чата",
            contacts: "Контакты",
            numbers: "Числа",
            all_contacts: "Все контакты",
            new_template: "Создать новый шаблон",
            broadcast_group: "Рассылка",
            broadcast_requests: "Запросы на рассылку",
            customer_groups: "Группы клиентов",
            businessChannelDetail: "Детали канала Whatsapp Business",
            wallet: "Wallet",
            postacellMessage: "Отправить SMS",
            postacellAllMessage: "Отправить массовое SMS",
            message_group: "Сообщение",
            createNewTemplate: "Создать новый шаблон сообщения",
            templateName: "Имя шаблона",
            templateNameDesc: "Дайте имя вашему шаблону сообщения.",
            templateInfo: "Информация о шаблоне",
            viewTemplates: "Просмотреть шаблоны",
            templateNameRules: "Имя шаблона может включать только строчные буквы, цифры и подчеркивания.",
            category: "Категория",
            categoryDesc: "Выберите, какой тип шаблона вы хотите создать",
            categoryUtility: "Утилита",
            categoryUtilityDesc:
                "Отправляйте информацию об утилите, такую как обновления аккаунта, обновления заказа, оповещения и многое другое.",
            categoryMarketing: "Маркетинг",
            categoryMarketingDesc:
                "Отправляйте рекламные предложения, предложения по продукции и многое другое для увеличения осведомленности и вовлеченности.",
            categoryAuth: "Аутентификация",
            categoryAuthDesc: "Отправляйте коды для того, чтобы ваши клиенты могли получить доступ к своим аккаунтам.",
            optional: "По желанию",
            languageDesc: "Выберите язык, на котором будет отправлен ваш шаблонный текст",
            header: "Заголовок",
            headerRules:
                "Добавьте заголовок к вашему сообщению длиной 60 символов. В заголовке поддерживается только одна переменная.",
            headerOptionMedia: "Медиа",
            headerOptionText: "Текст",
            none: "Нет",
            headerType: "Тип заголовка",
            headerText: "Текст заголовка",
            body: "Тело",
            bodyRules: "Введите текст на выбранном вами языке для вашего сообщения",
            addVariable: "Добавить переменную",
            variables: "Переменные",
            variable: "Переменная",
            defaultVariableName: "Имя переменной по умолчанию",
            defaultVariableToolTip:
                "Ваша переменная появляется в шаблоне под этим именем. <br><br> Кроме того, это значение отправляется по умолчанию в случае других ситуаций.",
            selectATemplate: "Выберите шаблон сообщения",
            variableSettings: "Настройки переменных",
            example: "Пример",
            footer: "Нижний колонтитул",
            footerDesc:
                "Добавьте к вашему сообщению нижний колонтитул длиной 60 символов. В подвале не поддерживаются переменные.",
            buttons: "Кнопки",
            buttonType: "Тип кнопки",
            buttonTypeReply: "Ответить",
            submit: "Сохранить",
            submitting: "Подача заявки",
            addButton: "Добавить кнопку",
            rejectWhatsapp: "Отклонено WhatsApp.",
            approvedWhatsapp: "Одобрено WhatsApp.",
            pendingWhatsapp: "В ожидании одобрения",
            daily_usages: "Ежедневные расходы",
        },
        multi_whatsapp_api: {
            profile: "Профиль",
            integration: "Интеграция",
            detail: "Деталь",
            visibility: "Видимость",
            templates: "Все сообщения шаблона",
            settings_group: "Настройки",
            template_message_group: "Сообщения шаблона",
            new_template: "Создать новый шаблон",
            broadcast_group: "Массовые сообщения",
            broadcast_requests: "Массовые отправки сообщений",
            customer_groups: "Группы клиентов",
            chat_initiator_template: "Шаблон инициатора чата",
            contacts: "Контакты",
            numbers: "Номера",
            all_contacts: "Все контакты",
        },
        archive: {
            destroyedBy: {
                agent: "Агент",
                visitor: "Посетитель",
                system: "Система",
                chatbot: "Чатбот",
            },
        },
        upgradeMessages: {
            ticket: "Даже если вы оффлайн, ваши запросы моментально записываются с помощью искусственного интеллекта и чат-бота. Всегда поддерживайте своих клиентов довольными!",
            tasks: "Легко управляйте своими задачами и проектами. Сотрудничайте с вашей командой и сдавайте проекты вовремя!",
            calendar:
                "Легко планируйте свои встречи и собрания. Синхронизируйтесь с вашей командой и используйте свое время более эффективно!",
            mail_integration:
                "Легко управляйте своими электронными письмами. Усильте коммуникацию с вашими клиентами и улучшите сотрудничество!",
            team_integration:
                "Общайтесь быстрее и эффективнее с вашей командой. Улучшайте сотрудничество и обеспечьте своевременную сдачу проектов!",
            webhook_integration: "Соедините свои приложения с помощью интеграции Webhook и упростите обмен данными!",
            whatsapp_v2:
                "Улучшите общение с вашими клиентами через интеграцию WhatsApp для более быстрого и эффективного общения!",
            whatsapp:
                "Улучшите общение с вашими клиентами с помощью интеграции WhatsApp для более быстрого и эффективного общения!",
            whatsapp_business_api:
                "Используйте WhatsApp Business API для более эффективного и продуктивного общения с вашими клиентами!",
            instagram: "Взаимодействуйте с вашими клиентами более эффективно с помощью интеграции Instagram!",
            messenger: "Легко общайтесь с вашими клиентами через интеграцию Messenger!",
            sms_postacell: "Общайтесь быстро и эффективно с вашими клиентами через интеграцию SMS!",
            ready_contents: "Готовые материалы помогут вам общаться с вашими клиентами быстрее и эффективнее.",
            automation:
                "Автоматизируйте ваши рабочие процессы, чтобы сэкономить время и более эффективно управлять задачами!",
            form: "Используйте конструктор форм для упрощения взаимодействия с клиентами, сбора полезной информации и улучшения сотрудничества!",
            customer_tables: "Создавайте настраиваемые таблицы и эффективно управляйте информацией о клиентах!",
            trendyol: "Улучшите общение с вашими клиентами через интеграцию Trendyol для плавного взаимодействия!",
            access_control:
                "Защитите ваши данные и предотвратите несанкционированный доступ с помощью функций контроля доступа!",
            upgrade: "Обновить мою подписку",
            upgradeFeature: "Купить дополнительный пакет",
            featureNotAvailable: "Функция недоступна.",
            usageLimitExceeded: "Превышен лимит использования.",
            maxAgentCount: "Обновите свой пакет, чтобы добавить больше агентов и обслуживать больше клиентов.",
            maxTriggerCount: "Обновите свой пакет, чтобы добавить больше триггеров и увеличить взаимодействия.",
            visitorStartChat:
                "Обновите свой пакет, чтобы начать чат с посетителями, которые еще не взаимодействовали с вами.",
            voiceCalling:
                "Обновите свой пакет, чтобы более эффективно общаться с клиентами с помощью голосовых звонков.",
            videoCalling: "Обновите свой пакет, чтобы более эффективно общаться с клиентами с помощью видеозвонков.",
            fileAndVoiceMessage: "Обновите свой пакет, чтобы отправлять файлы и голосовые сообщения клиентам.",
            autoTranslation:
                "Обновите свой пакет, чтобы автоматически переводить сообщения и обслуживать больше клиентов.",
            telegramEntegration: "Обновите свой пакет, чтобы подключить интеграцию с Telegram.",
            chatCopilot:
                "Обновите свой пакет, чтобы использовать чат-ассистента с искусственным интеллектом для более эффективного обслуживания.",
            calenderEntegration: "Обновите свой пакет, чтобы синхронизировать календарь с другими приложениями.",
            mailEntegration:
                "Обновите свой пакет, чтобы эффективно управлять электронной почтой и улучшить коммуникацию с клиентами.",
            smsEntegration: "Обновите свой пакет, чтобы быстрее достигать клиентов с помощью SMS-интеграции.",
            ticketSystem:
                "Обновите свой пакет, чтобы более эффективно управлять запросами клиентов с помощью системы тикетов.",
            taskManagementEntegration:
                "Обновите свой пакет, чтобы улучшить рабочие процессы с помощью управления задачами.",
            webhookEntegration: "Обновите свой пакет, чтобы синхронизировать другие приложения через вебхуки.",
            readyContents: "Обновите свой пакет, чтобы улучшить общение с клиентами с помощью готового контента.",
            automationEntegration: "Обновите свой пакет, чтобы автоматизировать рабочие процессы.",
            customerTablesEntegration:
                "Обновите свой пакет, чтобы эффективно управлять данными клиентов с помощью таблиц.",
            formEntegration: "Обновите свой пакет, чтобы эффективно управлять запросами клиентов с помощью форм.",
            maxFormLimit: "Обновите свой пакет, чтобы создавать больше форм и управлять запросами клиентов.",
            maxFormFieldLimit:
                "Обновите свой пакет, чтобы добавлять больше полей в формы для лучшего управления запросами.",
            maxCustomerTableCount: "Обновите свой пакет, чтобы добавить больше таблиц клиентов.",
            maxCustomerTableFieldCount: "Обновите свой пакет, чтобы добавить больше полей в таблицы клиентов.",
            maxCustomerTableViewCount: "Обновите свой пакет, чтобы сохранить больше представлений таблиц клиентов.",
            maxCustomerTableRecordCount: "Обновите свой пакет, чтобы добавить больше записей в таблицы клиентов.",
            maxAutomationButton: "Обновите свой пакет, чтобы добавить больше блоков автоматизации.",
            automationTimerBase: "Обновите свой пакет, чтобы использовать таймеры автоматизации.",
            automationEventBase: "Обновите свой пакет, чтобы использовать события автоматизации.",
            automationWebhookBase: "Обновите свой пакет, чтобы использовать вебхуки автоматизации.",
            automationButtonBase: "Обновите свой пакет, чтобы использовать кнопки автоматизации.",
            liveScore: "Обновите свой пакет, чтобы активировать функцию мониторинга в реальном времени.",
            multipleChatWindow: "Обновите свой пакет, чтобы открывать несколько окон чата одновременно.",
            maxTaskWorkflowLimit: "Обновите свой пакет, чтобы добавить больше рабочих процессов задач.",
            maxTaskColumnLimit: "Обновите свой пакет, чтобы добавить больше столбцов задач.",
            maxTaskRowLimit: "Обновите свой пакет, чтобы добавить больше строк задач.",
            maxDepartmentLimit: "Обновите свой пакет, чтобы добавить больше отделов.",
            maxRoleLimit: "Обновите свой пакет, чтобы добавить больше ролей.",
            maxReadyContentsLimit: "Обновите свой пакет, чтобы добавить больше готового контента.",
            excelDownload: "Обновите свой пакет, чтобы активировать возможность скачивания Excel-файлов.",
            customerGroup: "Обновите свой пакет, чтобы использовать функцию групп клиентов.",
            maxMailCount: "Обновите свой пакет, чтобы отправлять больше писем.",
            maxWhatsappChannel: "Обновите свой пакет, чтобы добавить больше каналов WhatsApp.",
            maxBusinessWhatsappChannel: "Обновите свой пакет, чтобы добавить больше каналов WhatsApp Business.",
            maxInstagramChannel: "Обновите свой пакет, чтобы добавить больше каналов Instagram.",
            maxMessengerChannel: "Обновите свой пакет, чтобы добавить больше каналов Messenger.",
            maxTelegramChannel: "Обновите свой пакет, чтобы добавить больше каналов Telegram.",
            maxTrendyolChannel: "Обновите свой пакет, чтобы добавить больше каналов Trendyol.",
            maxMetaLeadChannel: "Обновите свой пакет, чтобы добавить больше каналов Meta Lead.",
        },
    },
};

export default messagesRU;
